import antd from 'ant-design-vue/lib/locale-provider/id_ID'
import validation from 'vee-validate/dist/locale/id.json'

const messages = {
  language: 'Bahasa',
  common: {
    back: 'Kembali',
    save_changes: 'Simpan Perubahan',
    email: 'Email',
    username: 'Username',
    page_not_found_msg: 'Maaf, halaman yang Anda kunjungi tidak ada.',
    cancel: 'Batal',
    close: 'Tutup',
    wait: 'Mohon tunggu...',
    ok: 'OK',
    no_data: 'Tidak ada data',
    save: 'Simpan',
    add: 'Tambah',
    submit: 'Submit',
    coming_soon: 'Segera Hadir',
    error_occurred: 'Terjadi kesalahan',
    total_items: 'Total {total} item',
    sku: 'SKU',
    name: 'Nama',
    quantity: 'Kuantitas',
    uom: 'UOM',
    description: 'Keterangan',
    time: 'Waktu',
    user: 'Pengguna',
    attachment: 'Lampiran',
  },
  pageTitles: {
    dashboardAdmin: 'Powerbiz - Dashboard Admin',
    shopeePromo: 'Powerbiz - Shopee Promo',
    addProductMaster: 'Powerbiz - Add Product Master',
    editProductMaster: 'Powerbiz - Edit Product Master',
    importProductMaster: 'Powerbiz - Import Product Master',
    stockAllocation: 'Powerbiz - Stock Allocation',
    bulkPublishProduct: 'Powerbiz - Bulk Publish Product Channel',
    addProductTokopedia: 'Powerbiz - Add Product Tokopedia',
    addProductChannel: 'Powerbiz - Add Product Channel',
    editProductChannel: 'Powerbiz - Edit Product Channel',
    priceSetting: 'Powerbiz - Price Setting',
    withdrawal: 'Powerbiz - Withdrawal',
    walletHistory: 'Powerbiz - Wallet History',
    walletWithdrawal: 'Powerbiz - Wallet Withdrawal',
    payment: 'Powerbiz - Payment',
    paymentHistory: 'Powerbiz - Payment History',
    invoice: 'Powerbiz - Invoice',
    creditNotes: 'Powerbiz - Credit Notes',
    productDiscount: 'Powerbiz - Product Discount',
    addDiscount: 'Powerbiz - Add Discount',
    voucher: 'Powerbiz - Voucher',
    addVoucher: 'Powerbiz - Add Voucher',
    approval: 'Powerbiz - Approval',
    customer: 'Powerbiz - Customer',
    formCustomer: 'Powerbiz - Form Customer',
    storeList: 'Powerbiz - Store List',
    addStore: 'Powerbiz - Add Store',
    confirmStore: 'Powerbiz - Confirm Store',
    integration: 'Powerbiz - Integration',
    integrationListChannel: 'Powerbiz - Integration List Channel',
    purchaseOrder: 'Powerbiz - Purchase Order',
    createPurchaseOrder: 'Powerbiz - Create Purchase Order',
    supplier: 'Powerbiz - Supplier',
    error404: 'Powerbiz - Error 404',
    error403: 'Powerbiz - Error 403',
    error500: 'Powerbiz - Error 500',
    linkExpired: 'Powerbiz - Link Expired',
    signIn: 'Powerbiz - Sign In',
    forgotPassword: 'Powerbiz - Forgot Password',
    resetPassword: 'Powerbiz - Reset Password',
    register: 'Powerbiz - Register',
    registerConfirmation: 'Powerbiz - Register Confirmation',
    registrationSuccess: 'Powerbiz - Registration Success',
    userConfirmInvitation: 'Powerbiz - User Confirm Invitation',
    ownerConfirmInvitation: 'Powerbiz - Owner Confirm Invitation',
    userNotFound: 'Powerbiz - User Not Found',
    timeout: 'Powerbiz - Timeout',
    fullViewLabel: 'Powerbiz - Full View Label',
    redeemProduct: 'Powerbiz - Redeem Product',
    addProductRedeem: 'Powerbiz - Add Product Redeem',
    editProductRedeem: 'Powerbiz - Edit Product Redeem',
    redeemSales: 'Powerbiz - Redeem Sales',
    distributor: 'Powerbiz - Distributor',
    addDistributor: 'Powerbiz - Add Distributor',
    submission: 'Powerbiz - Submission',
    retur: 'Powerbiz - Retur',
    banner: 'Powerbiz - Banner',
    cmsRedirectionTitle: 'Berhasil Dialihkan',
    cmsRedirectionSubTitle: 'Halaman CMS Management telah dibuka di tab baru. Jika tidak muncul, silakan klik tombol di bawah.',
    cmsRedirectionSubTitleRedirecting: 'Anda akan dialihkan ke halaman CMS Management pihak ketiga.',
    cmsRedirectionButton: 'Buka CMS Management',
    name: 'Nama',
  },
  topBar: {
    profileMenu: {
      name: 'Nama',
      email: 'Email',
      phone: 'Telepon',
      logout: 'Keluar',
      account_setting: 'Pengaturan Akun',
      switch_to: 'Beralih ke',
    },
    subscribeNow: 'Berlangganan',
    no_Business: 'Bisnis tidak ditemukan!',
    no_Warehouse: 'Gudang tidak ditemukan!',
    search_Business: 'Cari bisnis',
    search_Warehouse: 'Cari gudang',
    further_data: 'Cari data lebih lanjut.',
    total_Business: '{value} bisnis',
    total_Warehouse: '{value} gudang',
    all_: 'Semua',
    all_Business: 'Semua Bisnis',
    all_Warehouse: 'Semua Gudang',
    all_Channel: 'Semua Channel',
    all_SalesChannel: 'Semua Sales Channel',
    refresh: 'Segarkan',
  },

  snackBar: {
    notYetConnected: 'Akun anda belum tersambung dengan toko yang anda miliki',
    storeConnected: 'Akun anda tersambung dengan',
    store: 'Toko',
    ConnectToYourStore: 'Sambungkan ke Toko',
  },

  auth: {
    login: 'Masuk',
    register: 'Daftar',
    notRegister: 'Belum memiliki akun?',
    signupNow: 'Daftar Sekarang',
    empowering_title1: 'Memberdayakan',
    empowering_title2: 'Merek Anda',
    empowering_desc: 'Kami menawarkan solusi dan layanan menyeluruh untuk memberdayakan merek Anda, mengubah bisnis Anda, dan membawa produk Anda ke pasar global dengan Platform Teknologi Omni-Channel',
    schedule_demo: 'Jadwalkan demo',
    view_our: 'Lihat',
    terms: 'Syarat & Ketentuan',
    and: 'dan',
    privacy_policy: 'Kebijakan Privasi',
    emailPhoneLabel: 'Email atau No. Handphone',
    emailAndPhoneBlank: 'Email atau No Handpone tidak boleh kosong',
    password: 'Kata Sandi',
    invalidPassword: 'Kata Sandi Tidak Valid',
    confirmPassword: 'Konfirmasi Kata Sandi',
    forgetPassword: 'Lupa Kata Sandi?',
    resetPass: 'Atur ulang kata sandi',
    requiredEmail: 'Email Wajib diisi dengan Benar',
    goToSignIn: 'Ke Halaman Login',
    name: 'Nama',
    businessName: 'Nama Usaha',
    anotherRegister: ' Coba cara lain untuk Daftar ',
    anotherSign: ' Coba cara lain untuk Masuk ',
    passwordNotMatch: 'Konfirmasi kata sandi tidak sesuai',
    requiredName: 'Nama tidak boleh kosong',
    minimumLengthPassword: 'Kata sandi minimal 6 karakter',
    atLeastOneUppercase: 'Kata sandi minimal mempunyai 1 huruf kapital',
    atLeastOneNumber: 'Kata sandi minimal menpunyai 1 angka',
    atLeastOneSpecialChar: 'Kata sandi minimal mempunya 1 karakter spesial',
    verifyAccount: 'Harap lakukan verifikasi',
    sendOtpTo: 'Kami telah mengirimkan Kode OTP ke',
    resendOtp: 'Kirim ulang OTP',
    successVerification: 'Berhasil Terverifikasi',
    userNotRegistered: 'User Belum Terdaftar',
    goToDashboard: 'Lihat Dashboard',
    goToLogin: 'Kembali ke Login',
    needVerification: 'Harap lakukan verifikasi',
    changeEmail: 'Ubah Email',
    emailAddress: 'Alamat email',
    emailExpired: 'Ups, ada masalah dengan link Anda',
    expiredDescription:
      'Sepertinya link Anda telah kedaluwarsa atau tidak disalin dengan benar. Silahkan periksa dan coba lagi atau minta teman Anda untuk mengirimkan ulang undangan.',
    resendEmail: 'Kirim ulang email verifikasi ke:',
    resetMyPass: 'Atur Ulang Kata Sandi',
    sendAgain: 'Kirim ulang',
    invalidEmailPhoneNumber: 'Email atau nomer handphone tidak valid',
    successRegister: 'Registrasi Berhasil',
    loginFailed: 'Tidak Berhasil Masuk',
    hasAccount: 'Sudah memiliki akun?',
    loginHere: 'Masuk Disini',
    signUpWithGoogle: 'Daftar dengan akun Google',
    signUpWithFacebook: 'Daftar dengan akun Facebook',
    signInWithGoogle: 'Masuk dengan Google',
    signInWithFacebook: 'Masuk dengan Facebook',
    loading: 'Memuat',
    internalServerError: 'Terjadi Kesalahan Internal Server',
    changePassword: 'Ganti Kata Sandi',
    backToLogin: 'Kembali Ke Login',
    username: 'Username',
    phoneNumber: 'No. Handphone',
    emailInvalid: 'Email tidak valid',
    fieldRequired: '{0} wajib diisi',
    newPassword: 'Kata Sandi Baru',
    updatePassword: 'Perbarui Kata Sandi',
    resendCodeIn: 'Kirim ulang kode dalam',
    validate: 'Validasi',
    confirmationInvitation: 'Konfirmasi Undangan',
    hasAccountTrue: 'Sudah Punya Akun',
    hasAccountFalse: 'Belum Punya Akun',
    fullName: 'Nama Lengkap',
    pleaseLogoutFirst: 'Mohon Untuk Logout Terlebih Dahulu!',
    clickLinkAgain: 'Kemudian Klik Kembali Tautan Pada Email Untuk Konfirmasi.',
    creatingWorkspace: 'Sedang Membuat Workspace Anda',
    pleaseWait: 'Mohon Tunggu . . .',
    changePhoneNumber: 'Ubah Nomer Ponsel',
    passwordChangedSuccess: 'Kata Sandi Anda Berhasil diubah',
    loginToPowerBiz: 'Masuk Ke PowerBiz',
  },
  fulfillment: {
    sent: 'Terkirim',
    picked: 'Diambil',
    packed: 'Dikemas',
    shipped: 'Dikirim',
    readyToShip: 'Siap Kirim',
    printLabel: 'Cetak Label',
    print_label: 'Cetak Label',
    shippingId: 'ID Pengiriman',
    allWarehouses: 'Semua Gudang',
    closeDetail: 'Tutup Detail',
    viewDetail: 'Lihat Detail',
    changeAwb: 'Ubah No. Resi',
    inputAwb: 'Input No. Resi',
    enterAwb: 'Masukkan No. Resi',
    reviseDeliveryOrder: 'Revisi Delivery Order',
    orderNo: 'No Order',
    awbSaveFailed: 'Oops, No. Resi Gagal Disimpan',
    accept: 'Terima',
    cancel: 'Batalkan',
    allChannels: 'Semua Channel',
    allShippingTypes: 'Semua Tipe Pengiriman',
    startDate: 'Tanggal Awal',
    endDate: 'Tanggal Akhir',
    checkStock: 'Cek Stok Inventori',
    otherProducts: '+ {count} produk lainnya',
    showLess: 'Sembunyikan',
    shipping: 'Pengiriman',
    buyerAccepted: 'Buyer Sudah melakukan konfirmasi pesanan diterima',
    buyerNotAccepted: 'Buyer belum melakukan konfirmasi pesanan diterima',
    printOrderLabel: 'Print Label Pesanan',
    printLabelDesc: 'Cetak alamat pengiriman disertai dengan detail barang?',
    yesWithDetails: 'Ya, dengan detail barang',
    noAddressOnly: 'Tidak, hanya alamat saja',
    noSku: 'No SKU',
    inDelivery: 'Dalam Pengiriman',
    confirm: 'Konfirmasi',
    selectDateClosed: 'Pilih Tanggal Toko Tutup',
    updateStockInfo: 'Ubah informasi Stok Produk',
    reason: {
      productOutOfStock: 'Produk Habis',
      variantUnavailable: 'Varian Produk Tidak Tersedia',
      wrongPriceOrWeight: 'Salah Harga atau Berat',
      shopClosed: 'Toko Tutup',
      others: 'Lainnya',
      courierIssue: 'Kurir Bermasalah',
      buyerRequest: 'Permintaan Pembeli',
    },
    cancelDetailsMinLength: 'Rincian pembatalan minimal 30 karakter',
    enterDateClosed: 'Masukkan tanggal toko tutup',
    successCancelOrder: 'Berhasil membatalkan pesanan',
    min_char: 'min karakter',
    send: 'Kirim',
    reject_order: 'Tolak Pesanan',
    reason_cancel: 'Alasan Pembatalan',
    cancel_order: 'Batalkan Pesanan',
    separateShipment: 'Pengiriman Terpisah',
    cancelItem: 'Batalkan Item',
    changeItem: 'Ubah Item',
    submitToWms: 'Submit to WMS',
    status: 'Status',
    search: 'Cari',
    totalFulfillment: 'Total Order Pengiriman {value}',
    order_date: 'Tanggal Order',
    order_id: 'ID Order',
    business: 'Bisnis',
    channel: 'Channel',
    warehouse: 'Gudang',
    totalItem: 'Total Barang',
    all: 'Semua',
    new: 'Baru',
    do_process: 'Lakukan Proses',
    picking: 'Pengambilan',
    packing: 'Pengemasan',
    ready_to_ship: 'Siap Kirim',
    in_delivery: 'Dalam Pengiriman',
    delivered: 'Terkirim',
    canceled: 'Batal',
    check_do_data: 'Cek Data DO',
    booked: 'Booked',
    pending: 'Pending',
    oos: 'OOS',
    sla: 'SLA',
    booking_status: 'Status Booking',
    created_date: 'Tanggal Dibuat',
    store: 'Toko',
    bulk_accepted: 'Terima Masif',
    bulk_picking: 'Pilih Masif',
    bulk_packing: 'Packing Masif',
    bulk_good_issued: 'Siap Kirim Masif',
    bulk_shipped: 'Kirim Masif',
    bulk_delivered: 'Terkirim Masif',
    print_picking_list: 'Cetak Picking List',
    print_shipping_label: 'Cetak Shipping Label',
    cancel_bulk_actions: 'Batal Aksi Masif',
    separate_shipment: 'Pengiriman Terpisah',
    return_requested: 'Req Retur',
    returned: 'Retur',
    cancel_requested: 'Request Pembatalan',
    select_order_to_be: 'Pilih order yang ingin {action}',
    bulk_accepted_msg: 'diterima',
    bulk_picking_msg: 'diambil',
    bulk_packing_msg: 'dikemas',
    bulk_good_issued_msg: 'siap kirim',
    bulk_shipped_msg: 'dikirim',
    bulk_delivered_msg: 'terkirim',
    processed: 'diproses',
    submit_to_wms_msg: 'dikirim ke wms',
    bulk_actions_no_eligible: 'Tidak ada order yang memenuhi syarat untuk proses bulk actions',
    printed_msg: 'dicetak',
    bulk_title: 'Masif {action}',
    created: 'Baru',
    process: 'Lakukan Proses',
    cancelRequested: 'Request Pembatalan',
    canceled: 'Batal',
    submitSuccess: 'Submit Berhasil',
    submitSuccessDesc: 'Apabila data fulfillment belum berubah, mohon tunggu beberapa saat dan refresh ulang data fulfillment',
    submitFailed: 'Submit Gagal',
    submitFailedDesc: 'Mohon hubungi Admin terkait kendala Submit to WMS',
    stockAmount: 'Jumlah Stok',
    done: 'Selesai',
    reload: 'Reload',
    save: 'Simpan',
    back: 'Kembali',
    addProduct: 'Tambah Produk',
    searchItem: 'Cari Item',
    changeQty: 'Ubah Qty',
    addItem: 'Tambah Item',
    logistic: 'Logistik',
    separatedQty: 'Qty Terpisah',
    sender: 'Pengirim',
    recipient: 'Penerima',
    orderDate: 'Tanggal Order',
    shippingCost: 'Ongkos Kirim',
    insuranceCost: 'Biaya Asuransi',
    note: 'Catatan',
    product: 'Produk',
    quantity: 'Jumlah',
    printWithShippingId: 'Cetak dengan ID Pengiriman',
    confirmChange: 'Apakah anda yakin akan melakukan perubahan ini?',
    confirmCancelItemOrder: 'Pembatalan item ini akan menyebabkan order dibatalkan, Apakah Anda yakin akan batalkan item berikut?',
    confirmCancelOrder: 'Apakah Anda yakin akan batalkan pesanan berikut?',
    confirmChangeQty: 'Apakah Anda yakin akan ubah kuantitas item pesanan berikut?',
    initial_shipment: 'Pengiriman Awal',
    product_canceled: 'Produk Yang Dibatalkan',
    yesCancelItem: 'Ya, Batalkan Item',
    yesChangeQty: 'Ya, Ubah Kuantitas',
    successUpdateOrder: 'Berhasil memperbarui pesanan',
    noAccess: 'Anda tidak memiliki akses untuk fitur ini',
    inventoryBooking: 'Inventori Booking',
    next: 'Selanjutnya',
    historyList: 'Daftar Riwayat',
    filter: 'Filter',
    failed: 'Gagal',
    tryAgain: 'Coba Lagi',
    completed: 'Selesai',
    shipping_id: 'ID Pengiriman',
    warehouse: 'Gudang',

    accept_msg: 'Apakah Anda yakin akan terima pesanan berikut?',
    reject_msg: 'Apakah Anda yakin akan membatalkan pesanan berikut?',
    pick_confirmed_msg: 'Apakah Anda yakin akan mengambil pesanan berikut?',
    pack_confirmed_msg: 'Apakah Anda yakin akan mengemas pesanan berikut?',
    packing_completed_msg: 'Apakah Anda yakin akan mengirimkan pesanan berikut?',
    good_issued_msg: 'Apakah Anda yakin pesanan sudah siap dikirim?',
    shipped_msg: 'Apakah Anda yakin pesanan sudah terkirim?',
    accept_order: 'Ya, Terima Pesanan',
    reject_order: 'Ya, Batalkan Pesanan',
    btn_caption_accept_pick_confirmed: 'Ya, ambil pesanan',
    btn_caption_accept_pack_confirmed: 'Ya, kemas pesanan',
    btn_caption_packing_completed: 'Ya, kirimkan pesanan',
    btn_caption_good_issued: 'Ya, Pesanan siap dikirim',
    btn_caption_shipped: 'Ya, Pesanan terkirim',
    description: 'Deskripsi',
    order_list: 'Daftar Order',
    setting_label: 'Pengaturan Label Pengiriman',
    sub_total_order: 'Sub Total Pesanan',
    paper_size: 'Ukuran Kertas',
    print_details: 'Cetak dengan detail barang',
    print_all_details: 'Cetak semua dengan detail barang',
    print_unboxing_video_label: 'Cetak dengan label wajib video unboxing',
    print_all_unboxing_video_label: 'Cetak semua dengan label wajib video unboxing',
    print_barcode_awb: 'Cetak dengan barcode awb',
    print_all_barcode_awb: 'Cetak semua dengan barcode awb',
    print_barcode_no_order: 'Cetak dengan barcode nomor order',
    print_all_barcode_no_order: 'Cetak semua dengan barcode nomor order',
    packing_completed: 'Dikirim',
    inventory_status: 'Status Inventori',
    didntHaveData: 'Belum Memiliki Data',
    didntHaveDataCaption: 'Saat ini anda \n belum memiliki data',
    exportExcelFile: 'Export Excel File',
    exportHistoryPage: 'Halaman Riwayat Export',
    captionNotifFilterBeforeExport: 'Lakukan Filter sebelum melakukan export \n dengan jangka waktu maksimal 3 bulan',
    created_date: 'Tgl. Buat',
    service_type: 'Prioritas',
    store: 'Nama Toko',
    inventory: 'Inventory',
    notification_success_accept_order: 'Success accept order',
    notification_success_update_order: 'Success update order',
    changeOrder: 'Ubah Pesanan',
    itemProduct: 'Item Produk',
    splitShipment: 'Pengiriman Terpisah',
    backToChangeOrder: 'Kembali Ubah Pesanan',
    booking_inventory: 'Inventory Booking',
    sla: 'SLA',
    bulk_accepted: 'Terima Massal',
    bulk_picking: 'Ambil Massal',
    bulk_packing: 'Kemas Massal',
    bulk_good_issued: 'Keluarkan Barang Massal',
    bulk_shipped: 'Kirim Massal',
    bulk_delivered: 'Terkirim Massal',
    print_picking_list: 'Cetak Daftar Pengambilan',
    print_shipping_label: 'Cetak Label Pengiriman',
    cancel_bulk_actions: 'Batalkan Aksi Massal',
    export_modal: {
      title: 'Export Data',
      do_status: 'Status Delivery Order',
      select_do_status: 'Pilih Status Delivery Order',
      inventory_status: 'Status Inventory',
      select_inventory_status: 'Pilih Status Inventory',
      warehouse: 'Gudang',
      select_warehouse: 'Pilih Gudang',
      channel: 'Channel',
      select_channel: 'Pilih Channel',
      shipping_type: 'Prioritas',
      select_shipping_type: 'Pilih Prioritas',
      order_date: 'Tanggal Order',
      start_date: 'Tanggal Awal',
      end_date: 'Tanggal Akhir',
      close: 'Tutup',
      export_data: 'Export Data',
      all: 'Semua',
      booked: 'Booked',
      pending: 'Pending',
      oos: 'OOS',
    },
    detailDeliveryOrder: 'Detail Delivery Order',
    detailItemProduct: 'Detail Item Produk',
    skuNotFoundWarehouse: 'SKU tidak ada pada gudang yang anda pilih, mohon tambahkan gudang terlebih dahulu untuk SKU tersebut',
    skuRequired: 'SKU harus dipilih',
    qtyRequired: 'Qty harus diisi',
    qtyCannotBeZero: 'Qty tidak boleh 0',
    confirmDeleteItem: 'Apakah Anda yakin ingin menghapus SKU: {sku} ?',
    cannotDeleteLastItem: 'Tidak bisa menghapus item terakhir',
    detailItemProductEmpty: 'Detail Item Produk tidak boleh kosong',
    skuNotInSelectedWarehouse: 'SKU {skus} tidak ada di gudang yang dipilih',
    revisionSavedSuccess: 'Data Revisi Berhasil di Simpan',
    revisionSavedFailed: 'Data Revisi Gagal di Simpan',
    searchSku: 'Cari SKU',
    stock: 'Stok',
    noData: 'Tidak Ada Data',
    printSlip: 'Cetak Slip',
    selectReferenceItem: 'Pilih Referensi Item',
    selectReferenceItemDesc: 'Pilih item order asli yang akan dijadikan referensi untuk item baru.',
    referenceItem: 'Referensi',
    hasZeroStockItem: 'Terdapat item dengan stok kosong',
    confirmRevisionDoTitle: 'Konfirmasi Revisi Delivery Order',
    confirmRevisionDoDesc: 'Terdapat produk dengan ketersediaan ',
    zeroStockStatus: 'stok kosong (0)',
    confirmRevisionDoQuestion: 'Apakah Anda yakin ingin tetap melanjutkan revisi ini?',
    continueRevision: 'Lanjutkan Revisi',
    update_package: 'Update Package',
    update_package_success: 'Update Package berhasil',
    update_package_failed: 'Update Package gagal',
    priority_level: 'Prioritas',
  },
  authForm: {
    systemBusy: 'System sibuk, cobalah beberapa saat lagi atau kontak administrator!',
  },
  notification: {
    successAddDiscount: 'Add Discount Voucher Success',
    successDeleteVoucher: 'Delete Voucher Success',
    duplicateVoucherCode: 'Voucher code already exist',
    failedSearchSalesOrder: 'Please select parameter for search sales order',
    failedSearchVoucher: 'Please select parameter for search voucher',
  },
  sideBar: {
    dashboard: 'Beranda',
    sales: 'Pesanan',
    fulfillment: 'Fulfillment',
    product: 'Produk',
    product_master: 'Produk Utama',
    productCategory: 'Kategori Produk',
    management_category: 'Manajemen Kategori',
    price_setting: 'Setting Harga',
    global_variable: 'Variabel Global',
    formula_variable: 'Variabel Formula',
    product_variable: 'Variabel Produk',
    price_formula: 'Formula Harga',
    inventory: 'Inventori',
    stock: 'Persediaan',
    stock_alocation: 'Alokasi Stok',
    inventory_list: 'Daftar Persediaan',
    inventory_movement: 'Riwayat Persediaan',
    setup_stock: 'Pengaturan Stok',
    transfer_stock: 'Transfer Stok',
    promotion: 'Promosi',
    customer: 'Pelanggan',
    channel: 'Saluran',
    analytic: 'Analitik',
    finance: 'Finansial',
    user: 'Pengguna',
    account: 'Akun',
    user_management: 'Manajemen Pengguna',
    setting: 'Pengaturan',
    integration: 'Integrasi',
    business: 'Bisnis',

    warehouse: 'Gudang',
    shipping: 'Pengiriman',
    customer_setting: 'Pelanggan',
    sales_setting: 'Pengaturan Pesanan',
    account_setting: 'Pengaturan Akun',
    distributorship: 'Distributorship',
    sales_order: 'Daftar Pesanan',
    product_list: 'Daftar Produk',
    distributorship_management: 'Kelola Distributor',
    store_management: 'Manajemen Toko',
    store_setting: 'Pengaturan Toko',
    price_group_setting: 'Atur Grup Harga',
    export_history: 'Riwayat Ekspor',
    price: 'Pengaturan Harga',
    add_store: 'Tambah Toko',
    add_warehouse: 'Tambah Gudang',
    type_shop_name: 'Ketik nama toko',
    type_warehouse_name: 'Ketik Nama Gudang',
    no_shop: 'Belum ada list toko!',
    reseller: 'Reseller',
    resellerdetail: 'Detail Reseller',
    voucher: 'Voucher',
    voucherdetail: 'Detail Voucher',
    addvoucher: 'Tambah Voucher',
    editvoucher: 'Edit Voucher',
    storesetting: 'Store Settings',
    adjustment: 'Penyesuaian Stok',
    'goods-receipt': 'Penerimaan Barang',
    'return-received': 'Pengembalian Barang',
    'inventory movement': 'Riwayat Persediaan',
    promo_channel_list: 'Atur Promo Diskon',

    distributor: 'Distributor',
    distributor_list: 'Daftar Distributor',
    customer_category: 'Kategori Pelanggan',
    discount: 'Diskon',
    approval: 'Approval',
    withdrawal: 'Request Penarikan Dana',
    payment_channel: 'List Bukti Transfer',
    payment_history: 'Riwayat Pembayaran',
    invoice: 'Invoice',
    retur: 'Retur',
    'retur-request-list': 'List Pengajuan Retur',
    'retur-list': 'Retur List',
    web_management: 'Web Management',
    banner: 'Banner',
    redeem: 'Loyalty',
    redeem_sales_channel: 'Redeem',
    redeem_product_channel: 'Produk',
    liststore: 'Daftar Toko',
    product_collection: 'Produk Pilihan',

    'credit-notes': 'Credit Notes',
    'customer-list': 'Daftar Pelanggan',
    'price-area': 'Harga per Area',
    'product-list': 'Daftar Produk',
    do: 'Delivery Order',
    po_and_supplier: 'Pembelian',
    purchase_order: 'Inbound Delivery',
    supplier: 'Atur Supplier',
    'setup-product-tags': 'Atur Tag Produk',
    'manage-product-tags': 'Manajemen Tag Produk',
  },
  settingsStore: {
    logo: 'Logo',
    banner: 'Banner Beranda',
    categoryBanner: 'Banner Kategori',
    resellerBanner: 'Banner Reseller',
    uploadImage: 'Unggah Gambar',
    title: 'Pengaturan Toko',
    delete_confirm: 'Apakah Anda yakin ingin menghapus item ini?',
    image_type: 'Tipe Gambar',
    select_image_type: 'Pilih Tipe Gambar',
    choose_image: 'Pilih gambar',
    upload: 'Unggah',
    dimension_uploaded: 'Dimensi foto yang Anda unggah adalah: {value}',
    dimension_recomended: 'dimensi yang disarankan untuk {name} adalah: {value}',
    redirect_url: 'URL Pengalihan',
    optional: 'opsional',
    error_max_banner: 'Jumlah maksimal banner yang bisa diupload adalah 10',
    failed: 'Gagal',
  },
  dashboardContent: {
    detail_link: 'Detail',
    total_sku: 'Total SKU',
    order: 'Pemesanan',
    orderStatus: 'Status Pesanan',
    orderStatusDescription:
      'Ringkasan status pesanan saat ini yang perlu ditindaklanjuti',
    orderStatusNew: 'Baru',
    orderStatusConfirmed: 'Terkonfirmasi',
    orderStatusSent: 'Terkirim',
    orderStatusSuccess: 'Berhasil',
    orderStatusCancel: 'Batal',
    summaryItemInventory: 'Inventory',
    summaryBusiness: 'Bisnis',
    summaryClient: 'Klien',
    summaryPO: 'PO Tertunda',
    summaryItemNoStock: 'Stok Habis',
    summarySalesToday: 'Penjualan Hari Ini',
    summaryLogisticToday: 'Logistik Keluar Hari Ini',
    summaryItemSoldToday: 'Item Terjual Hari Ini',
    summarySales: 'Penjualan',
    summaryLogistic: 'Logistik Keluar',
    summaryItemSold: 'Item Terjual',
    paramToday: 'Hari Ini',
    paramLast7day: '7 Hari Terakhir',
    paramLast30day: '30 Hari Terakhir',
    paramThisMonth: 'Bulan Ini',
    paramLastYear: '1 Tahun Terakhir',
    paramThisYear: 'Tahun Ini',
    salesOverview: 'Ikhtisar Penjualan',
    section_description_inventory: 'Total item di Inventory dari Semua Brand',
    section_description_business: 'Total item di Bisnis dari Semua Saluran',
    section_description_client: 'Klien-klien yang bekerjasama',
    section_description_PO: 'Total item di PO Tertunda',
    section_description_nostock: 'Total item Stok Kosong',
    section_description_salesToday: 'Total Penjualan hari ini',
    section_description_logisticToday: 'Total item di Logistik Keluar hari ini',
    section_description_itemsoldToday: 'Total item Terjual hari ini',
    section_description_sales: 'Total item dalam Penjualan',
    section_description_logistic: 'Total item di Logistik Keluar',
    section_description_itemsold: 'Total item Terjual',
    top_region: 'Penjualan Tertinggi',
    top_region_description: '10 Daerah Teratas dengan Penjualan Terbanyak',
    shipping: 'Pengiriman',
    shipping_description: '10 Kurir Pengiriman Teratas',
    channel: 'Channel',
    sales_channel: 'Sales Channel',
    info_channel: 'List 10 channel teratas',
    info_sales_channel: 'List 10 sales channel teratas',
    info_business: 'List 10 bisnis teratas',
    info_warehouse: 'List 10 gudang teratas',
    info_courier: 'List 10 kurir teratas',
    info_payment_method: 'List 10 metode pembayaran teratas',
    channel_description: 'Ringkasan Channel',
    business: 'Bisnis',
    business_description: 'Ringkasan Bisnis',
    warehouse: 'Gudang',
    courier: 'Logistik',
    payment: 'Pembayaran',
    payment_method: 'Metode Pembayaran',
    payment_description: 'Ringkasan Pembayaran',
    no_data: 'Tidak ada data',
    start_date: 'Tanggal Mulai',
    end_date: 'Tanggal Akhir',
    today: 'Hari ini',
    is_today: 'hari ini',
    not_today: '',
    today_month: 'Bulan ini',
    today_year: 'Tahun ini',
    last_week: '7 Hari Terakhir',
    last_month: '30 Hari Terakhir',
    last_year: '1 Tahun Terakhir',
    transaction_status: 'Status Transaksi',
    detail_status: 'Ringkasan status transaksi delivery order sampai hari ini yang perlu di tindaklanjuti',
    today_summary: 'Ringkasan Hari Ini',
    sales: 'Penjualan',
    logistic: 'Logistik',
    logistic_expenses: 'Pengeluaran Logistik',
    item_sold: 'Item Terjual',
    report: 'Laporan',
    date_difference: 'Tanggal akhir min. 7 hari dari tanggal awal',
    sales_overview_graph: 'Grafik Ikhtisar Penjualan',
    compare: 'Bandingkan',
    detail_channel: 'List 10 channel teratas berdasarkan transaksi',
    province: 'Provinsi',
    detail_province: 'List 10 provinsi teratas berdasarkan jumlah order',
    city: 'Kota / Kabupaten',
    detail_city: 'List 10 kota / kabupaten teratas berdasarkan jumlah order',
    product: 'Produk Terlaris',
    detail_product: 'List 10 produk teratas berdasarkan qty',
    catalog: 'Item Terlaris',
    detail_catalog: 'List 10 item teratas berdasarkan qty',
    shopee_id: 'Shopee',
    tokopedia_id: 'Tokopedia',
    tiktok: 'Tiktok',
    tiktok_id: 'Tiktok',
    blibli_id: 'Blibli',
    lazada_id: 'Lazada',
    toco_id: 'Toco',
    distributor: 'Distributorship',
    store: 'Webcommerce',
    total: {
      sku: 'Total item dalam gudang',
      oos: 'Total item kosong dalam gudang',
      sales: 'Total',
      canceled_sales: 'Total dibatalkan',
      logistic_expenses: 'Total biaya pengiriman',
      item_sold: 'Total item terjual',
    },
  },
  sales: {
    sync_order: 'Sinkronisasi Pesanan',
    resend_sfa: 'Kirim Ulang SFA',
    detail_sfa: 'Detail SFA',
    awb_status: 'Status Pengiriman AWB',
    delivery_data_not_found: 'Data Pengiriman Tidak Ditemukan',
    delivery_data_not_found_msg: 'Mohon untuk mencoba beberapa saat lagi atau silahkan hubungi Admin terkait kendala data pengiriman',
    channel: 'Channel',
    seller: 'Penjual',
    status: 'Status',
    delivery_status: 'Status Pengiriman',
    shipping_status: 'Status Pengapalan',
    waiting: 'Menunggu',
    picking: 'Pengambilan',
    packing: 'Pengemasan',
    ready_to_ship: 'Siap Dikirim',
    on_delivery: 'Pengiriman',
    delivered: 'Terkirim',
    completed: 'Selesai',
    track: 'Lacak',
    canceled_by_buyer: 'Dibatalkan oleh pembeli',
    canceled_by_seller: 'Dibatalkan oleh penjual',
    system_cancellation: 'Pembatalan oleh sistem',
    no_history_data: 'Tidak ada data history',
    date_from: 'Periode',
    business_id_sales: 'Bisnis',
    sales_channel_id: 'Channel',
    warehouse_id: 'Gudang',
    customer_name: 'Nama Pelanggan',
    courier_name: 'Nama Kurir',
    unmapped_products_warning: 'Order ini terdapat produk yang belum ter-mapping',
    instant_courier_info: 'Order ini menggunakan kurir instan',
    order_type: 'Tipe Pesanan',
    priority_level: 'Prioritas',
  },
  manualOrder: {
    create_title: 'Formulir Buat Pesanan Manual',
    transaction_detail: 'Data Detail Transaksi',
    buyer_data: 'Data Pembeli',
    cart_title: 'Keranjang Transaksi',
    shipping_data: 'Data Pengiriman',
    billing_data: 'Data Penagihan',
    transaction_summary: 'Rincian Transaksi',
    order_number: 'Nomor Pesanan',
    input_order_number: 'Masukan nomor pesanan',
    warehouse: 'Gudang',
    date: 'Tanggal',
    input_date: 'Masukan tanggal pesanan',
    payment_method: 'Metode Pembayaran',
    payment_status_placeholder: 'Sudah Lunas / Belum Lunas',
    first_name: 'Nama Depan',
    last_name: 'Nama Belakang',
    attachment_url: 'URL Lampiran',
    input_first_name: 'Masukan nama depan',
    input_last_name: 'Masukan nama belakang',
    input_email: 'Masukan email',
    input_phone: 'Masukan no telp',
    input_attachment_url: 'Masukan url lampiran',
    add_item: 'Tambah Item',
    bulk_item_import: 'Bulk Item Import',
    no_product_in_warehouse: 'Tidak ada produk terdaftar di gudang yg anda pilih',
    product_placeholder: 'Produk',
    stock_unavailable: 'Stok tidak tersedia',
    all_products_loaded: 'Semua produk telah dimuat',
    msrp: 'MSRP',
    sub_total: 'Sub Total',
    sub_total_cart: 'Sub Total Keranjang',
    shipping_type: 'Pilih Jenis Pengiriman',
    courier: 'Kurir',
    self_pickup: 'Ambil Sendiri',
    courier_type: 'Pilih Jenis Kurir',
    custom_courier: 'Kurir Pilihan Sendiri',
    integrated_courier: 'Kurir Terintegrasi Sistem',
    integrated_courier_tooltip: 'Nomor AWB, biaya pengiriman, dan biaya asuransi pengiriman diisikan otomatis oleh sistem.',
    custom_courier_tooltip: 'Anda dapat mengisi nomor AWB, biaya pengiriman, dan biaya asuransi pengiriman secara bebas (custom).',
    courier_service: 'Layanan Kurir',
    choose_courier: 'Pilih kurir',
    choose_service: 'Pilih layanan',
    awb_number: 'No. Resi (AWB)',
    input_awb: 'Masukan nomor resi',
    courier_not_available: 'Mohon maaf, kurir tidak tersedia untuk alamat pengiriman yang anda pilih',
    street_name: 'Nama Jalan',
    use_shipping_address: 'Gunakan alamat pengiriman untuk alamat penagihan',
    discount: 'Diskon',
    shipping_cost: 'Biaya Pengiriman',
    insurance_cost: 'Asuransi Pengiriman',
    grand_total: 'GRAND TOTAL',
    create_single_order: 'Buat Pesanan Satuan',
    create_bulk_order: 'Buat Pesanan Massal',
    import_export: 'Ekspor / Impor',
    import_manual_order: 'Impor Pesanan Manual',
    verify_file: 'Verifikasi File',
    upload_file: 'Upload File',
    upload_bulk_manual_order: 'Upload Bulk Pesanan Manual',
    verify_failed: 'Verifikasi Gagal',
    verify_success: 'Verifikasi Berhasil',
    empty_data: 'Data Kosong',
    empty_data_msg: 'Mohon untuk mengisi data minimal 1 row untuk dapat melakukan proses Bulk Order.',
    verified_msg: 'Semua data telah lolos verifikasi.',
    verified_action_msg: 'Silahkan klik tombol <b>Upload File</b> untuk melakukan proses Bulk Order.',
    failed_lines_msg: 'Terdapat <b>{count}</b> baris data yg tidak lolos verifikasi.',
    fix_data_msg: 'Mohon untuk perbaiki data tersebut agar dapat melakukan proses Bulk Order.',
    check_remark_msg: 'NB: Cek kolom <b>Keterangan</b> (kolom terakhir)',
    download_failed_data: 'Download Data Gagal',
    upload_attachment: 'Upload Lampiran',
    gen_own_label: 'Gen Own Label',
    url: 'URL',
    input_label_url: 'Masukan label url',
    invalid_url_alert: 'URL yang anda masukan <b>tidak valid</b>, anda dapat <b>mengosongkan</b> label url jika tidak memiliki url shipping label',
    valid_url_example: 'Contoh URL yang valid:',
    please_choose_city: 'Harap Pilih Kota',
    shipping_warehouse_warning: 'Harap isi terlebih dahulu alamat pengiriman & gudang sebelum mengisi form kurir',
    warehouse_product_warning: 'Harap pilih gudang sebelum menambahkan produk',
    weight_change_calculating: 'Terdapat perubahan total berat produk, sedang menghitung ulang biaya pengiriman.',
    max_char_warning: 'Maksimal {max} karakter',
    select_payment_method: 'Pilih metode pembayaran',
    select_order_date: 'Pilih tanggal order',
    select_country: 'Pilih negara',
    select_city: 'Pilih kota',
    select_district: 'Pilih kecamatan',
    input_postcode: 'Masukan kode pos',
    input_address: 'Masukan alamat',
    select_warehouse: 'Pilih gudang',
    select_courier: 'Pilih kurir',
    select_courier_service: 'Pilih layanan kurir',
    fail_create_order: 'Gagal membuat order',
    input_valid_url: 'Harap masukkan url shipping label yang valid',
    add_item_min_1: 'Harap tambahkan item minimal 1',
    item_not_filled: 'Terdapat item yang belum diisi',
    some_data_invalid: 'Beberapa data tidak valid',
    all_data_imported: 'Semua Data Berhasil di Import',
    error_get_store_id: 'Gagal mendapatkankan store id',
    error_occurred: 'Terjadi kesalahan',
    success_update_shipping_cost: 'Berhasil mengupdate biaya pengiriman',
    error_calculating_shipping_cost: 'Terjadi kesalahan saat menghitung biaya pengiriman',
    check_qty_warning: 'Mohon cek kembali quantity produk, quantity tidak boleh 0',
    check_uom_warning: 'Mohon cek kembali UOM produk, UOM tidak boleh kosong',
    success_create_order: 'Berhasil membuat order',
    order_number_label: 'nomor order',
    max_item_warning: 'Jumlah item melebihi batas maksimal, batas maksimal adalah {max} item',
    error_add_item: 'Gagal menambahkan item',
    import_items: 'Impor Item',
    selling_price: 'Harga Jual',
    product_discount: 'Diskon Produk',
    qty: 'Qty',
    total: 'Total',
    upload_excel_msg: 'Upload file excel anda disini',
    manage_edit_product: 'Kelola / Edit Produk',
    add_product: 'Tambah Produk',
    cancel_confirm_title: 'Batalkan Pembuatan Pesanan?',
    cancel_confirm_content: 'Semua data yang telah dimasukkan belum disimpan dan akan hilang.',
    yes_cancel: 'Ya, Batalkan',
    back: 'Kembali',
    delete_cart_confirm: 'Hapus produk ini dari keranjang?',
    no_product_in_cart: 'Belum ada produk di keranjang',
    product_in_cart: 'Produk di keranjang',
    view_detail_table: 'Lihat Detail Table',
    show_list: 'Tampilkan List',
    hide_list: 'Sembunyikan List',
    product_summary: 'Ringkasan Produk',
    done: 'Selesai',
    template_hint: 'Jika belum memiliki template file import items, silahkan klik tombol download file di kiri bawah.',
    download_template: 'Download Template',
    submit_all_items: 'Submit All Items',
    uploading_file: 'Sedang mengunggah file...',
    success_item: 'Item yang berhasil:',
    failed_item: 'Item yang gagal:',
  },
  add_store: {
    channel_integration: 'Integrasi Saluran',
    mandatory_selected_warehouse:
      'Pastikan Anda sudah memilih gudang, kemudian pilih saluran untuk di integrasikan ke toko Anda',
    marketplace_integration: 'Integrasi Marketplace',
    fulfillment_integration: 'Integrasi Fulfilment',
    coming_soon: 'Segera',
    sync_tips: 'Tips Sinkronisasi',
    note_tips:
      'Ketika mulai sinkronisasi Anda akan diarahkan ke halaman {name} untuk login dan otorisasi. Setelah otorisasi berhasil Anda dapat mengatur jasa pengiriman di Pengaturan Jasa Pengiriman Powerbiz.',
    loading_integration: 'Sedang melakukan integrasi, harap menunggu.',
    integration_failed_title: 'Integrasi Tidak Dapat Dilakukan.',
    integration_failed_warehouse: 'Harap untuk menginput Data Gudang Anda terlebih dahulu',
    input_warehouse_btn: 'Input Data Gudang',
    shopee_integration_failed: 'Integrasi Shopee Gagal',
    tiktok_integration_failed: 'Integrasi Tiktok Gagal',
    lazada_integration_failed: 'Integrasi Lazada Gagal',
    toco_integration_failed: 'Integrasi Toco Gagal',
    errors: {
      select_business_first: 'harap pilih bisnis terlebih dahulu, sebelum melakukan integrasi toko',
      failed: 'Gagal',
      redirect_failed: 'Redirect Failed',
      connected_failed: 'Connected Failed',
      blibli_integration_failed: 'Integrasi Blibli Gagal',
      store_required: 'Toko harus dipilih',
      warehouse_required: 'Gudang harus dipilih',
      shop_already_exist_business_id: 'Toko ini sudah terdaftar di ID Bisnis yang berbeda.',
      invalid_auth_code: 'Kode otorisasi telah kedaluwarsa atau tidak valid. Silakan coba hubungkan kembali toko Anda.',
      marketplace: 'Marketplace',
      warehouse: 'Warehouse',
    },
    blibli_sync: {
      how_to_get_title: 'Bagaimana Anda Mendapatkan Nama, ID & Kata Sandi Toko Anda ?',
      step_1: 'Langkah ke 1',
      step_1_desc_1: 'Salin API Client ID Powerbiz berikut :',
      step_1_desc_2: 'Masuk ke Seller Center Blibli Anda',
      step_1_desc_3: 'Klik menu Seller API Manager pada bagian profile toko Anda',
      step_1_desc_4: 'Pada bagian bawah terdapat bagian <b>Bind API Client</b>',
      step_1_desc_5: 'Salin Kode <b>API Client ID</b> pada kolom yang tersedia',
      step_1_desc_6: 'Lalu klik tombol <b>BIND</b> lalu klik tombol <b>YES</b> jika diminta',
      step_2: 'Langkah ke 2',
      step_2_desc_1: 'Pada bagian <b>Manage API Key</b> klik tombol <b>Generate</b>',
      step_2_desc_2: 'Catat nilai <b>API Seller Key</b> yang muncul dan <b>Store Code</b> Anda',
      step_2_desc_3: 'Salin pada kolom yang telah disediakan di form ini',
      step_2_desc_4: 'Langkah selanjutnya klik tombol <b>Mulai Integrasi</b>',
      step_2_desc_5: 'Terakhir Anda diminta memilih Gudang Powerbiz dan channel Anda agar terhubung',
      step_2_desc_6: 'Jika sudah maka proses integrasi toko Anda telah selesai',
      note: 'Note: Harap mematikan pengaturan signature key / kata sandi API ke posisi <b>off</b>',
      video_tutorial: 'Klik link berikut untuk melihat video tutorial',
      sync_warehouse: 'Sinkronisasi Gudang',
      channel_warehouse_list: 'List Gudang Channel',
      powerbiz_warehouse_list: 'List Gudang Powerbiz',
      warehouse_required: 'Gudang Powerbiz harus dipilih',
      select_main_warehouse: 'Pilih Gudang Master',
      authorization_success_title: 'Otorisasi Gudang Berhasil!',
      authorization_success_desc: 'Berhasil menambahkan Gudang Utama dan Gudang Channel.',
      ok: 'OK',
      integration_failed_warehouse: 'Integrasi Gudang {warehouseName} - {displayName} Gagal',
      copied: 'Disalin',
      success_title: 'Berhasil',
      fail_title: 'Gagal',
    },
    zalora_sync: {
      alert_msg: 'Pesanan yang masuk ke powerbiz secara otomatis akan di terima oleh sistem, namun belum mengatur pengiriman pada zalora, mohon pilih salah satu proses dibawah ini untuk sistem powerbiz update atur pengiriman di zalora',
      select_shipment_label: 'Update Atur Pengiriman Zalora',
      select_shipment_required: 'Pilih update atur pengiriman zalora',
      select_shipment_placeholder: 'Pilih update atur pengiriman zalora',
      how_to_get_title: 'Cara mendapatkan Client ID & Secret :',
      step_1: 'Login ke Zalora seller center',
      step_2: 'Masuk ke menu setting',
      step_3: 'Pilih Integration Management',
      step_4: 'Pilih OAuth Application',
      step_5: 'Tambah Aplikasi baru',
      step_6: 'Masukkan data :',
      step_6_li_1: 'Application Name : Powerbiz',
      step_6_li_2: 'Authorization redirect URL : https://admin.powerbiz.asia/integration/zalora',
      step_7: 'Jika sudah, klik simpan',
      step_8: 'Pilih aplikasi yang tadi dibuat, lalu klik edit',
      step_9: 'Salin client ID & Client Secret yang telah tergenerate',
      sales_items_booked: {
        label: 'Stok Teralokasi',
        tooltip: 'Stok teralokasi: atur pengiriman pada zalora akan diset saat stok teralokasi',
      },
      pick_confirmed: {
        label: 'Pengambilan',
        tooltip: 'Pengambilan: atur pengiriman pada zalora akan di set saat barang telah diambil dari rak gudang',
      },
    },
    sync_form: {
      success_title: 'Berhasil!',
      success_desc: 'Proses Integrasi Toko Tokopedia anda sedang dalam proses, silahkan cek email anda.',
      disclaimer: 'Form ini merupakan formulir untuk pengajuan proses integrasi tokopedia',
      is_binding_label: 'Apakah tokopedia anda sudah melakukan binding dengan tiktok shop?',
      is_binding_required: 'Harap pilih status binding',
      not_binding: 'Belum binding',
      already_binding: 'Ya, Sudah binding',
      complete_info: 'Lengkapi detail informasi berikut',
      store_name: 'Nama Toko',
      store_name_required: 'Harap masukan nama toko!',
      store_name_placeholder: 'Masukan nama toko',
      store_domain: 'Domain Toko',
      store_domain_required: 'Harap masukan domain toko!',
      tokopedia_steps_title: 'Ikuti langkah berikut ini untuk melakukan Integrasi Tokopedia :',
      tokopedia_steps: {
        1: 'Lakukan Permintaan integrasi toko dengan menginput Nama dan Domain Toko Anda. Toko Anda akan berstatus “Menunggu” (Menunggu konfirmasi dari Penjual). Nama dan domain toko Anda dapat dilihat pada web seller center Tokopedia > Pengaturan Toko > Informasi. Lalu copy informasi toko pada bagian Domain Toko (cukup salin tulisan yang setelah "www.tokopedia.com/")',
        2: 'Tokopedia akan mengirimkan email konfirmasi persetujutan integrasi toko ke alamat email toko Anda. Anda juga dapat menerima persetujuan integrasi toko melalui web seller center Tokopedia > Pengaturan Aplikasi Pihak Ketiga > Menunggu persetujuan.',
        3: 'Lalu tunggu proses verifikasi data oleh Powerbiz selama ± 1x24 jam. Proses verifikasi selesai, ditandai dengan status toko Anda berubah menjadi “Pending Warehouse” pada Daftar Toko. Powerbiz juga akan mengirimkan notifikasi ke alamat email Anda, menginformasikan bahwa proses verifikasi sudah selesai.',
        4: 'Lakukan pemetaan gudang yang Anda miliki di Powerbiz dengan gudang Tokopedia melalui menu daftar toko.',
        5: 'Toko Anda siap dioperasikan melalui Powerbiz.',
      },
      add_other_store: 'Tambah Toko Lainnya',
      finish: 'Selesai',
      request_integration: 'Request Integrasi',
      close: 'Tutup',
      store_id_not_found: 'Store id tidak ditemukan',
      connected_failed: 'Connected Failed',
    },
    start_sync: 'Mulai Integrasi',
    note_tips_tiktok_tokopedia: 'Anda akan melakukan integrasi tiktok shop , proses integrasi ini akan membuat 2 channel yakni tiktok & tokopedia, Pastikan tokopedia anda telah dilakukan binding dengan tiktok anda, namun jika anda belum melakukan binding tersebut maka hanya tiktok saja yang akan terdaftar pada sistem powerbiz. Anda dapat menambahkan tokopedia nantinya ,dengan melakukan daftar toko lalu klik icon “tokopedia” dan pilih “Ya, sudah binding”',
    back: 'Kembali',
    sync_store_sucess: 'Integrasi Toko Berhasil.',
    des_sync_store_sucess:
      'Silakan lakukan sinkronisasi produk pada Daftar Produk Toko Anda dengan mengklik tombol Sync. Produk.',
    add_more_store: 'Tambah Toko Lainnya',
    done_sync: 'Selesai',
    cancel: 'Batal',
    next: 'Selanjutnya',
    choose_chanel: 'Pilih saluran untuk di integrasikan ke toko Anda',
    complite_detail_information: 'Lengkapi detail informasi berikut',
    select_shop: 'Pilih Toko',
    error_sync: 'Terjadi kesalahan, harap coba lagi',
    complete_information: 'Lengkapi detail informasi berikut',
    sync_warehouse: 'Sinkronisasi Gudang',
    main_warehouse: 'Gudang Utama',
    select_main_warehouse: 'Pilih Gudang Utama',
    channel_warehouse: 'Gudang Channel',
    select_channel_warehouse: 'Pilih Gudang Channel',
  },
  distributor: {
    list_distributor: 'Daftar Distributor',
    search: 'Cari Distributor',
    export_data: 'Ekspor Data',
    add_distributor: 'Tambah Distributor',
    name_distributor: 'Nama Distributor',
    category_distributor: 'Kategori',
    address: 'Alamat',
    action: 'Aksi',
    country: 'Negara',
    indonesia: 'Indonesia',
    city: 'Kota',
    email: 'Email',
    status: 'Status',
    sla_day: 'SLA Komplain (Hari)',
    coverage_area: 'Area Cakupan',
    district: 'Kecamatan',
    subdistrict: 'Kecamatan',
    mobile_phone: 'No. Handphone',
    active: 'Aktif',
    inactive: 'Tidak Aktif',
    add_success_desc: 'Distributor berhasil ditambahkan',
    add_failed_desc: 'Gagal menambahkan distributor',
    detail_distributor: 'Rincian Distributor',
    active_condition: 'Non Aktifkan',
    inactive_condition: 'Aktifkan',
    deactivate_distributor: '{value} Distributor',
    confirm_deactivate: 'Apakah Anda yakin ingin {value} distributor ?',
    code: 'Kode Distributor',
    name: 'Nama Distributor',
    npwp_id: 'No. NPWP',
    npwp_name: 'Nama NPWP',
    postal_code: 'Kode Pos',
    warehouse_code: 'Kode Gudang',
    warehouse_name: 'Nama Gudang',
    warehouse_address: 'Alamat Gudang',
    use_distributor_address: 'Gunakan Alamat Distributor',
    choose_city: 'Pilih Kota terlebih dahulu',
    choose_district: 'Pilih Kecamatan terlebih dahulu',
    choose_coverage: 'Pilih Kota Coverage Area terlebih dahulu',
    rules: {
      code: 'Kode distributor wajib diisi',
      name: 'Nama distributor wajib diisi',
      categories: 'Kategori produk wajib dipilih',
      phone_number: 'Nomor handphone wajib diisi',
      taxid: 'Nomor NPWP wajib diisi',
      taxname: 'Nama NPWP wajib diisi',
      bank_name: 'Nama bank wajib dipilih',
      account_number: 'Nomor rekening wajib diisi',
      account_name: 'Nama rekening wajib diisi',
      sla_shipping_day: 'SLA Komplain wajib diisi',
      city: 'Kota wajib dipilih',
      district: 'Kecamatan wajib dipilih',
      postal_code: 'Kode pos wajib diisi',
      address: 'Alamat wajib diisi',
      warehouse_name: 'Nama gudang wajib diisi',
      coverage: 'Area cakupan wajib dipilih',
    },
  },
  reseller: {
    titleHead: 'Reseller',
    search: 'Cari reseller..',
  },
  customer: {
    customer_category: "Kategori Pelanggan",
    add_customer_category: 'Tambah Kategori Pelanggan',
    enter_category_name: 'Masukkan nama kategori',
    create_success_category: 'Kategori pelanggan berhasil dibuat',
    create_failed_category: 'Gagal membuat kategori pelanggan',
    list: 'Daftar Pelanggan',
    search: 'Cari Data Pelanggan',
    export: 'Ekspor Data',
    invite: 'Undang Pelanggan',
    name: 'Nama Pelanggan',
    category: 'Kategori Pelanggan',
    email: 'Email',
    mobile: 'No. Handphone',
    distributor: 'Distributor',
    city: 'Kota',
    status: 'Status',
    action: 'Aksi',
    all: 'Semua Status',
    not_approved: 'Belum Disetujui',
    active: 'Aktif',
    inactive: 'Tidak Aktif',
    new: 'Baru',
    approval: 'Persetujuan',
    edit: 'Ubah',
    credit_limit: 'Limit Kredit',
    transaction_limit: 'Limit Transaksi',
    payment_limit: 'Limit Waktu Bayar',
    edit_customer: 'Edit Customer',
    delete: 'Hapus',
    empty_title: 'Belum memiliki data',
    empty_msg: 'Saat ini Anda belum memiliki data',
    add: 'Tambah Pelanggan',
    password: 'Password',
    confirm_password: 'Konfirmasi Password',
    distributor_city: 'Kota Distributor',
    select_category: 'Pilih Kategori Pelanggan',
    select_city: 'Pilih Kota Distributor',
    select_distributor: 'Pilih Distributor',
    select_all: 'Pilih Semua',
    save: 'Simpan',
    cancel: 'Batal',
    approve: 'Disetujui',
    not_approve: 'Tidak Disetujui',
    registration_via: 'Registrasi via Email / No. Handphone',
    shop_code: 'Kode Toko',
    buyer_code: 'Kode Pembeli',
    sales_code: 'Kode Sales',
    store_name: 'Nama Toko',
    store_type: 'Store Type',
    payment_model: 'Model Pembayaran',
    transaction_limits: 'Maksimal Transaksi Kredit',
    coin_usage: 'Penggunaan Koin',
    pay_time_limit: 'Jatuh Tempo',
    setup_credit_limit: 'Setup Kredit Limit',
    credit_limit_total_label: 'Total Credit Limit',
    credit_limit_usage_label: 'Credit Limit Berjalan',
    credit_limit_remaining_label: 'Remaining Credit Limit',
    user_status: 'Status Pengguna',
    phone: 'Nomor Handphone',
    road_name: 'Nama Jalan',
    distributor_list: 'List Distributor',
    search_distributor: 'Cari distributor...',
    select_warehouse: 'Pilih gudang',
    select_all_warehouse: 'Pilih Semua Gudang',
    payment_info: 'jika pilih CBD maka hanya dapat CBD saja, jika pilih COD maka dapat CBD & COD, jika CAD maka dapat seluruhnya',
    credit_limit_info: 'nilai kredit yang dimiliki pelanggan',
    transaction_limit_info: 'limit maksimal transaksi yang dilakukan dengan pembayaran tempo',
    payment_limit_info: 'Batas waktu pembayaran tagihan',
    rules: {
      payment_model_required: 'Model pembayaran harus di isi',
      distributor_required: 'Distributor harus dipilih',
      warehouse_required: 'Gudang harus dipilih minimal 1',
      credit_limit_required: 'Limit kredit harus diisi',
      transaction_limit_required: 'Limit transaksi harus diisi',
      payment_limit_required: 'Limit waktu bayar harus diisi',
      credit_limit_usage_error: 'Anda sedang memiliki tagihan dan nilai kredit limit berjalan anda saat ini: {value}, tidak boleh lebih kecil dari nilai yang dimiliki pelanggan saat ini',
      transaction_limit_usage_error: 'Anda sedang memiliki tagihan dan nilai transaksi limit anda saat ini: {value}, tidak boleh lebih kecil dari nilai yang dimiliki pelanggan saat ini',
      name: 'Nama Toko harus diisi',
      namecustomer: 'Nama pelanggan harus diisi',
      category: 'Kategori harus dipilih',
      email: 'Email harus diisi',
      email_invalid: 'Email yang diisi tidak valid',
      mobile: 'No. Handphone harus diisi',
      distributor: 'Distributor harus dipilih',
      city: 'Kota distributor harus dipilih',
      password: 'Password harus diisi',
      confirm_password: 'Konfirmasi password harus diisi',
      match_password: 'Konfirmasi password harus sama dengan password',
      sales_code: 'Kode Sales harus dipilih',
      coin_usage: 'Penggunaan koin harus dipilih',
      shop_code: 'Kode Toko harus diisi',
      category_name_required: 'Nama kategori wajib diisi',
      max_char: 'Maksimal {max} karakter',
      road_name_required: 'Nama jalan harus diisi',
      country_required: 'Negara harus dipilih',
      city_required: 'Kota harus diisi',
      subdistrict_required: 'Kecamatan harus dipilih',
      postcode_required: 'Kode Pos harus diisi',
      payment_model_required: 'Model pembayaran harus di isi',
      credit_limit_required: 'Limit kredit harus diisi',
      transaction_limit_required: 'Limit transaksi harus diisi',
      payment_limit_required: 'Limit waktu bayar harus diisi',
      distributor_required: 'Distributor harus dipilih',
      warehouse_required: 'Gudang harus dipilih minimal 1',
      credit_limit_warning: 'Anda sedang memiliki tagihan dan nilai kredit limit berjalan anda saat ini: {limit}, tidak boleh lebih kecil dari nilai yang dimiliki pelanggan saat ini',
      transaction_limit_warning: 'Anda sedang memiliki tagihan dan nilai transaksi limit anda saat ini: {limit}, tidak boleh lebih kecil dari nilai yang dimiliki pelanggan saat ini',
      distributor_delete_restricted: 'Aksi ini dibatasi, anda tidak dapat menghapus distributor yang sudah pernah ditambahkan sebelumnya',
      distributor_delete_restricted_title: 'Tidak dapat menghapus distributor',
      price_area_fetch_failed: 'Gagal saat mencari price area',
      warehouse_fetch_failed: 'Gagal saat mencari data gudang',
      price_area_not_found: 'Price area tidak ditemukan di gudang {warehouse}',
    },
    deactivate: 'Non Aktifkan',
    activate: 'Aktifkan',
    checkCustomerBill: 'Cek Tagihan Pelanggan',
    confirmDeactivate: 'Apakah anda yakin akan menonaktifkan Pelanggan atas nama',
    confirmActivate: 'Apakah anda yakin akan mengaktifkan Pelanggan atas nama',
    approveSuccess: 'Berhasil approve customer',
    approveFailed: 'Gagal approve, terjadi kesalahan.',
    deactivateSuccess: 'Pelanggan berhasil di non aktifkan',
    activateSuccess: 'Pelanggan berhasil di aktifkan',
    saveSuccess: 'Pelanggan berhasil disimpan',
    saveFailed: 'Gagal simpan pelanggan',
    payment_models: {
      cbd: 'Cash Before Delivery',
      cod: 'Cash On Delivery',
      cad: 'Cash After Delivery',
    },
  },
  order: {
    storeName: 'Nama Toko',
    customerDetail: 'Detail Pelanggan',
    namecustomer: 'Customer name is required',
    customerName: 'Nama Pelanggan',
    customerPhone: 'Nomer Telepon Pelanggan',
    customerEmail: 'Email Pelanggan',
    paymentDetail: 'Detail Pembayaran',
    totalPriceOrder: 'Total Belanja',
    paymentStatus: 'Status Pembayaran',
    paymentMethod: 'Metode Pembayaran',
    orderShippingDetail: 'Detail Pengiriman',
    courier: 'Kurir',
    warehouse: 'Gudang',
    detail: 'Detail',
    voucher: 'Voucher',
    shippingCost: 'Biaya Pengiriman',
    itemsSold: 'Item Terjual',
    salesTitle: 'Penjualan',
    cleanFilter: 'Bersihkan Filter',
    totalAllSales: 'Total Semua Sales',
    exportTitle: 'Eksport',
    orderDate: 'Tgl Order',
    business: 'Bisnis',
    channel: 'Channels',
    customer: 'Pelanggan',
    orderNumber: 'No Order',
    orderType: 'Tipe Pesanan',
    priorityLevel: 'Prioritas',
    itemTotal: 'Total Item',
    priceTotal: 'Total Harga',
    productName: 'Nama Produk',
    skuTitle: 'SKU',
    quantityTitle: 'Jml',
    priceTitle: 'Harga',
    discountTilte: 'Diskon',
    totalTitle: 'Sub Total Order',
    paymentsTotalTitle: 'Total Tagihan',
    moreDetailsTitle: 'Lihat Lebih',
    lessDetailsTitle: 'Lihat Sedikit',
    detailsTitle: 'Rincian',
    viewDetail: 'Lihat Detail',
    closeDetail: 'Tutup Detail',
    history_order_log: 'Riwayat Pesanan',
    history_order_title: 'Riwayat Pesanan',
    history_activities: 'Aktivitas Tercatat',
    history_empty_msg: 'Belum ada data riwayat log untuk pesanan ini.',
    history_failed_to_load: 'Gagal Memuat Riwayat Order',
    history_fetch_error_desc: 'Terjadi kesalahan saat mengambil log dari server.',
    sort_newest: 'Terbaru Dulu',
    sort_oldest: 'Terlama Dulu',
    no_activity: 'Tidak ada aktivitas',
    sortBy: 'Urutkan',
    sortByNewest: 'Terbaru',
    sortByOldest: 'Terlama',
    shippingTitle: 'Detail Pengiriman',
    shippingAddress: 'Alamat Tujuan',
    dropshipperInformation: 'Dikirim sebagai dropshipper',
    shippingCourierTitle: 'Kurir',
    shippingReceiptNumber: 'No Resi',
    shippingLabel: 'Label Pengiriman',
    shipping_id: 'ID Pengiriman',
    shippingWarehouseTitle: 'Dikirim Dari',
    shippingHistoryTitle: 'Riwayat Pengiriman',
    shippingShowMoreDetailsTitle: 'Lihat Lebih Lengkap',
    viewHistory: 'Lihat History',
    closeHistory: 'Tutup History',
    changesHistory: 'Riwayat perubahan',
    ordersPeriod: 'Periode Pesanan',
    ordersPeriodFrom: 'Periode Pesanan Awal',
    ordersPeriodUntil: 'Periode Pesanan Akhir',
    productCategory: 'Kategori Produk',
    printStatus: 'Status Cetak',
    date_created: 'Tanggal Dibuat',
    last_modified: 'Terakhir Diubah',
    order: 'Urutan',
    oldest_first: 'Terlama',
    newest_first: 'Terbaru',
    filterState: {
      all: 'Semua',
      verified: 'Belum dibayar',
      submitted: 'Baru',
      new_: 'Baru',
      confirmed: 'Terkonfirmasi',
      onprocess: 'Dalam Proses',
      on_process: 'Dalam Proses',
      cancelrequested: 'Konfirmasi pembatalan',
      shipped: 'Pengiriman',
      send: 'Terkirim',
      delivered: 'Terkirim',
      canceled: 'Batal',
      completed: 'Selesai',
      ready_to_ship: 'Siap Dikirim',
      cancel_requested: 'Req Batal',

    },
    filterStateTag: {
      all: 'Semua',
      verified: 'Belum dibayar',
      new: 'Baru',
      new_: 'Baru',
      confirmed: 'Terkonfirmasi',
      onprocess: 'Dalam Proses',
      on_process: 'Dalam Proses',
      cancelrequested: 'Konf. pembatalan',
      shipped: 'Pengiriman',
      send: 'Terkirim',
      delivered: 'Terkirim',
      canceled: 'Batal',
      completed: 'Selesai',
      ready_to_ship: 'Siap Dikirim',
      cancel_requested: 'Req Batal',

    },
    status: {
      confirmOrder: 'Selesai',
      completedOrder: 'Baru',
    },
    require_order_period: 'Harap isi periode pesanan',
    empty_title: 'Belum memiliki data',
    empty_msg: 'Saat ini Anda belum memiliki data',
    courier_name: 'Nama kurir',
    accept_order: 'Terima Pesanan',
    reject_order: 'Tolak Pesanan',
    accept_cancel_order: 'Setuju Pembatalan',
    cancel_order: 'Batalkan Pesanan',
    cancel_request: 'Tolak Pembatalan',
    accept_with_shipment: 'Terima Pesanan dengan Pengiriman',
    arrange_shipment: 'Atur Pengiriman',
    channel_accept_success: 'Pesanan {order_number} berhasil diproses',
    channel_accept_already_accepted: 'Order {order_number} sudah pernah diproses sebelumnya',
    channel_accept_failed: 'Gagal memproses pesanan {order_number}',
    channel_accept_shipment_delay_title: 'Arrange Shipment ditunda.',
    channel_accept_shipment_delay_description: 'Pengaturan pengiriman berada di luar waktu penerimaan. Sistem akan',
    channel_accept_shipment_delay_retry: 'secara otomatis mencoba kembali pada {retry_at}.',
    cancel_reason: 'Alasan Pembatalan',
    cancel_reason_sub: 'Alasan Batal',
    cancel_detail: 'Rincian pembatalan',
    select_empty_stock: 'Pilih stock yang habis',
    placeholder_cancel_detail: 'Jelaskan alasan pembatalan pesanan Anda',
    info_cancel_detail: 'Minimal {value} karakter',
    novalid_reason: 'Harap pilih alasan',
    accept_confirm_msg: 'Apakah Anda yakin ingin menerima pesanan ini?',
    transaction_discount: 'Diskon Transaksi',
    transaction_deposit: 'Deposit',
    transaction_loyalty: 'Loyalty',
    transaction_voucher: 'Voucher',
    transaction_shipping: 'Biaya Pengiriman',
    transaction_admin: 'Total Biaya Admin',
    discount_transaction: 'Diskon Transaksi dari',
    discount_shipping: 'Diskon Pengiriman dari',
    tracking: {
      delivery: {
        waiting: 'Menunggu',
        waitingTooltip: 'Paket dalam antrian proses',
        picking: 'Pengambilan',
        pickingTooltip: 'Paket telah diambil dari gudang',
        packing: 'Pengemasan',
        packingTooltip: 'Paket telah dikemas',
        readyToShip: 'Siap Dikirim',
        readyToShipTooltip: 'Paket telah di good issued',
      },
      shipping: {
        waiting: 'Menunggu',
        waitingTooltip: 'Paket siap dikirim',
        delivery: 'Pengiriman',
        deliveryTooltip: 'Paket dalam pengiriman',
        delivered: 'Terkirim',
        deliveredTooltip: 'Paket telah sampai',
        completed: 'Selesai',
        completedTooltip: 'Pesanan telah selesai',
      },
    },
    pickup_address: 'Alamat Pengambilan',
    export_mode: 'Mode Ekspor',
    export_order_data: 'Ekspor Data Pesanan',
    export_excel: 'Export Excel',
    total_sales_data: 'Total Data Penjualan',
    filter_state_title: 'Status Pesanan',
    choose_order_status: 'Pilih Status Pesanan',
    choose_order_type: 'Pilih Tipe Pesanan',
    choose_priority_level: 'Pilih Prioritas',
    choose_business: 'Pilih Bisnis',
    choose_channel: 'Pilih Channel',
    choose_warehouse: 'Pilih Gudang',
    choose_sales_channel: 'Pilih Sales Channel',
    disclaimer_max_data: 'Silahkan pilih kembali filter tanggal, maksimal yang dapat diunduh sebanyak 500 data',
    max_date_range_error: 'Batas maksimal filter tanggal adalah {limit} hari.',
    current_date_range_info: 'Filter tanggal yang anda pilih saat ini adalah {count} hari',
    order_item_status: 'Status Produk Pesanan',
    choose_order_item_status: 'Pilih Status Produk Pesanan',
    all_order_type: 'Semua Tipe Pesanan',
    all_priority_level: 'Semua Prioritas',
    all_status: 'Semua Status',
    all_business: 'Semua Bisnis',
    all_channel: 'Semua Channel',
    all_sales_channel: 'Semua Sales Channel',
    all_warehouse: 'Semua Gudang',
    confirmed: 'Terkonfirmasi',
    unconfirmed: 'Belum Terkonfirmasi',
    cancel_order: 'Batalkan Pesanan',
    internal_cancel_order: 'Internal - Batalkan Pesanan',
    cannot_cancel_fulfillment_started: 'Maaf, nomor order ini tidak dapat dibatalkan, karena proses fulfillment sedang berlangsung.',
    yes_cancel_order: 'Ya, Batalkan Pesanan',
    no_title: 'Data judul kosong',
    not_mapped: 'Produk ini belum ter-mapping',
    no_data_show: 'Tidak ada data untuk dibetulkan',
    pick_up_admin: 'Pick Up Admin',
    cad_detail: 'Detail CAD',
    processing_data: 'Data sedang diproses, silakan coba lagi beberapa saat lagi.',
  },
  integration: {
    integration: 'Integrasi',
    name: 'Nama',
    channelManagement: 'Pengelolaan Saluran',
    warehouseManagement: 'Pergudangan',
    shippingManagement: 'Pengiriman',
    pointOfSales: 'Pusat Penjualan',
    paymentGateway: 'Jalur Pembayaran',
    accounting: 'Akuntansi',
    addChannel: 'Tambah Saluran Penjualan',
    addWarehouse: 'Tambah Gudang',
    addShipping: 'Tambah Pengiriman',
    addPointOfSales: 'Tambah titik Penjualan',
    addPaymentGateway: 'Tambah Jalur Pembayaran',
    addAccountingTool: 'Tambah Alat Akuntansi',
    startIntegration: 'Mulai Integrasi',
    confirmProduct: 'Konfirmasi Produk',
    editChannel: 'E d i t',
    deleteChannel: 'Putuskan Sambungan',
    empty_store_title: 'Belum Ada Toko atau Saluran Penjualan',
    empty_store_desc: 'Saat ini akun anda belum memiliki toko atau saluran penjualan. <br /> Silakan tambahkan toko dan integrasikan dengan sistem kami.',
    search_sales_channel_placeholder: 'Cari Toko atau Kanal Penjualan',
    add_store: 'Tambah Toko',
    store_name: 'Nama Toko',
    store_status: 'Status Toko',
    authorization_time: 'Waktu Otorisasi',
    country: 'Negara',
    notes: 'Catatan',
    options: 'Pilihan',
  },
  product: {
    productTags: {
      title: 'Tag Produk',
      add_new: 'Tambah tag baru',
      tabs: {
        all: 'Semua',
        active: 'Aktif',
        inactive: 'Non-aktif',
      },
      table: {
        name: 'Nama tag',
        status: 'Status',
      },
      action: {
        deactivate: 'Nonaktifkan',
        activate: 'Aktifkan',
        see_details: 'Lihat detail',
        edit: 'Edit',
        manage_products: 'Kelola Produk',
      },
      modal: {
        add_title: 'Tambah Tag Baru',
        edit_title: 'Edit Tag',
        subtitle: 'Isi nama tag untuk setiap bahasa',
        field_name: 'Nama Tag',
        required: 'wajib',
        optional: 'opsional',
        default: 'Default',
        set_as_default: 'Set sebagai default',
        sequence: 'Sequence',
        status: 'Status',
        cancel: 'Batal',
        submit: 'Submit',
      },
      detail: {
        title: 'Detail Tag Produk',
        id: 'ID',
        name_id: 'Nama (ID)',
        name_en: 'Nama (EN)',
        status: 'Status',
      },
      messages: {
        fetch_failed: 'Gagal mengambil data',
        fetch_detail_failed: 'Gagal mengambil detail tag',
        save_success: 'Berhasil disimpan',
        save_failed: 'Gagal menyimpan data',
        status_updated: 'Status {name} diubah',
        status_update_failed: 'Gagal mengubah status',
        detail_fetch_failed: 'Gagal mengambil detail',
        id_required: 'Nama ID wajib diisi',
        en_required: 'Nama EN wajib diisi',
        set_default_success: '{lang} disetel sebagai default',
      },
      manage: {
        title: 'Kelola Produk Tag',
        add_product: 'Tambah Produk',
        remove_product: 'Hapus dari Tag',
        modal_title: 'Pilih Produk untuk Tag',
        table: {
          product: 'Produk',
          sku: 'SKU',
          price: 'Harga',
          stock: 'Stok',
        },
        messages: {
          add_success: 'Produk berhasil ditambahkan',
          add_failed: 'Gagal menambahkan produk',
          remove_success: 'Produk berhasil dihapus dari tag',
          remove_failed: 'Gagal menghapus produk dari tag',
          fetch_products_failed: 'Gagal mengambil daftar produk',
        },
        empty_description: 'Pilih tag untuk melihat produk',
        no_tags: 'Tidak ada tag tersedia',
        search_placeholder: 'Cari nama produk atau SKU...',
        tagged: 'Sudah Ada',
        add: 'Tambah',
      },
    },
    title: 'Produk',
    listProduct: 'Daftar Produk Utama',
    priceArea: 'Harga per Area',
    per_area: 'Per Area',
    select_photo: 'Pilih Foto',
    upload_image_hint: 'Silahkan upload gambar di bagian {section}',
    photo_video_section: 'Foto dan Video',
    area: 'Area',
    customer_type: 'Tipe Pelanggan',
    price: 'Harga',
    effective_date: 'Tanggal Berlaku',
    quantity: 'Quantity',
    product_bundling: 'Product Bundling',
    soft_bundling: 'Soft Bundling',
    hard_bundling: 'Hard Bundling',
    no_bundling: 'Tidak Ada',
    delete_bundling_confirm_title: 'Hapus Bundling',
    delete_bundling_confirm_content: 'Jika Anda rubah, daftar produk bundling akan terhapus lho, apakah Anda yakin?',
    searchBarPlaceholder: 'Pencarian',
    addProduct: 'Tambah Produk',
    editProduct: 'Edit Produk',
    addPrice: 'Tambah Harga',
    clearFilter: 'Bersihkan filter',
    setfilter: 'Terapkan',
    date: {
      first: 'Awal',
      end: 'Akhir',
    },
    select_date: 'Pilih tanggal',
    productStatus: {
      ACTIVE: 'Aktif',
      NON_ACTIVE: 'Tidak Aktif',
      INACTIVE: 'Tidak Aktif',
      DRAFT: 'Draft',
    },
    slug: 'Slug',
    slug_disclaimer: 'Format slug belum sesuai standar. Silakan klik tombol <b>Edit</b> untuk menyesuaikan secara otomatis.',
    slug_error: 'Gagal mendapatkan angka unik untuk slug. Silakan klik tombol "Edit" kembali untuk mencoba lagi.',
    addNewProduct: 'Tambah Produk Baru',
    uploadTemplate: 'Upload Template',
    cancel: 'Batal',
    next: 'Selanjutnya',
    selectClient: 'Pilih Klien',
    mass_change: 'Ubah Banyak',
    all_select: 'Semua',
    selected: 'Terpilih',
    delete: 'Hapus Produk',
    delete_product_confirm_title: 'Hapus Produk',
    delete_product_confirm_content: 'Apakah Anda yakin ingin menghapus produk {name} ?',
    export: 'Eksport',
    product_name: 'Nama Produk',
    categories: 'Kategori',
    varian: 'Varian',
    variant: '{count} Varian',
    variant_name: 'Nama Varian',
    variant_label: 'Varian',
    add_variant: 'Tambah varian',
    type_variant_option: 'Ketik pilihan',
    variant_remove_confirm: 'Jika dihapus, data varian yang telah dimasukkan akan berubah dan tipe varian akan hilang dari pilihan varian, lho.',
    variant_list_empty: 'Daftar varian belum lengkap diisi',
    variant_list_empty_desc: 'Lengkapi data varian di atas untuk mengisi detail varian',
    product_variant: 'Produk Varian',
    variant_desc:
      'Pilih salah satu untuk pengaturan tipe Produk Satuan, Produk Bundling, Produk Varian',
    variant_options: 'Opsi Varian',
    product_type: 'Tipe Produk',
    non_variant: 'Non Varian',
    delete_variant_confirm_title: 'Hapus Varian',
    delete_variant_confirm_content: 'Jika dirubah, data varian yang telah dimasukkan akan berubah dan tipe varian akan hilang dari pilihan varian, lho.',
    delete_variant_confirm_ok: 'Ya, Hapus',
    range_price: 'Rentang Harga',
    channel: 'Channel',
    status: 'Status',
    product_empty: 'Belum Ada Produk',
    have_no_product: 'Saat ini Anda belum memiliki produk.',
    product_details: 'Detail Produk',
    photo_video: 'Foto',
    product_image: 'Gambar Produk',
    set_main: 'Set Utama',
    set_thumbnail: 'Set Thumbnail',
    confirm_delete_photo: 'Apakah Anda ingin menghapus foto ini?',
    delete_photo: 'Hapus',
    main: 'Utama',
    thumbnail: 'Thumbnail',
    product_type_and_price: 'Tipe Produk dan Harga',
    weight_product_shipping: 'Berat Produk dan Pengiriman',
    inventory: 'Inventory',
    channel_publication: 'Publikasi Channel',
    no_channels_integrated: 'Belum ada channel yang ter-integrasi.',
    confirm_remove_channel: 'Apakah Anda ingin menghapus channel ini ?',
    selected_channels: 'Info Pilihan',
    select_channel: 'Pilih Channel',
    add_channel: 'Tambahkan Channel',
    not_supported: 'Belum didukung',
    must_be_selected: '{name} harus dipilih',
    product_information: 'Informasi Produk',
    brand: 'Merek Produk',
    search_select_brand: 'Cari & Pilih Brand Produk',
    item_condition: 'Kondisi Barang',
    non_physical_product: 'Produk Non Fisik',
    specification: 'Spesifikasi',
    used_condition: 'Bekas',
    description: 'Deskripsi',
    short_description: 'Deskripsi Singkat',
    photo_title: 'Foto Produk',
    product_name: 'Nama Produk',
    max_70_characters: 'Maks. 70 Karakter',
    bundle_list_empty: 'Daftar produk bundling diisi',
    remove_bundle_item_confirm: 'Apakah Anda yakin ingin menghapus produk ini dari daftar bundling?',
    add_bundle_product: 'Tambah produk bundling',
    search_product: 'Cari produk',
    enter_product_title_sku: 'Masukkan judul produk / SKU',
    choose_warehouse_first: 'Pilih gudang terlebih dahulu',
    search_min_2_chars: 'Ketik minimal 2 karakter untuk mencari produk',
    sku_not_in_warehouse: 'SKU tidak ada pada salah satu gudang yang anda pilih, mohon tambahkan gudang terlebih dahulu untuk SKU tersebut',
    variant_name: 'Nama Varian',
    variant_label: 'Varian',
    type_variant_option: 'Ketik pilihan',
    add_variant: 'Tambah varian',
    variant_list_empty: 'Daftar varian belum lengkap diisi',
    variant_list_empty_desc: 'Lengkapi data varian di atas untuk mengisi detail varian',
    variant_remove_confirm: 'Jika dihapus, data varian yang telah dimasukkan akan berubah dan tipe varian akan hilang dari pilihan varian, lho.',
    sku_already_registered_simple: 'SKU sudah terdaftar',
    product_save_success: 'Perubahan berhasil disimpan',
    product_draft_save_success: 'Draft produk berhasil disimpan',
    product_save_failed_prefix: 'Oops, produk gagal disimpan! {message}',
    product_image_save_success: 'Gambar produk berhasil disimpan',
    product_image_save_failed: 'Oops, gambar produk gagal disimpan',
    product_catalog_save_failed: 'Oops, catalog produk gagal disimpan',
    weight_shipping_save_failed: 'Oops, berat dan pengiriman produk gagal disimpan',
    try_again_later: 'Coba lagi beberapa saat',
    product_not_found: 'Produk tidak ditemukan',

    foto_video_description:
      'Unggah foto dan varian yang dimiliki produk. Dimensi foto minimal {minWidth}x{minHeight} px. Ukuran file maksimal 1MB. Dengan format JPG, JPEG, PNG, BMP, GIF.',
    foto_video_description_master:
      'Unggah foto dan varian yang dimiliki produk. Dimensi foto minimal {minWidth}x{minHeight} px. Ukuran file maksimal 10MB. Dengan format JPG, JPEG, PNG, BMP, GIF.',
    video_title: 'Video Produk',
    video_description:
      'Unggah video produk Maksimal 30MB atau masukkan link video youtube dari produk',
    picture: 'Gambar',
    base_unit: 'Satuan Dasar',
    gift_size: 'Ukuran Bingkisan',
    unit: 'Satuan',
    weight_unit: 'Satuan Berat',
    weight: 'Berat',
    width: 'Lebar',
    height: 'Tinggi',
    length: 'Panjang',
    additional_unit: 'Satuan Tambahan',
    sku_duplicate_variant: 'SKU tidak boleh sama dengan varian lainnya',
    product_price: 'Harga Produk',
    quantity_conversion: 'Konversi Kuantitas',
    add_new_unit: 'Tambah Satuan',
    product_weight_per_unit: 'Berat produk / {unit}',
    confirm_remove_unit: 'Apakah Anda yakin ingin menghapus satuan {unit}?',
    validate_unit_required: 'Satuan harus diisi',
    validate_unit_min: 'Satuan harus lebih dari 0',
    validate_unit_conversion: 'Satuan harus lebih besar dari Konversi',
    use_price_area: 'Gunakan Harga per Area',
    add_warehouse: 'Tambah Gudang',
    add_another_warehouse: 'Tambah Gudang Lain',
    select_warehouse: 'Pilih Gudang',
    warehouse: 'Gudang',
    stock: 'Stok',
    main_warehouse: 'Gudang Utama',
    add_warehouse_location: 'Tambah Lokasi Gudang',
    search_select_warehouse: 'Cari & Pilih Gudang',
    apply: 'Terapkan',
    confirm_remove_warehouse: 'Apakah Anda yakin menghapus warehouse ini dari daftar inventory?',
    validate_warehouse_required: 'Gudang harus diisi',
    select_warehouse_validation: 'Pilih salah satu gudang untuk produk ini',
    availability: 'Availability',
    on_hand: 'On Hand',
    preorder: 'Preorder',
    change_unit: 'Ubah Satuan',
    confirm_change_base_unit: 'Jika diubah, semua satuan tambahan akan dihapus. Apakah Anda ingin mengubah satuan dari {oldUnit} ke {newUnit}?',
    package_size: 'Ukuran Paket',
    physical_product: 'Produk Fisik',
    product_unit: 'Satuan Produk',
    weight_unit: 'Satuan Berat',
    weight_value: 'Nilai Berat',
    width_value: 'Nilai Lebar',
    length_value: 'Nilai Panjang',
    height_value: 'Nilai Tinggi',
    dangerous_product: 'Produk Berbahaya',
    dangerous_product_desc: 'Mohon isi keterangan Produk Berbahaya dengan tepat. keterangan Produk berbahaya yang tidak tepat dapat menambah biaya pengiriman atau gagal pengiriman.',
    item_dangerous_content: 'Mengandung baterai/magnet/cairan/bahan mudah terbakar',
    shipping_fee: 'Ongkos Kirim',
    seller_bears_shipping: 'Penjual Menanggung Ongkos Kirim',
    supported_logistic_service: 'Jasa Kirim Yang Didukung',
    change_logistic_status: 'Ubah Status Jasa Kirim : {name}',
    i_will_bear_shipping: 'Saya Akan Menanggung Ongkos Kirim',
    shipping_fee_note: 'Pengaturan jasa kirim hanya akan diterapkan pada produk ini. Ongkir yang dimunculkan adalah tarif dasar yang dapat berubah berdasarkan berat & lokasi pembeli.',
    shipping_insurance: 'Asuransi Pengiriman',
    mandatory: 'Wajib',
    optional: 'Opsional',
    item_return: 'Retur Barang',
    item_can_be_returned: 'Barang Dapat Diretur',
    item_cannot_be_returned: 'Barang Tidak Dapat Diretur',
    cod: 'Bayar di Tempat (COD)',
    shipping: 'Pengiriman',
    shipping_weight: 'Berat Pengiriman',
    product_stock: 'Stock Produk',
    make_main_warehouse: 'Jadikan Gudang Utama',
    main_stock: 'Stok Utama',
    allocated_stock: 'Alokasi Stok',
    channel_stock: 'Stok Channel',
    product_not_synced: 'Produk Belum Tersinkronisasi',
    location: 'Lokasi',
    make_main: 'Jadikan Utama',
    factory_sku: 'SKU Pabrik',
    barcode: 'Barcode',
    set_wholesale_price: 'Atur Harga Grosir',
    add_wholesale_price: 'Tambah Harga Grosir',
    error_empty_variant: 'Nama Varian tidak boleh kosong',
    use_formula: 'Gunakan Kalkulasi Formula',
    import_page: {
      title: 'Impor Produk Baru',
      non_variant: 'Non Variant',
      multi_variant: 'Multi Variant',
      create_bundling: 'Create Product Bundling',
      easy_way_desc: 'Cara mudah untuk tambah banyak produk sekaligus.',
      download_template_title: 'Download Template',
      download_template_desc: 'File ini memiliki data yang diperlukan Powerbiz untuk mengimpor data Anda dengan benar.',
      download_template_btn: 'Download Template',
      upload_template_title: 'Upload Template',
      upload_template_desc: 'Setelah selesai mengisi template, silahkan Unggah file. File yang Anda unggah harus dalam format xlsx atau xls.',
      upload_template_btn: 'Upload Template',
      select_file: 'Select File',
      import_data_title: 'Impor Data',
      success_message: 'Selamat data berhasi diimpor. Silahkan cek hasilnya pada',
      failed_all_message: 'Maaf. Proses impor data Anda gagal, semua data gagal diimpor. Mohon periksa kembali file yang Anda upload.',
      failed_partial_message: 'Maaf. Proses impor data Anda gagal, terdapat',
      failed_data: 'data yang gagal',
      failed_master_data: 'data master',
      failed_bundling_data: 'data bundling',
      data_master: 'Data Master',
      data_bundling: 'Data Bundling',
      row: 'Baris',
      note: 'Keterangan',
      active_processes_title: 'Proses Aktif',
      process_history_title: 'Riwayat Proses',
      clear_completed: 'Bersihkan yang Selesai',
      in_progress: 'Dalam Proses',
      cancel_process: 'Batalkan Proses',
      view_details: 'Lihat Detail',
      validating_excel: 'Memvalidasi data Excel... Harap tunggu',
      started_at: 'Dimulai pada',
      started_at_label: 'Waktu Mulai',
      processing_wait: 'Memproses... Harap tunggu',
      waiting_resources: 'Menunggu resources...',
      skus_processed: 'SKU diproses',
      stop_process_confirm: 'Hentikan proses ini?',
      stop_btn: 'Stop',
      keep_btn: 'Tetap Simpan',
      file_name_label: 'Nama File',
      total_label: 'Total',
      success_label: 'Berhasil',
      failed_label: 'Gagal',
      skipped_label: 'Dilewati',
      action_label: 'Aksi',
      uploaded_by_label: 'Diunggah Oleh',
      reupload_tip: 'Perlu memperbarui beberapa SKU? Anda selalu dapat <b>unggah ulang</b> template di atas.',
      process_details_title: 'Detail Proses',
      sku_label: 'SKU',
      status_label: 'Status',
      message_label: 'Pesan',
      processing_file: 'Memproses file...',
      of: 'dari',
    },
    bulk_publish: {
      title: 'Bulk Publikasi Produk Channel',
      easy_way_desc: 'Cara mudah untuk publish banyak produk sekaligus.',
      form_title: 'Form Publish Massal',
      step_1: 'Step 1',
      step_1_desc: 'Silahkan memilih kategori channel shopee terlebih dahulu.',
      shopee_category: 'Kategori Channel Shopee',
      toco_category: 'Kategori Channel Toco',
      step_2: 'Step 2',
      step_2_desc: 'Pilih produk dari daftar sebelah kiri, lalu klik tombol ">" untuk memindahkan produk ke sebelah kanan. Klik tombol "<" untuk menghapus produk dari daftar sebelah kanan, jika anda tidak ingin mempublish produk tersebut.',
      master_product_list: 'List Produk Master',
      not_registered_desc: 'Produk ini belum terdaftar di channel',
      publish_list: 'List Produk yang akan di Publish',
      will_publish_desc: 'Produk ini akan di publish ke channel',
      add_tooltip: 'Tambahkan produk ke daftar publish',
      remove_tooltip: 'Hapus produk dari daftar publish',
      step_3: 'Step 3',
      step_3_desc: 'Pastikan anda mengisi attribut mandatory untuk setiap produk. Namun jika seluruhnya optional , produk dapat dipublikasikan langsung.',
      fill_via_excel: 'Anda dapat mengisi sekaligus menggunakan fitur upload file excel, klik',
      here: 'disini',
      success_publish: 'Berhasil Publish Produk',
      cancel_confirm: 'Apakah anda yakin ingin membatalkan proses ini? Anda akan mengulang dari awal jika membatalkan proses ini.',
      yes_cancel: 'Ya, Batalkan Publish',
      no: 'Tidak',
      cancel: 'Batal',
      back_step: 'Kembali ke step sebelumnya',
      next: 'Selanjutnya',
      publish_confirm_title: 'Apakah anda yakin? Pastikan data yang anda masukkan sudah benar. Jika ada kesalahan maka anda harus melakukan edit dari marketplace (shopee).',
      yes_publish: 'Ya, Publish Produk',
      check_again: 'Cek Lagi',
      publish_btn: 'Publish Produk',
      close: 'Tutup',
      category_required: 'Kategori harus diisi',
      row: 'Baris',
      note: 'Keterangan',
      product_name: 'Nama Produk',
      product_attribute: 'Produk Attribute',
      upload_modal: {
        title: 'Upload Form Attribute',
        upload_loading: 'Sedang mengunggah file...',
        download_template: 'Download file template',
        here: 'disini',
        upload_your_file: 'Upload file anda',
        drag_text: 'Upload file excel attribute yang telah diisi',
        submit: 'Submit Form Attribute',
        failed_title: 'Gagal',
        no_product_selected: 'Tidak ada produk yang dipilih',
        product_sku: 'Produk SKU',
        product_name: 'Nama Produk',
        mandatory: '(Wajib)',
        optional: '(Opsional)',
      },
    },
    totalItemPrice: 'Jumlah Harga Barang',
    productBundling: 'Produk Bundling',
    product_bundling: 'Product Bundling',
    soft_bundling: 'Soft Bundling',
    hard_bundling: 'Hard Bundling',
    product_name_bundling: 'Nama Produk',
    quantity_bundling: 'Kuantitas',
    no_data: 'Tidak Ada Data',
    add_product: 'Tambah Produk',
    add_product_bundling: 'Tambah Produk Bundling',
    search_product: 'Cari Produk',
    enter_product_name_sku: 'Masukkan nama produk / SKU',
    select_warehouse_first: 'Pilih gudang terlebih dahulu',
    min_chars_search: 'Ketik minimal 2 karakter untuk mencari produk',
    remove_bundling_confirm: 'Apakah Anda yakin ingin menghapus produk ini dari daftar bundling?',
    sku_not_in_warehouse: 'SKU tidak ada pada salah satu gudang yang anda pilih, mohon tambahkan gudang terlebih dahulu untuk SKU tersebut',
    add_unit: 'Tambah Satuan',
    variant_list: 'List Varian',
    add_variant: 'Tambah Varian',
    variant_label: 'Varian',
    type_variant_option: 'Ketik pilihan',
    variant_name_required: 'Nama Varian harus diisi',
    variant_name_duplicate: 'Nama Varian sudah ada',
    variant_list_required: 'List Varian harus diisi',
    variant_remove_confirm: 'Jika dihapus, data varian yang telah dimasukkan akan berubah dan tipe varian akan hilang dari pilihan varian, lho.',
    bundling_list_empty: 'Daftar produk bundling diisi',
    variant_list_empty: 'Daftar varian belum lengkap diisi',
    variant_list_empty_desc: 'Lengkapi data varian di atas untuk mengisi detail varian',
    tambah_produk_bundling_modal: 'Tambah produk bundling',
    cari_produk_label: 'Cari produk',
    masukkan_judul_produk_sku: 'Masukkan judul produk / SKU',
    calc_price: 'Harga Kalkulasi Barang',
    import: 'Produk impor',
    importLabel: 'Asal Barang',
    'price-include-vat': 'Harga Termasuk PPN',
    'price-exclude-vat': 'Harga Belum Termasuk PPN',
    'price-no-vat': 'Harga Tidak Dikenakan PPN',
    write_something: 'Tuliskan Sesuatu',
    import_export: 'Impor / Ekspor',
    import_change_price: 'Impor Ubah Harga',
    export_product_data: 'Expor Data Produk',
    price_area: 'Harga Per Area',
    area: 'Area',
    customer_type: 'Tipe Pelanggan',
    price: 'Harga',
    effective_date: 'Tanggal Berlaku',
    add_price: 'Tambah Harga',
    stock_allocation: 'Alokasi Stok',
    allocated_stock: 'Stok Dialokasikan',
    set_allocation_stock: 'Set Stok Alokasi',
    enter_value_or_percentage: 'Masukkan Nilai atau Persentase Alokasi',
    apply_to_all: 'Terapkan ke Semua',
    channel_id: 'Channel ID',
    sales_channel: 'Sales Channel',
    allocation_success: 'Alokasi Stok berhasil disimpan',
    allocation_failed: 'Alokasi Stok gagal disimpan',
    catalog: 'Katalog Produk',
    product_category: 'Kategori Produk',
    category_name: 'Nama Kategori',
    new_product: 'Produk Terbaru',
    old_product: 'Produk Terlama',
    view_variant: 'Lihat Varian',
    close_variant: 'Tutup Varian',
    sortProduct: 'Urutkan Produk',
    import: 'Impor',
    detail: 'Detail',
    nonVariant: 'Non Varian',
    bundling: 'Bundling',
    draft: 'Draft',
    republish_product: 'Republish Produk',
    republish_multi_product: 'Republish Produk',
    selectFirst: 'Mohon untuk pilih {name} terlebih dahulu',
    accessDenied: 'Akses Ditolak',
    accessDeniedDesc: 'Maaf, anda tidak memiliki akses untuk {page} produk ini.',
    exportSuccess: 'Proses export berhasil',
    exportFailed: 'Export Data Gagal',
    exportFailedDesc: 'Export Data Produk Master gagal',
    exportFailedAllocation: 'Export Data Alokasi Stok gagal',
    unitNamePlaceholder: 'Nama Satuan',
    changeUnitTitle: 'Ubah Satuan',
    changeUnitContent: 'Jika dirubah, semua satuan tambahan akan dihapus. Apakah anda ingin mengubah satuan dari {old} ke {new} ?',
    changeUnitOk: 'Ubah Satuan',
    validateUnitRequired: 'Unit harus diisi',
    validateUnitMin: 'Unit minimal mengandung 2 karakter',
    validateUnitExist: 'Unit sudah ada',
    validateNameRequired: 'Nama Produk harus diisi',
    validateCategoryRequired: 'Kategori harus diisi',
    validateDescriptionRequired: 'Deskripsi harus diisi',
    validateImageRequired: 'Upload minimal 1 gambar produk',
    validateInventoryRequired: 'Inventory harus diisi',
    invalidData: 'Terdapat data yang belum sesuai. Mohon periksa kembali data yang Anda input',
    saveSuccess: 'Produk berhasil di Simpan!',
    saveFailed: 'Produk gagal di Simpan!',
    editProduct: 'Ubah Produk',
    notFound: 'Produk tidak ditemukan',
    errorOccurred: 'Terjadi kesalahan',
    backToPrevious: 'Kembali ke halaman sebelumnya',
    defaultCategory: 'Kategori Product Default',
    channelCategory: 'Kategori Product Channel',
    activationSuccess: 'Aktivasi Produk Berhasil',
    activationFailed: 'Aktivasi Produk Gagal',
    republishSuccess: 'Republish Produk Berhasil',
    republishFailed: 'Republish Produk Gagal',
    collection: {
      title: 'Produk Pilihan',
      type: {
        featured: 'Featured',
        bestseller: 'Best Seller',
        newarrival: 'New Arrival',
        special: "Special",
      },
      confirm: {
        delete: 'Apakah anda yakin ingin menghapus produk ini dari produk pilihan?',
      },
      'add-to-collection': 'Tambahkan ke produk pilihan',
      'type-label': 'Tipe',
    },
    bulk_edit_product: 'Bulk Edit Produk',
    upload_bulk_edit_product: 'Upload Bulk Edit Produk',
  },
  global_variable: {
    add: 'Tambah Variabel Global',
    empty_title: 'Tidak ada variabel global',
    empty_msg: 'Saat ini Anda belum memiliki variabel global',
  },
  formula_variable: {
    add: 'Tambah Variabel Formula',
    empty_title: 'Tidak ada variabel formula',
    empty_msg: 'Saat ini Anda belum memiliki variabel formula',
  },
  product_variable: {
    add: 'Tambah Variabel Produk',
    empty_title: 'Tidak ada variabel produk',
    empty_msg: 'Saat ini Anda belum memiliki variabel produk',
  },
  price_formula: {
    price_formula: 'Formula Harga',
    search: 'Cari',
    add_price_formula: 'Tambah Formula Harga',
    all: 'Semua',
    formula_name: 'Nama Formula',
    short_description: 'Deskripsi Singkat',
    cancel: 'Batal',
    rounding: 'Pembulatan',
    empty_title: 'Tidak ada formula harga',
    empty_msg: 'Saat ini Anda belum memiliki formula harga',
    error_add_variable: 'Harap masukkan variabel atau konstanta',
    error_add_operator: 'Harap masukkan operator',
    error_no_close: 'Harap tutup kurung',
    error_use_formula: 'Variabel ini digunakan diformula',
    error_close_bracket: 'Tutup kurung tidak sesuai',
    error_number_of_variable: 'Variabel atau konstanta minimal 2',
    error_get_global: 'Gagal mengambil data Variabel Global',
    error_get_formula: 'Gagal mengambil data Variabel Formula',
    error_get_product: 'Gagal mengambil data Variabel Produk',
    formula_label: 'Formula',
    save_success: 'Formula Harga berhasil disimpan.',
    save_failed: 'Gagal menyimpan Formula Harga',
  },
  price_setting: {
    label_variable: 'Nama Variabel',
    label_value: 'Value',
    label_formula: 'Nama Formula',
    label_description: 'Deskripsi Singkat',
    error_variable_name: 'Nama Variabel Tidak Boleh Kosong',
    error_max_variable_name: 'Nama Variabel Hanya Boleh 30 karakter',
    error_variable_name_pattern:
      'Nama Variabel Hanya Boleh Alfanumerik & garis bawah',
    error_max_formula: 'Nama Formula Hanya Boleh 30 karakter',
    error_formula_pattern: 'Nama Formula Hanya Boleh Alfanumerik & Underscore',
    error_formula_name: 'Nama Formula Tidak Boleh Kosong',
    error_value_empty: 'Value Tidak Boleh Kosong',
    error_description: 'Deskripsi Singkat Hanya Boleh 30 karakter',
    error_formula_same: 'Variabel tidak bisa lebih dari 1',
    error_formula_empty: 'Formula Tidak Boleh Kosong',
    confirm_delete_msg: 'Yakin ingin menghapus {type}',
    confirm_delete_info: '{type} tidak akan muncul kembali di dalam daftar',
    success_delete_msg: '{name} berhasil dihapus',
    cant_delete: 'Tidak Dapat Dihapus',
    used_msg: 'digunakan pada {type} berikut',
  },
  price_area_page: {
    add_title: 'Tambah Harga per Area',
    name_label: 'Nama Harga per Area',
    name_placeholder: 'Harga Area',
    province_label: 'Provinsi',
    province_placeholder: 'Cari Provinsi',
    province_select_all: 'Pilih Semua Provinsi',
    city_label: 'Kota / Kabupaten',
    city_placeholder: 'Cari Kota',
    city_select_all: 'Pilih Semua Kota',
    district_label: 'Kecamatan',
    district_placeholder: 'Cari Kecamatan',
    district_select_all: 'Pilih Semua Kecamatan',
    submit: 'Simpan',
    validation_area: 'Area Harus Diisi',
    success_add: 'Data Price Area Berhasil Ditambahkan',
    error_save: 'Oops, inventory Price Area Gagal disimpan',
    change_data: 'Ubah Data',
    coverage_area: 'Cakupan Area',
  },
  no_valid: {
    required: 'Tidak Boleh Kosong',
    alphanum_underscore: 'Hanya Boleh Alfanumerik & garis bawah',
  },

  userManage: {
    search: 'Cari',
    add_user: 'Tambah Penguna',
    user_management: 'Manajemen Pengguna',
    filter: 'Filter',
    username: 'Username',
    full_name: 'Nama Pengguna',
    role: 'Role',
    email: 'Email',
    phone_number: 'No. Handphone',
    created_at: 'Dibuat',
    business: 'Bisnis',
    warehouse: 'Warehouse',
    delete: 'Hapus',
    empty_title: 'Tidak Ada Pengguna',
    empty_desc: 'Saat ini anda <br /> belum memiliki data pengguna',
    add_user_button: 'Tambah Pengguna',
    status: {
      invited: 'Diundang',
      inactive: 'Tidak Aktif',
      active: 'Aktif',
    },
    actions: {
      deactivate: 'Non Aktifkan',
      activate: 'Aktifkan',
    },
    messages: {
      update_success: 'Data Berhasil di update',
      delete_success: 'Data Berhasil di hapus',
      invite_success_title: 'Berhasil',
      invite_success_desc: 'Anda berhasil menambahkan pengguna baru',
      invite_success_done: 'Selesai',
    },
    add_new_user: 'Tambah Pengguna Baru',
    user_role: 'Role Pengguna',
    name: 'Nama',
    password: 'Password',
    phone: 'Telepon',
    phone_number_placeholder: 'nomor telepon',
    send_password_to_email: 'Kirim Password ke Email',
    ask_password_change: 'Minta perubahan kata sandi saat Sign-in berikutnya',
    add_warehouse_location: 'Tambah Lokasi Gudang',
    status_label: 'Status',
    new_user: 'Pengguna Baru',
    user_information: 'Informasi Pengguna',
    mobile_number: 'No Handphone',
    full_name_label: 'Nama Lengkap',
    select_role: 'Pilih Role',
    working_area: 'Area Kerja',
    access_list: 'Daftar Akses',
    edit_user: 'Ubah Pengguna',
    cancel: 'Batal',
    save: 'Simpan',
    clear_selection: 'Bersihkan Pilihan',
    items_selected: '{count} item terpilih',
    select_all: 'Pilih Semua {label}',
    apply: 'Terapkan',
    clear_filter: 'Bersihkan filter',
    confirm_msg_edit: 'Apakah anda yakin akan mengubah data pengguna?',
    confirm_msg_delete: 'Setelah menghapus Manajemen Pengguna pada list daftar, data ini akan langsung terhapus',
    confirm_title: 'Konfirmasi',
    confirm_delete_title: 'Anda yakin ingin menghapus?',
    history_title: 'Riwayat Perubahan',
    success_title: 'Sukses',
    submit_edit: 'Ya, Ubah Pengguna',
    submit_delete: 'Konfirmasi',
    back_to_dashboard: 'Kembali Ke Dashboard',
    change_password_msg: 'Apakah anda yakin?',
    password_changed_msg: 'Kata Sandi berhasil diubah',
    submit_change_password: 'Ya, Ubah Kata Sandi',
    validations: {
      email_required: 'Email tidak boleh kosong',
      phone_required: 'No. Telephone tidak boleh kosong',
      role_required: 'Role tidak boleh kosong',
      business_required: 'Business tidak boleh kosong',
      warehouse_required: 'Warehouse tidak boleh kosong',
      full_name_required: 'Nama lengkap tidak boleh kosong',
    },
  },

  validations: {
    ...validation.messages,
    no_space: '{_field_} tidak boleh mengandung spasi',
    not_greater_than: 'Satuan harus lebih besar dari Konversi',
    not_less_than: 'Satuan harus lebih besar dari Konversi',
  },
  businessClient: {
    client: 'Client',
    add_client: 'Tambah Client',
    edit_client: 'Edit Client',
    detail_client: 'Detail Client',
    id_business_user: 'ID Bisnis atau Username',
    information: 'Informasi',
    currency: 'Mata Uang',
    category: 'Kategori Bisnis',
    business_identity: 'Identitas Bisnis',
    business_name: 'Nama Bisnis',
    company_information: 'Informasi Perusahaan',
    company_name: 'Nama Perusahaan',
    tax_liability: 'Kewajiban Pajak',
    company_address: 'Alamat Perusahaan',
    warehouse: 'Gudang',
    contact: 'Kontak',
  },
  store_list_page: {
    undefined: '-',
    store_list: 'Daftar Toko',
    product_confirm: 'Konfirmasi Produk',
    confirmed: 'Tersinkronisasi',
    unconfirmed: 'Belum Tersinkronisasi',
    part_confirmed: 'Part Tersinkronisasi',
    mix_confirmed: 'Mix Tersinkronisasi',
    active: 'Aktif',
    not_active: 'Tidak Aktif',
    inactive: 'Tidak Aktif',
    store_code: 'Store Code',
    store_id: 'ID Toko',
    store_name: 'Nama Toko',
    sales_channel: 'Sales Channel',
    store_status: 'Status Toko',
    api_password: 'API Seller Key',
    auto_confirm: 'Konfirmasi Otomatis',
    auto_accept_order: 'Terima Pesanan Otomatis',
    authorization_time: 'Waktu Otorisasi',
    country: 'Negara',
    channel: 'Channel',
    action: 'Tindakan',
    store_products: 'Nama Produk',
    voucher_type: 'Tipe Voucher',
    voucher_name: 'Nama Voucher',
    periode: 'Periode',
    kuota: 'Kuota',
    status: 'Status',
    variant: 'Varian',
    variant_count: 'Jumlah Varian',
    description: 'Keterangan',
    product_catalog_mapping: 'Mapping Katalog Produk',
    select_product: 'Pilih Produk',
    empty_title: 'Tidak ada data produk',
    empty_msg: 'Saat ini Anda belum memiliki data produk',
    search_placeholder: 'Cari toko atau kanal penjualan',
    add_store: 'Tambah Toko',
    connected: 'Terhubung',
    disconnected: 'Terputus',
    status: 'Status',
    all_channel: 'Semua Channel',
    all_status: 'Semua Status',
    all_country: 'Semua Negara',
    all: 'Semua',
    product: 'Produk',
    change_product: 'Detail Produk',
    change_data: 'Ubah Data',
    deactivate_product: 'Nonaktifkan Produk',
    activate_product: 'Aktifkan Produk',
    search_products: 'Cari Nama Produk / SKU',
    product_name: 'Nama Produk',
    channel_products_catalog: 'Katalog Produk Channel',
    see_more: 'Lihat Lebih Banyak',
    modal_info:
      'Jika produk tidak terdapat pada produk master, lakukan tambah produk',
    modal_empty_msg: 'Produk tidak ada dalam produk master',
    categories: 'Kategori',
    range_price: 'Rentang Harga',
    blibli_sku: 'SKU Blibli',
    program_name: 'Nama Program',
    voucher_name: 'Nama Voucher',
    voucher_type: 'Kode & Tipe Voucher',
    discount_rank: 'Tingkat Diskon',
    program_type: 'Tipe Program',
    periode: 'Periode',
    kuota: 'Kuota',
    live: 'Aktif',
    active: 'Aktif',
    activate: 'Aktif',
    seller_deactivated: 'Tidak Aktif',
    seller_delete: 'Seller Delete',
    deactivated: 'Tidak Aktif',
    draft: 'Draft',
    notActive: 'Tidak Aktif',
    not_active: 'Tidak Aktif',
    return: 'Aktif',
    return_release: 'Tidak Aktif',
    view_detail: 'Lihat Detail',
    product_mapping: 'Mapping Produk',
    product_status: 'Status Produk',
    mapping_status: 'Status Mapping',
    rules: {
      store_name: 'Nama Toko harus diisi',
      store_id: 'ID Toko harus diisi',
      client_id: 'Client ID harus diisi',
      api_password: 'API Seller Key harus diisi',
      client_secret: 'Client Secret harus diisi',
      main_warehouse: 'Gudang Utama harus dipilih',
      master_warehouse: 'Warehouse Master harus dipilih',
      channel_warehouse: 'Gudang Channel harus dipilih',
      arrange_shipment: 'Arrange Shipment harus dipilih',
    },
    status_label: {
      connected: 'Terhubung',
      disconnected: 'Terputus',
      waiting: 'Menunggu',
      pending_warehouse: 'Pending Warehouse',
      reauthentication_required: 'Perlu Autentikasi Ulang',
      token_expired: 'Token Kadaluarsa',
    },
    actions: {
      approve: 'Approve',
      deactivate: 'Non Aktifkan',
      activate: 'Aktifkan',
      disconnect: 'Putuskan',
      mapping_warehouse: 'Mapping Warehouse',
      edit_mapping_warehouse: 'Ubah Mapping Gudang',
      reconnect: 'Sambungkan Kembali',
      reauthorize: 'Autentikasi Ulang',
      cancel: 'Batal',
      confirm: 'Konfirmasi',
      bind_now: 'Binding Sekarang',
      agree: 'Setujui',
      activate_auto_accept: 'Aktifkan Terima Pesanan Otomatis',
      deactivate_auto_accept: 'Non Aktifkan Terima Pesanan Otomatis',
    },
    messages: {
      reauthorize_success_title: 'Autentikasi Ulang Berhasil',
      reauthorize_success_desc: 'Channel Shopee berhasil diotentikasi ulang.',
      reauthorize_failed_title: 'Autentikasi Ulang Gagal',
    },
    detail: {
      title: 'Detail Toko',
      channel_id: 'Channel ID',
      warehouse: 'Warehouse',
      warehouse_channel: 'Warehouse Channel',
      warehouse_master: 'Warehouse Master',
      arrange_shipment: 'Atur Pengiriman',
      auto_receive: 'Terima Pesanan Otomatis',
      last_updated: 'Terakhir diperbarui:',
      binding_done: 'Anda telah melakukan Binding',
      read_terms: 'Baca Ketentuan berikut:',
      terms_checkbox: 'Saya telah membaca dan mengerti ketentuan binding Tokopedia x TikTok Shop',
      binding_terms: {
        1: 'Pastikan sebelumnya anda telah melakukan binding pada seller centre Tokopedia',
        2: 'Anda tidak dapat unbinding jika proses binding telah dilakukan',
        3: 'Pastikan anda memilih channel Tokopedia yang sama saat melakukan binding di seller centre Tokopedia anda',
        4: 'Pada saat proses binding anda akan diminta melakukan login akun TikTok Kembali.',
        5: 'Pastikan anda login ke akun TikTok yang anda tuju dan yang telah dilakukan binding pada seller centre Tokopedia',
        6: 'Segala kesalahan pemilihan akun Tokopedia & TikTok pada saat proses binding ini menjadi tanggung jawab anda sepenuhnya.',
        7: 'Jika Anda telah yakin, silahkan klik tombol "Binding Sekarang"',
      },
    },
    integration: {
      approve_title: 'Setujui Integrasi Tokopedia',
      desc_1: 'Untuk menyetujui integrasi toko [{storeName}] anda perlu memastikan bahwa status toko berstatus aktif pada dev console Tokopedia :',
      desc_path: 'dev console > app management > pilih live apps yang diinginkan > shop management',
      desc_2: 'Masukkan App ID Tokopedia dari live apps yang digunakan untuk mendaftarkan toko [{storeName}] sesuai yang ada pada dev console Tokopedia.',
      desc_3: 'Input shop ID dari toko [{storeName}] pada bidang berikut',
      enter_app_id: 'Masukkan App ID',
      enter_shop_id: 'Masukkan Shop ID',
    },
    auto_accept: {
      confirm_title: 'Apakah anda yakin ingin {action} auto accept pada channel ini?',
      confirm_ok: 'Ya, {action}',
      change_arrange_shipment: 'Ubah Atur Pengiriman',
      change_auto_accept: 'Ubah Auto Accept',
      update_arrange_shipment: 'Update Atur Pengiriman',
      select_shipment: 'Pilih update atur pengiriman',
      info_message: 'Pesanan yang masuk ke powerbiz secara otomatis akan di terima oleh sistem, namun belum mengatur pengiriman pada {channelName}, mohon pilih salah satu proses dibawah ini untuk sistem powerbiz update atur pengiriman di {channelName}',
      this_channel: 'channel ini',
      status_success: 'Berhasil',
      status_failed: 'Gagal',
      activate: 'Aktifkan',
      deactivate: 'Non Aktifkan',
      update_auto_accept_success: 'Ubah Auto Accept Order Berhasil',
      update_auto_accept_failed: 'Ubah Auto Accept Order Gagal',
      deactivate_store_process: 'Proses menonaktifkan toko {status}',
      error_save_inventory: 'Oops, inventory produk gagal disimpan',
      sort: {
        alphabetical: 'Alfabetis',
        numerical: 'Numerik',
      },
      shipment_label: {
        allocated: 'Stok Teralokasi',
        picking: 'Pengambilan',
      },
      shipment_tooltip: {
        allocated: 'Stok teralokasi: atur pengiriman pada {channel} akan diset saat stok teralokasi',
        picking: 'Pengambilan: atur pengiriman pada {channel} akan diset saat barang telah diambil dari rak gudang',
      },
    },
    disconnect_warning: {
      confirm_msg: 'Apakah Anda yakin ingin menonaktifkan toko Blibli Anda - <b>{storeName}</b> dari aplikasi POWERBIZ ?',
      success_msg: 'Toko Blibli Anda - <b>{storeName}</b> berhasil dinonaktifkan dari aplikasi POWERBIZ',
    },
    mapping_modal: {
      title: 'Ubah Mapping Gudang {channelName} - {storeName}',
      title_main: 'Mapping Gudang',
      table: {
        channel_warehouse: 'Gudang Channel',
        master_warehouse: 'Gudang Master',
        status: 'Status',
        action: 'Tindakan',
        no_data: 'Tidak Ada Data',
        select_master_placeholder: 'Pilih Gudang Master',
        not_connected_label: 'Belum ada gudang yang terhubung',
        not_connected_tag: 'Tidak Terhubung',
        connected_tag: 'Terhubung',
      },
      tooltips: {
        add_sync: 'Tambah Sinkronisasi Gudang',
        disconnect_sync: 'Putuskan Sinkronisasi Gudang',
        save_sync: 'Simpan & Sinkronisasi Gudang',
        cancel: 'Batalkan',
      },
      confirm: {
        disconnect_title: 'Apakah kamu yakin ingin memutuskan sinkronisasi gudang?',
        disconnect_ok: 'Ya, putuskan sinkronisasi',
        disconnect_cancel: 'Tidak',
      },
      messages: {
        duplicate_warehouse: 'Gudang yang Anda pilih sudah terhubung dengan channel lain',
        master_required: 'Gudang master belum dipilih',
        channel_code_missing: 'Gagal sinkronisasi gudang, kode channel tidak ditemukan',
        success_add: 'Berhasil menambahkan sinkronisi gudang',
        success_disconnect: 'Berhasil memutuskan sinkronisasi gudang',
        success_sync: 'Berhasil sinkronisasi gudang',
        warehouse_not_found: 'Gagal sinkronisasi gudang, gudang tidak ditemukan',
        coming_soon: 'Segera Hadir',
        please_wait: 'Mohon tunggu...',
        error_occurred: 'Terjadi kesalahan',
        action_not_available: 'Gagal melakukan aksi mapping gudang karena aksi ini belum tersedia',
        disconnect_code_missing: 'Gagal memutuskan sinkronisasi gudang, channel code tidak ditemukan',
        success_update: 'Berhasil mengubah sinkronisi gudang',
        channel_status_not_updated: 'Status toko belum diperbarui oleh server. Silakan coba beberapa saat lagi.',
        warehouse_already_connected: 'Gudang yang Anda pilih sudah terhubung dengan channel lain',
        master_not_selected: 'Gudang master belum dipilih',
        failed_not_found: 'Gagal sinkronisasi gudang, gudang tidak ditemukan',
        success_add_sync: 'Berhasil menambahkan sinkronisi gudang',
        success_disconnect_sync: 'Berhasil memutuskan sinkronisasi gudang',
        failed_sync_warehouse_not_found: 'Gagal sinkronisasi gudang, gudang tidak ditemukan',
        master_warehouse_not_selected: 'Gudang master belum dipilih',
      },
    },
    synchronize: {
      sort: {
        alphabetical: 'Alfabetis',
        numerical: 'Numerik',
      },
      filter_status_product: 'Filter Status Produk',
      sort_status_asc: 'Status Asc',
      sort_status_desc: 'Status Desc',
      sync_product: 'Sync Produk',
      sync_all_product: 'Sync Semua Produk',
      sync_process_running: 'Proses sync berjalan',
      sync_info_title: 'Informasi Sync',
      sync_running_msg: 'Proses sync produk sedang berjalan.',
      sync_started_at: 'Sync dimulai pada',
      last_sync_info: 'Informasi Terakhir Sync',
      sync_success: 'Berhasil',
      sync_failed: 'Gagal',
      sync_desc_part1: 'melakukan sync produk, pada',
      sync_desc_part2: 'sampai dengan',
      history_update_stock: 'History Update Stock',
      product_history: 'Riwayat Produk',
      product_history_title: 'Riwayat Produk',
      product_history_empty: 'Belum ada riwayat untuk produk ini.',
      product_history_failed: 'Gagal Memuat Riwayat Produk',
      product_id_label: 'ID Produk',
      selected_product: 'Produk Terpilih:',
      create_master_product: 'Buat Produk Master',
      sync_stock: 'Sync Stok',
      deactivate_product_title: 'Nonaktifkan Produk',
      activate_product_title: 'Aktifkan Produk',
      confirm_desc_part1: 'Apakah Anda yakin ingin',
      deactivate: 'menonaktifkan',
      activate: 'mengaktifkan',
      confirm_desc_part2: 'produk:',
      this: 'ini',
      cancel: 'Batalkan',
      yes: 'Ya',
      warehouse_required_msg: 'Gudang harus dipilih',
      select_warehouse: 'Pilih Gudang',
      master_warehouse: 'Gudang Master',
      channel_warehouse: 'Gudang Channel',
      sync_single_product: 'Sync Single Produk',
      sync_single_product_process: 'Produk sedang dalam proses sinkronisasi.',
      sync_single_product_success: 'Produk Berhasil Disinkronisasi',
      sync_single_product_error: 'Terjadi Kesalahan',
      sync_single_product_error_desc: 'Gagal melakukan sinkronisasi produk',
      loading_info: 'Memuat informasi mapping dan stok gudang...',
      synced: 'Tersinkronisasi',
      not_synced: 'Belum Tersinkronisasi',
      info_mapping_stock: 'Informasi Mapping dan Stok Gudang',
      no_reserved_stock_info: 'channel ini tidak ada info reserved stok',
      cant_sync_stock_msg: 'Tidak dapat sinkronisasi stok karena status produk belum tersinkronisasi',
      info_history_product_warehouse_channel: 'Informasi Riwayat Produk Warehouse Channel',
      hide_raw_data: 'Sembunyikan Data RAW',
      show_raw_data: 'Lihat Data RAW',
      no_history_stock_info: 'channel ini tidak ada info riwayat stok',
      no_info_mapping_stock: 'Tidak ada informasi mapping dan stok gudang',
      product_not_synced_warehouse_master: 'produk ini belum tersinkronisasi dengan warehouse master',
      no_warehouse_connected: 'belum ada gudang yang terhubung',
      master_stock: 'Stok Master',
      checking_import_status: 'Sedang mengecek status import...',
      import_product_success: 'Produk berhasil di-import ke Master',
      import_product_failed: 'Gagal Mengimport Produk, Silahkan Coba Lagi.',
      import_product_failed_title: 'Gagal Mengimport Produk',
      some_products_import_failed: 'Beberapa produk gagal di-import',
      check_import_status_failed: 'Gagal mengecek status import',
      channel_stock: 'Stok Channel',
      allocation: 'Alokasi',
      action: 'Aksi',
    },
    product_master_modal: {
      not_mapped: '(Belum termapping)',
      remove_mapping: 'Hapus Mapping',
      mapping_product: 'Mapping Produk',
      master_product_catalog: 'Katalog Produk Master',
      choose_product: 'Pilih Produk',
      confirm_remove_mapping: 'Yakin ingin menghapus mapping produk ini?',
      success_remove_mapping: 'Mapping produk berhasil dihapus',
      success_mapping: 'Produk berhasil dimapping',
      failed_mapping: 'Gagal Mapping Produk',
      channel_catalog_name: 'Nama Katalog Channel',
      channel_catalog_sku: 'SKU Katalog Channel',
      master_catalog_name: 'Nama Katalog Master',
      master_catalog_sku: 'SKU Katalog Master',
    },
    sync_blibli_sku: {
      title: 'Sync Product Blibli berdasarkan SKU',
      enter_sku: 'Masukkan SKU produk',
      powerbiz_sku: 'SKU Powerbiz: ',
      blibli_sku: 'SKU Blibli: ',
    },
    upload_master: {
      info_msg: 'Anda dapat mengimpor 10.000 data sekaligus (format: xlsx,xls) untuk memperbarui Harga secara massal.',
      download_template: 'Download Template',
      row_selected: 'row dipilih',
      upload_template: 'Upload Template',
      upload_file: 'Upload File',
      file_type_error: 'Harap masukkan file xls / xlsx',
      upload_success: 'Template berhasil di upload',
      select_rows_error: 'Harap pilih rows',
      min_max_rows: 'minimal 1, maksimal 10',
    },
    deleted: 'Dihapus',
    disconnect_modal: {
      shopee_info: 'Untuk saat ini, silakan hubungi tim Powerbiz untuk memutuskan koneksi channel Shopee.',
      close: 'Tutup',
      confirm_title: 'Apakah anda yakin untuk memutuskan koneksi store anda dengan powerbiz?',
      cancel: 'Batalkan',
      confirm: 'Ya, Putuskan Koneksi Store',
    },
    create_product_modal: {
      title: 'Tambah Produk {channel}',
      redeem: 'Redeem',
      shopee: 'Shopee',
      tokopedia: 'Tokopedia',
      toco: 'Toco',
      distributorship: 'Distributorship',
      desc_redeem: 'Anda dapat membuat produk Redeem baru.',
      desc_master: 'Anda dapat membuat produk {channel} dari produk master yang sudah ada atau membuat produk baru.',
      create_new: 'Buat Produk Baru',
      use_existing: 'Gunakan Produk Yang Ada',
      select_product: 'Pilih Produk',
      draft_confirm: {
        title: 'Anda memiliki draf produk',
        desc: 'Untuk buat produk baru Anda dapat melanjutkan dengan draf atau buat baru',
        continue_draft: 'Lanjutkan Draf',
        delete_draft: 'Hapus Draf dan Buat Baru',
        next: 'Selanjutnya',
      },
    },
  },
  export_history_page: {
    title: 'Riwayat Expor',
    total_caption: 'Total Semua File Expor {total}',
    date: 'Tgl. Expor',
    user: 'Pengguna',
    menu: 'Menu',
    file_export: 'Ekspor File',
    status: 'Status',
    date_completed: 'Tgl. Komplit',
    try_again: 'Coba Lagi',
    empty_title: 'Tidak ada data',
    empty_msg: 'Saat ini Anda belum memiliki data',
    no_file: "File Anda sedang diproses. Silakan tunggu…",
    all: 'Semua',
    finished: 'Selesai',
    on_progress: 'Dalam Proses',
    failed: 'Gagal',
    sales: 'Pesanan',
    download_hint: 'Klik untuk mengunduh',
    action: 'Aksi',
    details: 'Detail',
    redirect_message: 'Setelah klik Export Excel, Anda akan diarahkan ke halaman Riwayat Ekspor untuk melihat file Anda.',
    shopee_warning: 'Untuk Shopee, data hanya tersedia selama 90 hari terakhir.',
    toco_warning: 'Untuk Toco, data hanya tersedia selama 90 hari terakhir.',
    business: 'Bisnis',
    currency: 'Mata Uang',
    sales_periode: 'Periode Pesanan',
    detail_export: 'Detil Expor Excel',
    info: "Info",
    warehouse: "Gudang",
    sales_channel: "Channel Penjualan",
    channel: "Toko",
    parameters: 'Parameter & Filter',
    workspace: "Workspace",
    generating: 'Memproses file...',
    detail_export_subtitle: 'Rincian permintaan ekspor Excel',
    max_order_message: "Batas ekspor terlampaui",
    max_order_description: "Silakan merubah filter agar total order ≤ {limit}",
  },
  exportSales: {
    tooltip_simple: 'Ekspor seluruh data pesanan tanpa filter tambahan.',
    tour_advance_title: 'Mode Advance',
    tour_advance_content: 'Saat ini, ekspor mode Advance hanya mendukung filter untuk Sales Channel Tiktok.',
    info_mode_version_2: 'info Mode Version 2.0',
    info_mode_version_2_desc_1: 'Penyesuaian nama table',
    info_mode_version_2_desc_2: 'Penambahan data diskon transaksi item seller & seller, voucher item seller & platform , diskon shipping seller & platform, customer payment',
    info_mode_version_2_desc_3: 'Saat ini versi 2.0 hanya tersedia untuk tiktok',
  },
  supplier: {
    title: 'Atur Supplier',
    add_supplier: 'Tambah Supplier',
    search_placeholder: 'Cari Supplier...',
    sort_name_asc: 'Nama Supplier, A-Z',
    sort_name_desc: 'Nama Supplier, Z-A',
    columns: {
      code: 'Kode Supplier',
      name: 'Nama Supplier',
      address: 'Alamat',
      email: 'Email',
      phone: 'Telepon',
    },
    add_title: 'Tambah Supplier',
    creating_tip: 'Sedang membuat supplier, Mohon tunggu...',
    form: {
      code: 'Kode Supplier',
      name: 'Nama Supplier',
      city: 'Kota',
      address: 'Alamat',
      email: 'Email',
      phone: 'No Telepon',
    },
    placeholder: {
      code: 'Masukan kode supplier',
      name: 'Masukan nama supplier',
      city: 'Masukan Kota',
      address: 'Masukan Alamat',
      email: 'Masukan Email',
      phone: 'Masukan No Telepon',
    },
    success_add: 'Berhasil menambahkan supplier',
    error_add: 'Gagal menambahkan supplier',
    error_business_id: 'Gagal menambahkan supplier, business_id tidak ditemukan',
    rules: {
      required: '{fieldName} harus diisi',
      max: '{fieldName} maksimal {max} karakter',
    },
  },

  inventory: {
    productName: 'Nama Produk',
    inventory: 'Gudang - Klien',
    firstPeriod: 'Periode Awal',
    initialStock: 'Stock Awal',
    lastPeriod: 'Periode Akhir',
    lastStock: 'Stock Akhir',
    baseUOM: 'Base UoM',
    date: 'Tanggal',
    changeType: 'Tipe Perubahan',
    changeStock: 'Perubahan Stok',
    period: 'Periode',
    stock_movement: {
      filter_by: 'Saring Berdasarkan',
      search_placeholder: 'Cari Nama Produk atau No SKU',
      choose_product: 'Pilih Nama Produk',
      choose_change_type: 'Pilih Tipe Perubahan',
      types: {
        inbound: 'Inbound',
        cancel_inbound: 'Batal Inbound',
        purchase_return: 'Retur Pembelian',
        cancel_order: 'Batal Pesanan',
        sales_return: 'Retur Penjualan',
        outbound: 'Outbound / Goods Issue',
        adjust_in: 'Penyesuaian Masuk',
        adjust_out: 'Penyesuaian Keluar',
      },
    },
    goods_receipt: {
      create_title: 'Buat Penerimaan Barang',
      create_desc: 'Anda dapat membuat Penerimaan Barang berdasarkan Dokumen Referensi (PO, dll) yang telah dibuat atau tanpa Dokumen Referensi.',
      without_ref: 'Tanpa Dokumen Referensi',
      use_po_ref: 'Gunakan Referensi Dokumen PO',
      placeholder_po: 'Masukkan Nomor PO',
      tooltip_disabled: 'PO sudah diterima penuh atau dibatalkan',
      btn_create: 'Buat GR',
      product: 'Produk',
      qty: 'Jumlah',
      uom: 'UOM',
      base_info: 'Info Base',
      base_qty: 'Base Qty',
      base_uom: 'Base UOM',
      stock_on_hand: 'Stok Tersedia',
      stock_change: 'Perubahan Stok',
      stock_after: 'Stok Setelah Berubah',
      detail_gr: 'Detail Penerimaan Barang',
      no_gr: 'No. Penerimaan Barang',
      gr_date: 'Tanggal GR',
      doc_ref: 'Nomor Dokumen Referensi',
      vendor_name: 'Nama Vendor',
      detail_item: 'Detail Item Produk',
      add_item: 'Tambah Item',
      bulk_import: 'Bulk Item Import',
      total_sku: 'Total SKU',
      qty_po: 'Jumlah Inbound Delivery',
      reference_detail: 'Detail Referensi',
      gr_detail: 'Detail GR',
      qty_ref_max: 'Qty Ref Max',
      uom_ref_max: 'UOM Ref Max',
      qty_gr: 'Qty GR',
      uom_gr: 'UOM GR',
      qty_inbound: 'Qty Ref',
      uom_inbound: 'UOM Ref',
      qty_outstanding: 'Qty Outstanding',
      uom_outstanding: 'UOM Outstanding',
      max_qty: 'Max Qty',
      batch_no: 'No. Batch',
      expired_date: 'Expired Date',
      stock_type: 'Tipe Stok',
      po_ref_doc: 'Referensi Dokumen PO',
      warehouse: 'Gudang',
      tooltip_cant_add: 'Tidak bisa menambah item baru jika menggunakan referensi dokumen PO',
      error_max_item: 'Jumlah item melebihi batas maksimal, batas maksimal adalah {max} item',
      error_qty_empty: 'Quantity tidak boleh kosong.',
      success_save: 'Data Berhasil Disimpan',
      failed_save: 'Data Gagal Disimpan, Coba Lagi.',
      failed_save_title: 'Gagal membuat GR',
      note: 'Catatan',
      import_items: 'Import Item',
      upload_desc: 'Sedang mengunggah file, {current}/{total} item sudah diimport',
      upload_placeholder: 'Upload file excel anda disini',
      upload_hint: 'Jika belum memiliki template file import items, silahkan klik tombol download file di kiri bawah.',
      warning: 'Peringatan',
      error_bulk_limit: 'Jumlah item yang diimport melebihi batas maksimum {max} item. Silahkan periksa file import anda.',
      download_template: 'Download Template',
      submit_all: 'Submit Semua Item',
      list_revised: 'Daftar Item Impor yang Direvisi',
      uploading: 'Sedang mengunggah file...',
      sku_not_found: 'SKU tidak ditemukan',
      uom_not_valid: 'UoM tidak valid',
      data_not_valid: 'Data tidak valid',
      close_no_download: 'Tutup Tanpa Download',
      close_download: 'Tutup dan Download Daftar Revisi',
      stock_list: {
        available: 'Available',
        quarantine: 'Quarantine',
        damage: 'Damage',
        wip: 'Work In Progress',
      },
      columns: {
        no: 'No',
        product_name: 'Nama Produk',
        sku: 'SKU',
        quantity: 'Jumlah',
        uom: 'UOM',
      },
    },
  },
  productAvailability: {
    search: 'Cari',
    productName: 'Nama Produk',
    vendorName: 'Nama Vendor',
    note: 'Catatan',
    productAvailability: 'Daftar Persediaan',
    goodsReceipt: 'Penerimaan Barang',
    gudang: 'Pilih Gudang',
    inbound: 'Buat Inbound',
    adjustment: 'Penyesuaian Stok',
    adjustmentType: 'Tipe Penyesuaian',
    allstatus: 'Semua Status',
    instock: 'Stok Tersedia',
    outofstock: 'Stok Habis',
    minusofstock: 'Stok Minus',
    movement: 'Riwayat Pemindahan',
    location: 'Lokasi',
    available: 'Available',
    allocated: 'Teralokasi',
    grDate: 'Tanggal GR',
    grAdjustment: 'Tanggal Penyesuaian',
    warningGr: 'Pilih Gudang Untuk Membuat Penerimaan Barang',
    warningReturn: 'Pilih Gudang Untuk Membuat Return Received',
    warningAdjustment: 'Pilih Gudang Untuk Membuat Penyesuaian Stok',
    warningTransfer: 'Pilih Gudang Untuk Membuat Transfer Stok',
    reference: 'No. Referensi Dokumen',
    adjustmentNumber: 'No. Penyesuaian',
    warehouseName: 'Nama Gudang',
    warehouseStock: 'Stok Gudang',
    inorder: 'On Order',
    safetyStock: 'Stok Pengaman',
    title: 'Nama Produk',
    sku: 'SKU',
    warehouseId: 'Nama Gudang',
    businessName: 'Nama Bisnis',
    availability: 'Available',
    allocatable: 'Stok dapat Dialokasikan',
    allocable: 'Dapat dialokasikan',
    movementQty: 'Jumlah Pergerakan',
    onHand: 'On Hand',
    inOrder: 'On Order',
    unit: 'Unit',
    updatedAt: 'Tanggal',
    IN_STOCK: 'Stok Tersedia',
    OUT_OF_STOCK: 'Stok Habis',
    MINUS_OF_STOCK: 'Stok Minus',
    warehouse: 'Gudang',
    stock: 'Stok',
    unit_label: 'Satuan',
    status: 'Status',
    movement_transaction: 'Movement Transaksi',
    product_detail: 'Detail Produk',
    hide_bundle_components: 'Sembunyikan Produk Pembentuk',
    show_bundle_components: 'Lihat Produk Pembentuk',
    soft_bundling_tooltip: 'Produk soft bundling tidak memiliki on-hand stok. Lihat produk pembentuk untuk melihat detail stok',
    soft_bundling_tooltip_order: 'Produk soft bundling tidak memiliki on-order stok. Lihat produk pembentuk untuk melihat detail stok',
    error_fetch_inventory: 'Gagal mengambil data inventory',
    export_failed: 'Export Data Gagal',
    export_failed_desc: 'Export Data Inventory gagal',
    soft_bundling: 'Soft Bundling',
    error_fetch_soft_bundling: 'Gagal mendapatkan data soft bundling',
    export_excel: 'Ekspor Excel',
    select_business: 'Pilih Bisnis',
    select_warehouse: 'Pilih Gudang',
    select_status: 'Pilih Status Stok',
    details: 'Detail',
    copy_success: '{value} berhasil disalin',
    stock_movement: 'Riwayat Stok',
    movement_type_select: 'Pilih Movement Type',
    enter_reff: 'Masukan Reff',
    sellable_stock: 'Dapat Dijual',
    sellable_stock_tooltip: 'Stok yang dapat dijual dan muncul di channel penjualan',
    on_order_tooltip: 'Stok pesanan dalam proses, sebelum dilakukan good issued',
    on_hand_tooltip: 'Stok yang berstatus available (termasuk stok yang dapat dijual maupun on order)',
    reserved_stock_tooltip: 'Stok yang dicadangkan untuk kebutuhan tertentu atau pesanan yang sedang diproses',
    movement_quantity: 'Jumlah Pergerakan',
    transaction: 'Transaksi',
    stock_movement_not_found: 'Data riwayat stok tidak ditemukan',
    no_data_filter: 'Tidak ada data berdasarkan filter yang dipilih.',
    total_data: 'Total Data',
    date_filter_label: 'Tanggal Pemesanan',
    movement_type_label: 'Movement Type',
    movement_status: {
      all: 'Semua Tipe Transaksi',
      good_receive: 'Good Receive',
      cancel_good_receive: 'Cancel Good Receive',
      good_issued: 'Good Issued',
      cancel_good_issued: 'Cancel Good Issued',
      adj_in: 'Adjustment In',
      adj_out: 'Adjustment Out',
      adj_booking: 'Adjustment Booking',
      booking_order: 'Booking Order',
      release_booking: 'Release Booking',
      transfer_in: 'Stock Transfer Warehouse In',
      transfer_out: 'Stock Transfer Warehouse Out',
      cancel_transfer_out: 'Batal Transfer Keluar',
      type_transfer_in: 'Stock Type Transfer In',
      type_transfer_out: 'Stock Type Transfer Out',
      ptp_in: 'Product to Product Transfer In',
      ptp_out: 'Product to Product Transfer Out',
      vas_inbound: 'VAS Inbound',
      vas_outbound: 'VAS Outbound',
      return: 'Return',
      cancel_return: 'Cancel Return',
      reserved: 'Adjustment Reserved',
    },
    ranges: {
      today: 'Hari ini',
      this_month: 'Bulan ini',
      this_year: 'Tahun ini',
      last_7_days: '7 Hari Terakhir',
      last_30_days: '30 Hari Terakhir',
      last_year: '1 Tahun Terakhir',
    },
    unknown_warehouse: '-[GUDANG TIDAK DIKENAL]-',
    allocation_saved: 'Alokasi Stok berhasil disimpan',
    enable_stock_push: 'Aktifkan stock push',
    allocation: 'Alokasi',
    channel: 'Channel',
    deleted_channel: '(channel dihapus)',
    stock_push_disabled_sku: 'Stock push dinonaktifkan untuk SKU ini',
    stock_push_enabled: 'Stock push: Diaktifkan',
    stock_push_disabled: 'Stock push: Dinonaktifkan',
    stock_push_label: 'Stock push',
    on_hand_stock: 'On Hand',
    allocated_stock: 'Stok allocated',
    sellable_stock_short: 'Stok sellable',
    allocation_history_tab: 'Riwayat',
    allocation_history_date: 'Tanggal',
    start_date: 'Tanggal Mulai',
    end_date: 'Tanggal Akhir',
    pagination_total: 'Menampilkan {start} - {end} dari {total} item',
    allocation_history_scope: 'Scope',
    allocation_history_channel: 'Channel',
    allocation_history_prev_status: 'Status Sebelumnya',
    allocation_history_new_status: 'Status Baru',
    allocation_history_user: 'Diubah Oleh',
    allocation_history_enabled: 'Aktif',
    allocation_history_disabled: 'Nonaktif',
    allocation_history_empty: 'Belum ada riwayat perubahan',
    allocation_history_error: 'Gagal memuat riwayat',
    allocation_history_warehouse: 'Gudang',
    allocation_history_channel_scope: 'Per Channel',
    allocation_history_warehouse_scope: 'Per Gudang',
    allocation_tab: 'Alokasi Stok',
    allocation_history_select_catalog: 'Pilih varian untuk melihat riwayat',
    allocation_history_select_warehouse: 'Pilih gudang untuk melihat riwayat',
    grNumber: 'No. GR',
    createGr: 'Buat GR',
    importGr: 'Impor GR',
    detailGr: 'Detail GR',
    uploadBulkGr: 'Upload Bulk GR',
    bulkGrSummary: 'Ringkasan Upload Bulk GR',
    downloadFailedData: 'Download Data Gagal',
    bulkImportGrDesc: 'Gunakan template ini untuk melakukan penerimaan barang secara massal. Pastikan format sesuai sebelum upload.',
    reserved_stock: 'Reserved',
    reserved_stock_tooltip: 'Stok yang dicadangkan (reserved) dan tidak dapat dijual',
    edit_reserved_stock: 'Edit Reserved',
    reserved_stock_history: 'Reserved History',
    reserved_stock_updated: 'Stok reserved berhasil diperbarui',
    tour_reserved_header_title: 'Kolom Reserved',
    tour_reserved_header_content: 'Melihat stok yang sudah dicadangkan (reserved) dan tidak tersedia untuk penjualan',
    tour_reserved_edit_title: 'Edit Manual',
    tour_reserved_edit_content: 'Klik ikon pensil untuk mengubah stok reserved',
    tour_bulk_reserved_title: 'Update Stok Reserved (Massal)',
    tour_bulk_reserved_content: 'Gunakan fitur Bulk Edit untuk memperbarui banyak stok reserved sekaligus melalui Excel',
    tour_paham: 'Oke, Paham',
    reserved_stock_update_failed: 'Gagal memperbarui Reserved',
    reserved_stock_reason: 'Alasan perubahan',
    reserved_stock_reason_placeholder: 'Masukkan alasan perubahan reserved',
    reserved_stock_reason_required: 'Alasan wajib diisi',
    reserved_stock_reason_max_chars: 'Maksimal 200 karakter',
    reserved_stock_exceed: 'Reserved tidak boleh melebihi Available Stock',
    reserved_stock_negative: 'Reserved harus 0 atau lebih',
    reserved_stock_max_digits: 'Maksimal 12 digit',
    reserved_stock_preview: 'Available Stock setelah perubahan',
    reserved_stock_current: 'Reserved Saat Ini',
    reserved_stock_new_value: 'Reserved Baru',
    reserved_stock_previous: 'Nilai Sebelumnya',
    reserved_stock_new: 'Nilai Baru',
    reserved_stock_changed_by: 'Diubah Oleh',
    reserved_stock_no_history: 'Belum ada riwayat perubahan',
    reserved_stock_quantity: 'Total Perubahan',
    reserved_stock_date: 'Tanggal',
    reserved_stock_movement_type: 'Tipe',
    reserved_in: 'Reserved In',
    reserved_out: 'Reserved Out',
    reserved_stock_from_upload: 'Dari Unggahan',
    reserved_stock_download_file: 'Unduh File',
  },
  reservedStock: {
    bulk_edit_reserved_stock: 'Bulk Edit Reserved Stock',
    upload_tab: 'Unggah',
    history_tab: 'Riwayat',
    download_template_title: '1. Download Template',
    download_template_desc: 'Unduh template file excel untuk mengisi data reserved stock yang akan diimpor.',
    upload_file_title: '2. Upload File',
    upload_excel_hint: 'Klik atau tarik file ke area ini untuk mengunggah',
    upload_excel_limit_hint: 'Mendukung unggahan tunggal. Harap gunakan template yang disediakan.',
    download_template: 'Download Template',
    uploading: 'Mengunggah...',
    start_import: 'Mulai Impor',
    processing: 'Memproses...',
    import_failed: 'Impor Gagal',
    import_successful: 'Impor Berhasil',
    total_rows: 'Total Baris',
    success_count: 'Berhasil',
    failed_count: 'Gagal',
    download_result_file: 'Unduh File Hasil',
    error_details_count: 'Detail Kesalahan ({count} baris)',
    error_table_row: 'Baris',
    error_table_sku: 'SKU',
    error_table_message: 'Pesan Kesalahan',
    history_table_col_info: 'Informasi Batch / SKU & Nama Produk',
    history_table_col_detail: 'Detail Progress / Keterangan',
    history_table_col_action: 'Aksi',
    loading_history: 'Memuat riwayat...',
    download_template_error: 'Gagal mengunduh template.',
    upload_success_processing: 'File berhasil diunggah. Memproses...',
    upload_error_title: 'Kesalahan Unggah',
    upload_error_failed: 'Gagal mengunggah file',
    import_process_errors: 'Proses impor menemukan kesalahan.',
    import_completed_success: 'Berhasil memproses {count} baris.',
    batch_detail_title: 'Detail Batch Reserved Stock',
    upload_time: 'Waktu Unggah',
    user: 'Pengguna',
    batch_status: 'Status Batch',
    download: 'Unduh',
    sku_product: 'SKU / Produk',
    warehouse: 'Gudang',
    value: 'Nilai',
    reason_msg: 'Alasan / Keterangan',
    status: 'Status',
    copy_sku: 'Salin SKU',
    copied: 'Tersalin!',
    copied_desc: 'SKU {sku} tersalin ke clipboard',
    search_placeholder: 'SKU / Nama Produk',
  },
  returnReceived: {
    title: 'Pengembalian Barang',
    createReturn: 'Buat Pengembalian Barang',
    detailReturn: 'Detail Pengembalian Barang',
    cancelReturn: 'Batalkan Pengembalian Barang',
    cancelConfirmTitle: 'Pembatalan Pengembalian Barang',
    cancelConfirmContent: 'Apakah Anda yakin ingin membatalkan Pengembalian Barang dengan no. {number}?',
    cancelSuccess: 'Pengembalian Barang Berhasil Dibatalkan',
    cancelFailed: 'Pengembalian Barang Gagal Dibatalkan',
    returnNumber: 'No. Pengembalian Barang',
    returnDate: 'Tgl. Pengembalian Barang',
    searchPlaceholder: 'Cari No. Pengembalian Barang / No. Order',
    detailCard: 'Detail Pengembalian Barang',
    itemCard: 'Detail Item Produk',
    totalSku: 'Total SKU',
    stockType: 'Tipe Stok',
    storeLabel: 'Toko',
    refDocRequired: 'No. Referensi Dokumen harus dipilih',
    warehouseRequired: 'Gudang harus dipilih',
    returnNoRequired: 'No. Pengembalian Barang harus diisi',
    status_return: 'Diterima',
    status_return_release: 'Dibatalkan',
  },
  account: {
    profile: 'Profil Anda',
    fullname: 'Nama Lengkap',
    noHp: 'No. Handphone',
    setPassword: 'Gunakan Kata Sandi yang Kuat',
    setting: 'Pengaturan Akun',
    password: 'Ubah Kata Sandi',
    placeholder: {
      current_password: 'Kata Sandi Saat Ini',
      new_password: 'Kata Sandi Baru',
      confirm_new_password: 'Konfirmasi Kata Sandi Baru',
    },
    validation: {
      password_mismatch: 'Kata Sandi tidak sama',
      current_password_required: 'Kata sandi saat ini tidak boleh kosong',
      new_password_required: 'Kata sandi baru tidak boleh kosong',
      confirm_password_required: 'Konfirmasi kata sandi baru tidak boleh kosong',
      email_required: 'Email wajib diisi',
      username_required: 'Username wajib diisi',
      fullname_required: 'Nama Lengkap wajib diisi',
      phone_required: 'No. Handphone wajib diisi',
    },
    messages: {
      update_success: 'Data Berhasil diupdate',
      password_changed: 'Password berhasil diubah',
    },
  },
  warehouse: {
    list_warehouse: 'Daftar Gudang',
    export_data: 'Export Data',
    add_warehouse: 'Tambah Gudang',
    detail_warehouse: 'Detail Gudang',
    edit_warehouse: 'Ubah Gudang',
    name_warehouse: 'Nama Gudang',
    ext_code: 'Kode Eksternal',
    code_warehouse: 'Kode Gudang',
    search: 'Cari',
    placeholder_search: 'Cari...',
    category_warehouse: 'Kategori Gudang',
    address: 'Alamat',
    status: 'Status',
    action: 'Aksi',
    information_warehouse: 'Informasi Gudang',
    address_warehouse: 'Alamat Gudang',
    integration_warehouse: 'Integrasi Gudang',
    connected_with: 'Terkoneksi dengan',
    update_warehouse: 'Ubah Gudang',
    editWarehouseData: 'Ubah Data Gudang',
    manageProducts: 'Atur Produk',
    warehouseName: 'Nama Gudang',
    warehouseCode: 'Kode Gudang',
    externalCode: 'Kode Eksternal',
    warehousePIC: 'PIC Gudang',
    phoneNumber: 'Nomor Handphone',
    country: 'Negara',
    city: 'Kota',
    subDistrict: 'Kecamatan',
    postalCode: 'Kodepos',
    province: 'Provinsi',
    district: 'Kecamatan',
    please_select_city: 'Harap Pilih Kota',
    not_connected_wms: 'Tidak Terkoneksi Warehouse Management System',
    connected_javelin: 'Terkoneksi dengan Javelin',
    connected_jubelio: 'Terkoneksi dengan Jubelio',
    auth_key: 'Auth Key',
    secret_key: 'Secret Key',
    api_url: 'API URL',
    username: 'Username',
    password: 'Password',
    success_save: 'Data Berhasil di Simpan',
    validation: {
      name_required: 'Nama Gudang Tidak Boleh Kosong',
      name_exist: 'Nama Gudang sudah ada',
      code_required: 'Kode Gudang Tidak Boleh Kosong',
      code_exist: 'Kode Gudang sudah digunakan',
      ext_code_required: 'Kode Eksternal Tidak Boleh Kosong',
      ext_code_exist: 'Kode Eksternal sudah digunakan',
      pic_required: 'PIC Tidak Boleh Kosong',
      phone_required: 'Nomor Handphone Tidak Boleh Kosong',
      country_required: 'Negara Tidak Boleh Kosong',
      city_required: 'Kota Tidak Boleh Kosong',
      district_required: 'Kecamatan Tidak Boleh Kosong',
      province_required: 'Provinsi Tidak Boleh Kosong',
      postal_code_required: 'Kode Pos Tidak Boleh Kosong',
      address_required: 'Alamat Tidak Boleh Kosong',
      auth_key_required: 'Auth Key Tidak Boleh Kosong',
      secret_key_required: 'Secret Key Tidak Boleh Kosong',
      api_url_required: 'API URL Tidak Boleh Kosong',
      username_required: 'Username Tidak Boleh Kosong',
      password_required: 'Password Tidak Boleh Kosong',
    },
    placeholder: {
      name: 'Nama gudang',
      code: 'Kode gudang',
      ext_code: 'Kode eksternal',
      pic: 'PIC',
      phone: 'No. Handphone',
      auth_key: 'Masukan Auth Key',
      secret_key: 'Masukan Secret Key',
      api_url: 'Masukan API URL',
      username: 'Masukan Username',
      password: 'Masukan Password',
    },
    setup_product: {
      title: 'Atur Produk',
      question: 'Apakah Anda ingin mendaftarkan seluruh produk Anda ke gudang: <b>{name}</b>?',
      this_warehouse: 'ini',
      all_products: 'Ya, semua produk',
      some_products: 'Tidak, hanya beberapa produk',
      or: 'Atau',
      setup_later: 'Atur Nanti',
      setup_later_desc: 'Anda dapat mengatur produk melalui menu <b>Daftar Gudang &#8594; Atur Produk</b>',
      btn_cancel: 'Batal',
      btn_next: 'Lanjut',
      success_add: 'Produk berhasil ditambahkan',
      failed_title: 'Gagal',
      failed_desc: 'Terjadi kesalahan saat menambahkan produk ke gudang.',
      error_wh_not_found: 'Warehouse id tidak ditemukan',
    },
    streetAddress: 'Alamat',
    warehouseConnection: 'Koneksi Gudang',
    notConnected: 'Tidak Terkoneksi',
  },
  discount: {
    discount: 'Diskon',
    search: 'Cari Diskon',
    createDiscount: 'Tambah Diskon',
    latest: 'Data Terbaru',
    program_name: 'Nama Program',
    promotionName: 'Nama Program',
    discount_level: 'Tier Diskon',
    period: 'Periode',
    quota: 'Kuota',
    status: 'Status',
    all: 'Semua',
    waiting_approval: 'Menunggu Persetujuan',
    active: 'Aktif',
    not_active: 'Tidak Aktif',
    sort_by: 'Sortir',
    order_by: 'Urutan',
    newest: 'Terbaru',
    oldest: 'Terlama',
    basic_details: 'Rincian Dasar',
    promotion_target: 'Target Promosi',
    setting_promotion: 'Pengaturan Promosi',
    start_date: 'Waktu Mulai',
    end_date: 'Waktu Berakhir',
    promotion_type: 'Tipe Promosi',
    select_type: 'Pilih Tipe Promosi',
    select_level: 'Pilih Tier Diskon',
    national_program: 'Program Nasional',
    local_program: 'Program Lokal',
    distributor_program: 'Program Distributor',
    program_type: 'Tipe Program',
    select_program: 'Pilih Tipe Program',
    product_type: 'Tipe Produk',
    product_item: 'Item Produk',
    select_item: 'Pilih Item Produk',
    product_category: 'Kategori Produk',
    product_brand: 'Brand Produk',
    promotion_quota: 'Kuota Promosi',
    program_buy: 'Tipe Program & Pembelian',
    discount_format: 'Format Diskon',
    promotion_value: 'Nilai Promosi',
    promotion: 'Promosi',
    process: 'Proses',

    select: 'Pilih',
    all: 'Semua',
    products: 'Produk',
    transaction: 'Transaksi',
    purchase_range: 'Rentang Pembelian',
    min_qty: 'Min. Qty',
    max_qty: 'Maks. Qty',
    min_trx: 'Min. Transaksi',
    max_trx: 'Maks. Transaksi',
    uom: 'UoM',
    promotion_format: 'Format Promosi',
    percentage: 'Persentase',
    currency: 'Mata Uang',
    fixed: 'Nominal',
    product: 'Ekstra Barang',
    product_name: 'Nama Produk',
    discount_max: 'Nilai Maks. Diskon',
    add_promotion: 'Tambah Promosi',
    voucher: 'Voucher',
    edit: 'Ubah Diskon',
    coin: 'Koin',
    coin_value: 'Nilai Koin',
    promo_cancellation: 'Pembatalan Promo',
    cancellation_description:
      'Dengan membatalkan Promo {value}, maka promo akan berstatus tidak aktif dan tidak dapat digunakan',
    choose_cancellation: 'Pilih alasan untuk membatalkan promo ini',
    write_reason: 'Tulis alasan lain disini',
    inactive: 'Tidak Aktif',
    createdAt: 'Tanggal Buat',
    promotion_criteria: 'Kriteria Promo',
    purchase_transaction: 'Jumlah Transaksi Pembelian',
    purchase_quantity: 'Jumlah Kuantitas Pembelian',
    promo_type: 'Tipe Kriteria Promo',
    select_promo_type: 'Pilih Tipe Kriteria Promo',
    range_promo: 'Kisaran',
    multiple_promo: 'Kelipatan',
    multiple_value: 'Nilai Kelipatan',
    approval_title: 'Persetujuan Diskon & Voucher',
    cancellation_reason: 'Alasan Pembatalan',
    add_tier: 'Tambah Tier',
    approve: 'Terima',
    cancel_promo: 'Batalkan',
    gift: 'Hadiah',
    qty: 'Kuantitas',
    error_min_max: 'Min lebih besar Max',
    error_max_min: 'Max lebih kecil Min',
    search_select_product: 'Cari & Pilih Produk',
    search_select_item: 'Cari & Pilih Item Produk',
    rules: {
      program_name_required: 'Nama Program harus diisi',
      start_date_required: 'Waktu Mulai harus dipilih',
      end_date_required: 'Waktu Berakhir harus dipilih',
      promotion_type_required: 'Tipe Promosi harus dipilih',
      discount_level_required: 'Tingkat Diskon harus dipilih',
      program_type_required: 'Tipe Program harus dipilih',
      promo_criteria_type_required: 'Tipe Kriteria Promo harus dipilih',
      voucher_code_required: 'Kode Voucher harus diisi',
      uom_required: 'UoM harus dipilih',
      discount_format_required: 'Format Diskon harus dipilih',
      currency_required: 'Mata Uang harus dipilih',
      product_required: 'Produk harus dipilih',
      input_required: 'Inputan harus diisi',
      input_not_zero: 'Inputan tidak boleh 0',
      quota_exceed: 'Quota tidak boleh lebih dari {quota}',
      area_required: 'Area harus dipilih',
      seller_required: 'Penjual harus dipilih',
      customer_category_required: 'Kategori Pelanggan harus dipilih',
      customer_required: 'Pelanggan harus dipilih',
      product_type_required: 'Tipe Produk harus dipilih',
      product_item_required: 'Item Produk harus dipilih',
      product_category_required: 'Kategori Produk harus dipilih',
      product_brand_required: 'Brand Produk harus dipilih',
    },
    discount_list: 'Daftar Diskon',
    detail_discount: 'Detail Diskon',
    edit_discount: 'Edit Diskon',
    add_discount: 'Tambah Diskon',
    duplicate_discount: 'Duplikat Diskon',
    area: 'Area',
    seller: 'Penjual',
    seller_description: 'Tentukan penjual berdasarkan area dan penjual',
    customer: 'Pelanggan',
    customer_category: 'Kategori Pelanggan',
    customer_description: 'Tentukan pelanggan berdasarkan kategori dan pelanggan',
    search_select_area: 'Cari & Pilih Area',
    select_all_area: 'Pilih Semua Area',
    search_select_seller: 'Cari & Pilih Penjual',
    select_all_seller: 'Pilih Semua Penjual',
    select_all_category: 'Pilih Semua Kategori',
    search_select_customer_category: 'Cari & Pilih Kategori Pelanggan',
    search_select_customer: 'Cari & Pilih Pelanggan',
    select_all_customer: 'Pilih Semua Pelanggan',
    search_select_product_category: 'Cari & Pilih Kategori Produk',
    search_select_product_brand: 'Cari & Pilih Brand Produk',
    add_promotion: 'Tambah Promosi',
    add_gift: 'Tambah Hadiah',
  },
  voucher: {
    voucher: 'Voucher',
    createvoucher: 'Tambah Voucher',
    latest: 'Data Terbaru',
    allstatus: 'Semua',
    search: 'Cari Voucher',
    sort: 'Urutkan',
    waiting: 'Menunggu Persetujuan',
    active: 'Aktif',
    nonactive: 'Tidak Aktif',
    codeTypeVoucher: 'Kode & Tipe Voucher',
    create_voucher: 'Tambah Voucher',
    edit_voucher: 'Ubah Voucher',
    voucher_lists: 'Daftar Voucher',
    voucher_name: 'Nama Voucher',
    voucher_code: 'Kode Voucher',
    voucher_get: 'Periode Mendapatkan Voucher',
    voucher_usage: 'Periode Penggunaan Voucher',
    same_period: 'Sama dengan masa berlaku Voucher',
    voucher_combined: 'Voucher dapat dikombinasikan',
    edit: 'Ubah Voucher',
    promo_cancellation: 'Pembatalan Voucher',
    cancellation_description:
      'Dengan membatalkan Voucher {value}, maka voucher akan berstatus tidak aktif dan tidak dapat digunakan',
    choose_cancellation: 'Pilih alasan untuk membatalkan voucher ini',
    write_reason: 'Tulis alasan lain disini',
    inactive: 'Dibatalkan',
    add_voucher: 'Tambah Voucher',
    edit_voucher: 'Ubah Voucher',
    detail_voucher: 'Detail Voucher',
    customer: 'Pelanggan',
    seller: 'Penjual',
    seller_target_desc: 'Tentukan penjual berdasarkan area dan penjual',
    area: 'Area',
    search_select_area: 'Cari & Pilih Area',
    select_all_area: 'Pilih Semua Area',
    search_select_seller: 'Cari & Pilih Penjual',
    select_all_seller: 'Pilih Semua Penjual',
    customer_target_desc: 'Tentukan pelanggan berdasarkan kategori dan pelanggan',
    customer_category_label: 'Kategori Pelanggan',
    search_select_customer_category: 'Cari & Pilih Kategori Pelanggan',
    select_all_customer_category: 'Pilih Semua Kategori',
    search_select_customer: 'Cari & Pilih Pelanggan',
    select_all_customer: 'Pilih Semua Pelanggan',
    search_select_category: 'Cari & Pilih Kategori Produk',
    search_select_brand: 'Cari & Pilih Brand Produk',
    add_promotion: 'Tambah Promosi',
    edit: 'Ubah',
    delete: 'Hapus',
    error_promotion_required: 'Daftar Promosi tidak boleh kosong',
    success: 'Berhasil',
    success_create: 'Voucher Berhasil dibuat',
    failed: 'Gagal',
    error_403_create: 'Anda tidak memiliki Hak Akses untuk membuat Voucher',
    failed_create: 'Voucher Gagal dibuat',
    rule_area_required: 'Area harus dipilih',
    rule_seller_required: 'Penjual harus dipilih',
    rule_customer_category_required: 'Kategori Pelanggan harus dipilih',
    rule_customer_required: 'Pelanggan harus dipilih',
    rule_product_type_required: 'Tipe Produk harus dipilih',
    rule_product_item_required: 'Item Produk harus dipilih',
    rule_product_category_required: 'Kategori Produk harus dipilih',
    rule_product_brand_required: 'Brand Produk harus dipilih',
    duplicate_voucher_error: 'Voucher tersebut telah tersedia. Silakan cek voucher tersebut pada daftar promo untuk menghindari duplikat promo',
  },
  redeem: {
    redeem_product: 'Produk Redeem',
    search: 'Cari Produk',
    stock: 'Stok',
    redeem_count: 'Jumlah Redeem',
    minimum: 'Minimum',
    maximum: 'Maksimum',
    reset_filter: 'Bersihkan Filter',
    apply: 'Terapkan',
    category: 'Kategori',
    variant: 'Varian',
    status: 'Status',
  },
  addDiscount: {
    basic: 'Rincian Dasar',
    programName: 'Nama Program',
    startDate: 'Waktu Mulai',
    endDate: 'Waktu Berakhir',
    promotionType: 'Tipe Promosi',
    rate: 'Tingkat Diskon',
    target: 'Target Promosi',
    area: 'Area',
    distributor: 'Distributor',
    shopType: 'Tipe Toko',
    shop: 'Toko',
    programType: 'Tipe Program',
    productType: 'Tipe Produk',
    settingPromo: 'Pengaturan Promosi',
    itemProduct: 'Item Produk',
    kuota: 'Kuota Promosi',
    typeBuy: 'Tipe Program & Pembelian',
    format: 'Format Diskon',
    nilaiPromosi: 'Nilai Promosi',
    promotion: 'Promosi',
    addPromotion: 'Tambah Promosi',
    purchaseRange: 'Rentang Pembelian',
    promotionFormat: 'Format Promosi',
  },
  addVoucher: {
    basic: 'Rincian Dasar',
    voucherName: 'Nama Voucher',
    voucherCode: 'Kode Voucher',
    startDate: 'Waktu Mulai',
    endDate: 'Waktu Berakhir',
    voucherType: 'Tipe Voucher',
    rate: 'Tingkat Diskon',
    target: 'Target Promosi',
    area: 'Area',
    distributor: 'Distributor',
    shopType: 'Tipe Toko',
    shop: 'Toko',
    cutType: 'Tipe Potongan',
    productType: 'Tipe Produk',
    settingVoucher: 'Pengaturan Voucher',
    itemProduct: 'Item Produk',
    kuota: 'Kuota Promosi',
    typeBuy: 'Tipe Program & Pembelian',
    format: 'Format Diskon',
    nilaiPromosi: 'Nilai Promosi',
    periode: 'Periode',
    addPromotion: 'Tambah Promosi',
    purchaseRange: 'Rentang Pembelian',
    promotionFormat: 'Format Promosi',
    usageQuota: 'Kuota Pemakaian',
    minimumReq: 'Persyaratan Minimum',
  },
  finance: {
    list_transfer: 'Daftar Bukti Transfer',
    search: 'Cari Bukti Transfer',
    pay_number: 'No. Pembayaran',
    method: 'Metode',
    total_bill: 'Total Tagihan',
    rest_of_bill: 'Sisa Tagihan',
    payment_deadline: 'Tanggal Request',
    payment_status: 'Status Pembayaran',
    invoice_number: 'No. Invoice',
    customer_name: 'Nama Pelanggan',
    order_number: 'No. Order',
    payment_confirm: 'Konfirmasi',
    payment_reject: 'Tolak Bukti Transfer',
    transaction_detail: 'Detail Transaksi',
    order_id: 'ID Order',
    transaction_date: 'Tanggal Transaksi',
    bill_amount: 'Jumlah Tagihan',
    discount_use: 'Pemakaian Diskon',
    point_use: 'Pemakaian Poin',
    payment_date: 'Tanggal Bayar',
    payment_type: 'Tipe Pembayaran',
    bank_name: 'Nama Bank',
    account_number: 'Nomor Rekening',
    transfer_evidence: 'Bukti Transfer',
    input_payment: 'Nominal Pembayaran',
    mistake: 'Kesalahan',
    select_mistake: 'Pilih Kesalahan',
    expired_date: 'Tanggal Expired',
    payment_amount: 'Nominal Pembayaran',
    need_confirmation: 'Perlu Konfirmasi',
    confirmed: 'Sudah di Konfirmasi',
    waiting: 'Perlu Konfirmasi',
    cancelled: 'Dibatalkan',
    rejected: 'Ditolak',
    outstanding: 'Outstanding',
    confirm_transfer: 'Konfirmasi Bukti Transfer',
    payment_history: 'Riwayat Pembayaran',
    create_payment: 'Buat Pembayaran',
    total_pay: 'Total Bayar',
    pay_date: 'Tanggal Bayar',
    pay_method: 'Metode Pembayaran',
    pay_name: 'Nama Pembayaran',
    order_detail: 'Detail Order',
    create: 'Buat',
    account_name: 'Nama Rekening',
    payout_bank_name: 'Payout Bank Name',
    payout_account_number: 'Payout Account Number',
    payout_account_name: 'Nama Akun Payout',
    selectSeller: 'Pilih seller',
    selectSellerFirst: 'Pilih seller terlebih dahulu',
    distributor: 'Distributor',
    order: 'Order',
    paymentTerm: 'Termin Pembayaran',
    errorOccurred: 'Terjadi kesalahan',
    failedLoadDistributor: 'Gagal memuat data distributor seller',
    nominalRequired: 'Nominal tidak boleh kosong',
    nominalMismatch: 'Nominal tidak boleh kurang atau lebih dari total tagihan',
    mistakeOptions: {
      option1: 'Pembayaran sudah masuk, bukti salah',
      option2: 'Pembayaran belum masuk, bukti benar',
      option3: 'Pembayaran belum masuk, bukti salah',
    },
    statusOptions: {
      all: 'Semua',
      needConfirmation: 'Perlu Konfirmasi',
      confirmed: 'Sudah di Konfirmasi',
      cancelled: 'Dibatalkan',
      rejected: 'Ditolak',
    },
    payment_type_bank_transfer: 'Transfer Bank',
  },
  withdrawal: {
    distributor_wallet: 'Wallet Distributor',
    withdraw_wallet: 'Tarik Wallet',
    history_wallet: 'Riwayat Wallet',
    estimated_balance: 'Estimasi Total Saldo berikutnya',
    disclaimer_balance: 'Nilai total saldo diatas, belum termasuk biaya-biaya lain yang berlaku',
    total_balance: 'Total Saldo',
    withdrawal_history: 'Riwayat Penarikan',
    request_date: 'Tanggal Permintaan',
    nominal: 'Nominal',
    date: 'Tanggal',
    status: 'Status',
    request_id: 'ID Request',
    bank_details: 'Detail Bank',
    bank_name: 'Nama Bank',
    bank_account: 'Akun Bank',
    account_number: 'Nomor Rekening',
    account_name: 'Nama Akun',
    benificiary_name: 'Nama Penerima',
    processing_date: 'Tanggal Proses',
    withdrawal_form: 'Form Request Penarikan',
    withdrawal_amount: 'Jumlah Penarikan',
    minimum_withdrawal: 'Minimal penarikan',
    withdrawal_fee: 'Biaya penarikan',
    data_correct: 'Semua data sudah sesuai',
    select_bank: 'Pilih Bank',
    all: 'Semua',
    draft: 'Dalam Pengajuan',
    confirmed: 'Disetujui',
    canceled: 'Dibatalkan',
    completed: 'Selesai',
    approved: 'Disetujui',
    rejected: 'Ditolak',
    processed: 'Dalam Proses',
    failed: 'Gagal',
    terms1: 'Maksimal penarikan {max_frequency}x dalam {frequency_time_value} {frequency_time_unit}',
    terms2: 'Proses transfer dilakukan maksimal 2x24 jam setelah request dikirim',
    terms3: 'Minimum penarikan {min_amount} dan maksimum penarikan {max_amount}',
    text_min_amount: 'Minimum penarikan {min_amount}',
    text_max_amount: 'Maksimum penarikan {max_amount}',
    month: 'bulan',
    week: 'minggu',
    error_amount_exceed_balance: 'Jumlah Penarikan tidak boleh lebih dari Saldo',
    add_bank: 'Tambah Bank',
    day: 'hari',
  },
  helpdesk_page: {
    title: 'Ada yang bisa kita bantu?',
    info: `Apabila Anda memerlukan bantuan silahkan hubungi CS Kino Siap \ndi nomor handphone atau alamat email yang tertera.`,
  },
  error: {
    CL_NOT_ELIGIBLE: 'Kredit limit tidak memenuhi syarat',
    CL_INSUFFICIENT: 'sisa kredit limit tidak mencukupi',
    CL_EXCEED_MULTIPLEBOND: 'Kesempatan untuk hutang sudah habis',
    CL_OVERDUE: 'Ada transaksi yang sudah jatuh tempo',
    WP_NOT_FOUND: 'Tidak ada transaksi yang menunggu pembayaran',
  },
  tiktok: {
    categoryMaster: 'Kategori Produk Utama',
    categoryTiktok: 'Kategori Produk Tiktok',
    categoryShopee: 'Kategori Produk Shopee',
    categoryToco: 'Kategori Produk Toco',
    description:
      'Unggah size chart yang dimiliki produk. Dimensi foto minimal {minWidth}x{minHeight} px. Ukuran file maksimal 1MB. Dengan format JPG, JPEG, PNG, BMP, GIF.',
    garansi: 'Masa Garansi',
    policy: 'Kebijakan Garansi',
  },
  adjustment: {
    stock: 'Penyesuaian Stok',
    create: 'Buat Penyesuaian',
    id: 'Nomor Penyesuaian',
    date: 'Tanggal Penyesuaian',
    type: 'Tipe Penyesuaian',
    search: 'Cari Penyesuaian',
    detail: 'Detail Penyesuaian',
    chooseType: 'Pilih Tipe Penyesuaian',
    note: 'Catatan',
    see_more: 'Lihat selengkapnya',
    detailItem: 'Detail Item Produk',
    addItem: 'Tambah Item',
    stockAvailable: 'Stok Tersedia',
    stockChanges: 'Perubahan Stok',
    stockAfterChange: 'Stok Setelah Perubahan',
    adjust: 'Sesuaikan',
    sync: 'Sinkronisasi Stok',
    choose_sync_warehouse: 'Pilih gudang yang akan disinkronkan stoknya',
    all_warehouse: 'Semua Gudang',
    is_syncing: 'Sedang mensinkronisasi',
    last_sync: 'Sinkronisasi terakhir',
    actor: 'Dilakukan Oleh',
    adjustIn: 'Adjust In',
    adjustOut: 'Adjust Out',
    bulkImport: 'Bulk Item Import',
    notValidData: 'Beberapa data tidak valid',
    importSuccess: 'Semua Data Berhasil di Import',
    qtyExceed: 'Tidak boleh melebihi Stok Tersedia',
    itemExist: 'Item sudah ada',
    importItems: 'Impor Item',
    uploading: 'Sedang mengunggah file...',
    uploadExcel: 'Unggah file excel Anda di sini',
    downloadTemplateHint: 'Jika belum memiliki template file impor item, silakan klik tombol unduh file di kiri bawah.',
    submitItems: 'Kirim Semua Item',
    revisedListTitle: 'Daftar Perbaikan Item Impor',
    skuNotFound: 'SKU tidak ditemukan',
    uomNotValid: 'UOM tidak valid',
    dataNotValid: 'Data tidak valid',
    closeNoDownload: 'Tutup Tanpa Unduh',
    closeDownloadRevised: 'Tutup dan Unduh Daftar Perbaikan',
    revisedStatus: 'Status Perbaikan',
  },
  channel: {
    category: {
      default: 'Kategori Channel',
      tiktok: 'Kategori Produk Tiktok',
      tiktok_id: 'Kategori Produk Tiktok',
      tokopedia_id: 'Kategori Produk Tokopedia',
      shopee_id: 'Kategori Produk Shopee',
      toco_id: 'Kategori Produk Toco',
    },
    product: {
      tiktok: 'Produk Tiktok',
      tiktok_id: 'Produk Tiktok',
      tokopedia_id: 'Produk Tokopedia',
      shopee_id: 'Produk Shopee',
      toco_id: 'Produk Toco',
    },
  },
  po: {
    title: 'Atur Inbound Delivery',
    create: 'Buat Inbound Delivery',
    search_placeholder: 'Cari No Inbound Delivery...',
    sort_po_date_newest: 'Tanggal Inbound Delivery, Terbaru',
    sort_po_date_oldest: 'Tanggal Inbound Delivery, Terlama',
    sort_created_at_newest: 'Tanggal Dibuat, Terbaru',
    sort_created_at_oldest: 'Tanggal Dibuat, Terlama',
    sort_number_asc: 'Nomor Inbound Delivery, A-Z',
    sort_number_desc: 'Nomor Inbound Delivery, Z-A',
    sort_supplier_asc: 'Supplier Inbound Delivery, A-Z',
    sort_supplier_desc: 'Supplier Inbound Delivery, Z-A',
    create_gr: 'Buat GR',
    cancel: 'Batalkan Inbound Delivery',
    cancel_confirm: 'Ya, batalkan Inbound Delivery',
    cancel_success: 'Inbound Delivery berhasil dibatalkan',
    cancel_description: 'Apakah Anda yakin akan membatalkan Inbound Delivery ini?',
    created: 'Dibuat',
    partial_received: 'Diterima Sebagian',
    full_received: 'Diterima',
    unreceived: 'Belum Diterima',
    canceled: 'Dibatalkan',
    columns: {
      number: 'Nomor Inbound Delivery',
      po_date: 'Tanggal Inbound Delivery',
      supplier_do: 'Nomor Surat Jalan',
      delivery_date: 'Tanggal Pengiriman',
      supplier: 'Supplier',
      warehouse: 'Gudang',
      created_by: 'Dibuat Oleh',
      created_at: 'Tanggal Dibuat',
      status: 'Status',
      detail_po: 'Detail Inbound Delivery',
      qty_po: 'Qty Inbound Delivery',
      uom_po: 'UOM Inbound Delivery',
      qty_gr: 'Qty GR',
      qty_received: 'Qty Diterima',
    },
    detail_title: 'Inbound Delivery',
    loading_detail: 'Mohon tunggu, sedang memuat data Inbound Delivery...',
    loading_create: 'Mohon tunggu, sedang membuat Inbound Delivery...',
    input_po_number: 'Masukan nomor Inbound Delivery',
    input_po_date: 'Masukan tanggal Inbound Delivery',
    input_delivery_number: 'Masukan nomor surat jalan',
    input_delivery_date: 'Masukan tanggal pengiriman',
    select_supplier: 'Pilih supplier',
    select_warehouse: 'Pilih gudang',
    no_supplier_found: 'tidak menemukan supplier?',
    add_supplier: 'Tambah Supplier',
    select_warehouse_warning: 'Harap pilih gudang sebelum menambahkan produk',
    error_failed_create: 'Maaf, gagal membuat Inbound Delivery.',
    error_no_product: 'Tambahkan produk terlebih dahulu, minimal 1 produk.',
    error_qty_empty: 'Jumlah produk / quantity tidak boleh kosong.',
    error_batch_empty: 'Batch Number tidak boleh kosong.',
    error_expired_empty: 'Expired Date tidak boleh kosong.',
    success_created: 'Inbound Delivery Berhasil Dibuat',
    batch_no: 'No. Batch',
    expired_date: 'Expired Date',
    stock_type: 'Tipe Stok',
    po_number_required: 'Nomor Inbound Delivery harus diisi',
    po_date_required: 'Tanggal Inbound Delivery harus diisi',
    delivery_date_required: 'Tanggal Pengiriman harus diisi',
    supplier_required: 'Supplier harus diisi',
    warehouse_required: 'Gudang harus diisi',
    revised_list: 'Daftar Revisi Item',
    close_no_download: 'Tutup tanpa Unduh',
    close_download_revised: 'Tutup dan Unduh Daftar Item yang Direvisi',
    repush_to_javelin: 'Repush ke Javelin',
    repush_to_javelin_success: 'Repush ke Javelin Berhasil',
    repush_to_javelin_failed: 'Repush ke Javelin Gagal',
  },
  transferStock: {
    title: 'Transfer Stok',
    detailTitle: 'Transfer Stok - Detail',
    createTitle: 'Transfer Stok - Buat Request',
    createButton: 'Buat Transfer Stok',
    searchPlaceHolder: 'Nomor Transfer',
    optionGudang: 'Pilih Gudang',
    sortByNewest: 'Tanggal Terbaru',
    sortByOldest: 'Tanggal Terlama',
    columns: {
      date: 'Tanggal',
      number: 'Nomor Transfer',
      referenceNumber: 'Nomor Referensi',
      sourceWarehouse: 'Gudang Asal',
      destinationWarehouse: 'Gudang Tujuan',
      sender: 'Pengirim',
      receiver: 'Penerima',
      status: 'Status',
      no: 'No',
      catalog: 'SKU/Katalog',
      unit: 'Unit',
      quantity: 'Qty',
      qtyAvailable: 'Qty Tersedia',
      qtyTransfer: 'Qty Transfer',
      qtyShipped: 'Qty Dikirim',
      qtyReceived: 'Qty Diterima',
    },
    actions: {
      viewDetail: 'Lihat Detail',
      send: 'Kirim',
      receive: 'Terima',
      cancel: 'Batalkan',
      printSJ: 'Cetak Surat Jalan',
    },
    labels: {
      detailCardTitle: 'Detail Transfer',
      itemCardTitle: 'Item Transfer',
      numberLabel: 'No. Transfer',
      referenceNumberLabel: 'No. Referensi',
      dateLabel: 'Tanggal',
      warehouseFromLabel: 'Gudang (Dari)',
      warehouseToLabel: 'Gudang (Ke)',
      noteLabel: 'Catatan',
      createdAt: 'Dibuat',
      createdBy: 'Oleh',
      sentAt: 'Dikirim',
      senderLabel: 'Pengirim',
      receiptAt: 'Diterima',
      receiverLabel: 'Penerima',
      sortBy: 'Urutkan',
    },
    filters: {
      startDate: 'Tanggal Mulai',
      endDate: 'Tanggal Akhir',
    },
    datePresets: {
      today: 'Hari Ini',
      thisMonth: 'Bulan Ini',
      thisYear: 'Tahun Ini',
      last7Days: '7 Hari Terakhir',
      last30Days: '30 Hari Terakhir',
      last1Year: '1 Tahun Terakhir',
    },
    itemColumns: {
      no: 'No',
      catalog: 'SKU/Catalog',
      quantity: 'Qty',
      unit: 'Unit',
      qtyReceived: 'Qty Diterima',
    },
    messages: {
      copy: 'Salin',
      copySuccess: 'Nomor transfer disalin',
      copyError: 'Gagal menyalin nomor transfer',
      copyReferenceSuccess: 'Nomor referensi disalin',
      copyReferenceError: 'Gagal menyalin nomor referensi',
      warningSelectWarehouse: 'Pilih Gudang Untuk Membuat Transfer Stok',
    },
    confirm: {
      sendTitle: 'Konfirmasi Pengiriman',
      sendContent: 'Apakah Anda yakin ingin mengirim transfer {value}?',
      receiveTitle: 'Konfirmasi Penerimaan',
      receiveContent: 'Apakah Anda yakin ingin menerima transfer {value}?',
      cancelTitle: 'Konfirmasi Pembatalan',
      cancelContent: 'Apakah Anda yakin ingin membatalkan transfer {value}?',
      okSend: 'Ya, Kirim',
      okReceive: 'Ya, Terima',
      okCancel: 'Ya, Batalkan',
      cancelText: 'Tidak',
      changeWarehouseTitle: 'Ganti Gudang?',
      changeWarehouseContent: 'Mengubah gudang akan menghapus semua item yang sudah diinput. Lanjutkan?',
    },
    success: {
      send: 'Transfer berhasil dikirim',
      receive: 'Transfer berhasil diterima',
      cancel: 'Transfer berhasil dibatalkan',
    },
    error: {
      send: 'Gagal mengirim transfer',
      receive: 'Gagal menerima transfer',
      cancel: 'Gagal membatalkan transfer',
      qtyExceeded: 'Qty melebihi stok tersedia di gudang asal',
      qtyExceededOnSubmit: 'Tidak bisa simpan: terdapat item melebihi stok tersedia',
      qtyNegative: 'Qty tidak boleh negatif',
      availabilityNegative: 'Stok tersedia negatif, item tidak valid',
      availabilityNegativeOnSubmit: 'Tidak bisa simpan: terdapat item dengan stok negatif',
      forbiddenSource: 'Anda tidak memiliki akses ke gudang asal ini',
      forbiddenDestination: 'Anda tidak memiliki akses ke gudang tujuan ini',
    },
    placeholders: {
      selectProduct: 'Pilih Produk',
      noteOptional: 'Tambahkan keterangan (opsional)',
      referenceNumberOptional: 'Masukkan nomor referensi',
      driverName: 'Nama Sopir',
      vehicleNumber: 'Nomor Mobil',
    },
    buttons: {
      addRow: 'Tambah Item',
      saveTransfer: 'Simpan Transfer',
      search: 'Cari',
      importTitle: 'Import Transfer Stok',
      import: {
        uploadTab: 'Upload',
        historyTab: 'Riwayat Import',
        step1Title: '1. Download Template',
        step1Desc: 'Unduh template file excel untuk mengisi data transfer stock yang akan diimpor.',
        downloadButton: 'Download Template',
        downloadFile: 'Download File',
        step2Title: '2. Upload File',
        step2Desc: 'Upload file excel yang sudah diisi sesuai template. Format yang didukung: .xlsx, .xls',
        uploadPlaceholder: 'Klik atau drag file ke area ini untuk upload',
        uploadHint: 'Hanya mendukung upload satu file sekaligus.',
        processing: 'Memproses...',
        startImport: 'Mulai Import',
        successTitle: 'Import Berhasil',
        failedTitle: 'Import Gagal',
        totalRows: 'Total Baris',
        successCount: 'Berhasil',
        failedCount: 'Gagal',
        downloadProcessFile: 'Download Process File',
        errorDetail: 'Detail Error',
        lines: 'baris',
        transferNumber: 'Nomor Transfer',
        noTransfer: 'No. Transfer',
        row: 'Baris',
        errorMessage: 'Pesan Error',
        allDataSuccess: 'Semua data berhasil diimport.',
        noDetail: 'Tidak ada detail untuk ditampilkan.',
        notifications: {
          downloadTemplateError: 'Gagal Download Template',
          downloadTemplateDesc: 'Terjadi kesalahan saat mengunduh template.',
          uploadSuccess: 'Upload berhasil, memproses data...',
          uploadError: 'Upload Gagal',
          uploadErrorData: 'Terdapat kesalahan pada data file import. Silakan cek detail error.',
          uploadErrorFile: 'Terjadi kesalahan saat upload file.',
          importFailed: 'Proses Import Gagal',
          importFailedDesc: 'Silahkan cek detail error.',
          importSuccess: 'Proses Import Selesai',
          downloadFileError: 'Gagal Download File',
          downloadFileDesc: 'Terjadi kesalahan saat mengunduh file.',
          loadDetailError: 'Gagal Memuat Detail',
          loadDetailDesc: 'Terjadi kesalahan.',
        },
        columns: {
          items: 'Items',
          totalRows: 'Total Baris',
          success: 'Berhasil',
          failed: 'Gagal',
          status: 'Status',
          action: 'Aksi',
          row: 'Baris',
          noTransfer: 'No. Transfer',
          sku: 'SKU',
          errorMessage: 'Pesan Error',
        },
      },
    },
    print: {
      title: 'Surat Jalan',
      paperSize: 'Ukuran Kertas',
      print: 'Cetak',
      close: 'Tutup',
      sender: 'Pengirim',
      receiver: 'Penerima',
      admin: 'Admin',
      driver: 'Sopir',
      vehicleNumber: 'Nomor Mobil',
      driverName: 'Nama Sopir',
    },
  },
  utils: {
    refresh: 'Segarkan',
    copy: 'Salin',
    try_again: 'Coba Lagi',
    loading: 'Memuat data...',
    back: 'Kembali',
    select: 'Pilih',
    choose: 'Pilih',
    accept: 'Setuju',
    reject: 'Tolak',
    not_set: 'Belum diatur',
    filter: 'Filter',
    cancel: 'Batal',
    bulk_actions: 'Aksi Masif',
    save: 'Simpan',
    edit: 'Ubah',
    add: 'Tambah',
    price: 'Harga',
    add_product: 'Tambah Produk',
    apply: 'Terapkan',
    variable: 'Variabel',
    search: 'Cari',
    search_placeholder: 'No Order / SKU / Kurir',
    insert: 'Masukkan',
    use: 'Gunakan',
    step: 'Langkah {step}',
    downloadTemplate: 'Download Template',
    successData: 'Data Berhasil',
    failedData: 'Data Gagal',
    totalData: 'Total Data',
    items_per_page: 'Items per halaman',
    close: 'Tutup',
    show: 'Lihat',
    hide: 'Sembunyikan',
    success_save: 'Data Berhasil Disimpan',
    failed_save: 'Data Gagal Disimpan, Coba Lagi.',
    error_occurred: 'Terjadi kesalahan',
    all: 'Semua',
    categories: 'Categories',
    channel: 'Saluran',
    date: 'Tanggal',
    quantity: 'Kuantitas',
    sku: 'SKU',
    example: 'Contoh',
    name: 'Nama',
    price: 'Harga',
    currency: 'Mata Uang',
    wrong: 'Ada yang salah',
    used: 'sudah digunakan',
    yes: 'Ya',
    no: 'Tidak',
    confirm_delete: 'Apakah Anda yakin ingin menghapus',
    change: 'Ubah',
    choose_a_tag: 'Pilih tag',
    choose_a_channel: 'Pilih channel',
    choose_a_warehouse: 'Pilih gudang',
    choose_a_service: 'Pilih prioritas',
    schedule: 'Jadwal',
    clearFilter: 'Bersihkan Filter',
    reload: 'Muat Ulang',
    export: 'Ekspor',
    status: 'Status',
    hour: 'Jam',
    not_found: 'Tidak ditemukan',
    amount: 'Jumlah',
    quantity: 'Jumlah',
    uom: 'UOM',
    failed: 'Gagal',
    success: 'Berhasil',
    delete: 'Hapus',
    deleted: 'Terhapus',
    close: 'Tutup',
    formula: 'Formula',
    pagination_show_total: 'Menampilkan {perpage} dari {total} item',
    pagination_show_range: 'Menampilkan {start} - {end} dari {total} item',
    items_per_page: '/ halaman',
    order_date: 'Tanggal Order',
    no_data: 'Tidak ada data',
    view_detail: 'Lihat Detail',
    close_detail: 'Tutup Detail',
    view_history: 'Lihat Riwayat',
    close_history: 'Tutup Riwayat',
    times: 'Kali',
    days: 'Hari',
    day: 'Hari',
    week: 'Minggu',
    month: 'Bulan',
    isRequired: 'wajib diisi',
  },
  web_platform: {
    product: {
      list_title: 'Produk Web Commerce',
      deactivate_title: 'Non-aktifkan produk',
      deactivate_desc: 'Apakah anda yakin ingin menonaktifkan produk ini ?',
      view_detail: 'Lihat Detail',
      edit_product: 'Ubah Produk',
      create_product: 'Buat Produk',
      search_product: 'Cari Produk',
      change_status_title: 'Ubah Status Product',
      confirm_status_change_prefix: 'Apakah Anda yakin ingin',
      deactivate_action: 'menonaktifkan',
      activate_action: 'mengaktifkan',
      confirm_status_change_suffix: 'produk ini ?',
      cancel: 'Batalkan',
      yes: 'Ya',
      status_update_success: 'Status Produk Berhasil Diupdate',
      status_update_failed: 'Gagal Mengubah Status Product, Silahkan Coba Lagi.',
      update_failed: 'Gagal Diupdate, Coba Lagi!',
      sync_failed: 'Gagal Sync Product, Coba Lagi.',
      sync_success: 'Produk Berhasil Disinkronisasi',
      draft: {
        have_draft: 'Anda memiliki draf produk',
        draft_desc: 'Untuk buat produk baru Anda dapat melanjutkan dengan draf atau buat baru',
        continue_draft: 'Lanjutkan Draf',
        delete_draft: 'Hapus Draf dan Buat Baru',
        product_not_found: 'Produk tidak ditemukan',
        error_occurred: 'Terjadi kesalahan',
      },
      messages: {
        try_again_later: 'Coba lagi beberapa saat',
        sku_already_registered: 'Kode SKU {sku} telah terdaftar pada produk lain',
        product_save_failed: 'Oops, produk gagal disimpan!',
        changes_saved: 'Perubahan berhasil disimpan',
        draft_saved: 'Draft produk berhasil disimpan',
        images_saved: 'Gambar produk berhasil disimpan',
        images_save_failed: 'Oops, gambar produk gagal disimpan',
        catalog_save_failed: 'Oops, catalog produk gagal disimpan',
        shipping_save_failed: 'Oops, weight dan shipping produk gagal disimpan',
      },
    },
    reseller: {
      title: 'Reseller',
      search: 'Cari Reseller',
      confirm_register: 'Konfirmasi Pendaftaran',
      view_detail: 'Lihat Detail',
      total_items: 'Total {total} item',
      update_level: 'Perbarui Level Model',
      seller_confirmation: 'Konfirmasi Pendaftaran Penjual',
      seller_confirmation: 'Konfirmasi Pendaftaran Penjual',
      detail: {
        user_data: 'DATA PENGGUNA',
        firstname: 'Nama Depan:',
        name: 'Nama:',
        email: 'Email:',
        phone: 'Telepon:',
        address_data: 'DATA ALAMAT',
        address_line_1: 'Alamat Baris 1',
        address_line_2: 'Alamat Baris 2',
        subdistrict: 'Kecamatan:',
        district: 'Kabupaten/Kota:',
        city: 'Kota:',
        province: 'Provinsi:',
        image_data: 'DATA GAMBAR',
      },
    },
  },
  promotion: {
    title: 'Promosi',
    promotion_name: 'Nama Promosi',
    promotion_list: 'Daftar Promosi',
    add_promotion: 'Tambah Promosi',
    edit_promotion: 'Ubah Promosi',
    add_item: 'Tambah Item',
    bulk_import: 'Bulk Item Import',
    import_items: 'Impor Item',
    wait_uploading: 'Sedang mengunggah file...',
    upload_excel_placeholder: 'Unggah file excel anda disini',
    download_template_hint: 'Jika belum memiliki template file import items, silahkan klik tombol download file di kiri bawah.',
    submit_all_items: 'Submit Semua Item',
    duplicate_sku_list: 'Daftar Duplikat SKU',
    revised_item_list: 'Daftar Revisi Item',
    close_without_download: 'Tutup tanpa Unduh',
    close_and_download_revised: 'Tutup dan Unduh Daftar Item yang Direvisi',
    error_sku_not_found: 'SKU tidak ditemukan',
    error_duplicate_sku: 'duplikat SKU',
    error_uom_invalid: 'UOM tidak valid',
    error_data_invalid: 'Data tidak valid',
    error_price_invalid: 'Harga tidak valid',
    sync_promotion: 'Sinkronisasi',
    syncing_promotion: 'Proses Sinkronisasi...',
    view_product: 'Lihat produk',
    promotion_date: 'Tanggal Promosi',
    end_date: 'Tanggal Akhir',
    sync_date: 'Tanggal Sinkronisasi',
    deactivate: 'Non-aktifkan',
    delete_promotion: 'Hapus Promosi',
    delete_confirm: 'Apakah Anda yakin ingin menghapus promosi: {name}?',
    delete_success: 'Berhasil menghapus promosi',
    sync_process_title: 'Sinkronisasi sedang berlangsung',
    sync_process_desc: 'Mohon tunggu, sedang sync promo: {name}',
    sync_success: 'Sinkronisasi berhasil',
    sync_failed: 'Gagal melakukan sinkronisasi',
    deactivate_title: 'Non-Aktifkan Promosi',
    deactivate_confirm_desc: 'Apakah Anda yakin ingin menonaktifkan promosi:',
    deactivate_wait_msg: 'Mohon tunggu, sedang non-aktifkan promo:',
    deactivate_success: 'Berhasil non-aktifkan promosi',
    deactivate_failed: 'Terjadi kesalahan, gagal non-aktifkan promo',
    deactivate_btn_confirm: 'Ya, Non-aktifkan',
    active: 'Aktif',
    inactive: 'Tidak Aktif',
    upcoming: 'Akan Datang',
    draft: 'Draft',
    expired: 'Telah Berakhir',
    ongoing: 'Berjalan',
    period: 'Periode',
    status: 'Status',
    action: 'Aksi',
    promotion_info: 'Informasi Promosi',
    promotion_code: 'Kode Promosi',
    placeholder_promotion_code: 'Masukan kode promosi',
    start_date: 'Tanggal Mulai',
    placeholder_start_date: 'Masukan tanggal mulai',
    placeholder_end_date: 'Masukan tanggal berakhir',
    product_info: 'Informasi Produk',
    batch_edit: 'Ubah Sekaligus',
    batch_edit_desc: 'Atur untuk mengubah semua <b>presentase diskon</b> dan <b>batas pembelian</b>',
    discount_nominal: 'Nominal Diskon',
    placeholder_discount_nominal: 'Masukan nominal diskon',
    discount_percentage: 'Persentase Diskon',
    placeholder_discount_percentage: 'Masukan persentase diskon',
    apply_all: 'Terapkan Semua',
    not_eligible_date: 'Produk tidak tersedia untuk tanggal yang dipilih.',
    no_stock: 'Produk ini tidak memiliki stok.',
    all_products_shown: 'Semua produk telah ditampilkan',
    loading_products: 'Sedang memuat produk...',
    unlimited: 'Tidak terbatas',
    confirm_edit: 'Konfirmasi Edit',
    confirmation: 'Konfirmasi',
    mandatory_date_range: 'Harap pilih tanggal mulai dan berakhir, sebelum menambahkan produk.',
    change_date_confirm: 'Apakah Anda yakin ingin mengubah tanggal {type}?',
    change_date_desc: 'Perubahan ini akan mempengaruhi eligible/tidaknya seluruh produk yang sudah anda tambahkan.',
    yes_change_date: 'Ya, ubah tanggal {type}',
    wait_fetching_detail: 'Mohon tunggu, sedang mengambil data promosi...',
    wait_updating: 'Mohon tunggu, sedang update promosi...',
    wait_creating: 'Mohon tunggu, sedang membuat promosi...',
    failed_fetch_detail: 'Gagal mendapatkan data terakhir promosi',
    failed_add_product_desc: 'Tambahkan produk terlebih dahulu, minimal 1 produk.',
    error_fill_discount: 'Mohon masukkan nilai diskon nominal atau diskon persentase.',
    promo_code_required: 'Kode promosi harus diisi',
    start_date_required: 'Waktu mulai harus diisi',
    start_date_after_now: 'Waktu mulai harus setelah waktu saat ini',
    start_date_after_prev: 'Waktu mulai yang baru harus setelah waktu mulai yang sebelumnya diatur. Waktu sebelumnya: {date}',
    end_date_required: 'Waktu berakhir harus diisi',
    end_date_after_start: 'Waktu berakhir harus setelah waktu mulai',
    end_date_min_1hour: 'Waktu berakhir harus minimal 1 jam setelah waktu mulai',
    end_date_before_prev: 'Waktu berakhir yang baru harus sebelum waktu berakhir yang sebelumnya diatur. Waktu sebelumnya: {date}',
    discount_exclusive: 'Hanya satu antara nominal atau persentase diskon yang dapat diisi',
    discount_too_high: 'Nominal diskon tidak boleh lebih besar dari harga termurah, harga termurah saat ini adalah: {price}',
    apply_discount_success: 'Berhasil menerapkan diskon',
    apply_discount_failed: 'Gagal menerapkan diskon, tipe diskon tidak ditemukan',
    discount_limit_error: 'Nominal diskon tidak boleh lebih besar dari harga asli, maksimal harga diskon saat ini adalah: {price}',
    import_success_all: 'Semua {count} Data Berhasil di Import',
    import_success_partial: 'Ada {fail} Data Gagal di Import, {success} Data Berhasil di Import',
    import_failed_all: 'Semua Data Gagal di Import',
    columns: {
      product_name: 'Nama Produk',
      original_price: 'Harga Asli',
      discount_price: 'Harga Diskon',
      discount: 'Diskon',
      promo_stock: 'Stok Promosi',
      purchase_limit: 'Batas Pembelian',
    },
    add_voucher: 'Tambah Voucher Baru',
    edit_voucher: 'Edit Voucher',
    search_result: 'Hasil Pencarian',
    voucher_code: 'Kode Voucher',
    select_date_range: 'Silakan pilih rentang tanggal',
    search: 'Cari',
    desc_percentage: 'Diskon {value}% untuk seluruh pesanan. Dengan minimum transaksi {min}. Maksimum diskon {max}.',
    desc_amount: 'Diskon {value} untuk seluruh pesanan. Dengan minimum transaksi {min}. Maksimum diskon {max}.',
    availability: 'Ketersediaan:',
    total: 'Total:',
    available: 'Tersedia:',
    used: 'Terpakai:',
    booked: 'Dipesan:',
    voucher_period: 'Periode Voucher',
    list_product_discount: 'Daftar Produk Diskon:',
    courier_discount: 'Kurir Diskon:',
    brand_discount: 'Merek Diskon:',
    type: {
      transaction: 'Voucher Transaksi',
      product: 'Voucher Produk',
      shipping: 'Voucher Pengiriman',
      brand: 'Voucher Merek',
    },
    product_count: '({count} produk)',
    delete_confirm: 'Apakah Anda ingin menghapus voucher ini? {value}',
    status_labels: {
      expired: 'kedaluwarsa',
      coming_soon: 'akan datang',
      running: 'berjalan',
    },
    detail: {
      voucher_code: 'Kode Voucher',
      voucher_type: 'Tipe Voucher',
      voucher_value: 'Nilai Voucher',
      min_transaction: 'Transaksi Minimum',
      max_discount: 'Diskon Maksimum',
      orders_using_voucher: 'Daftar pesanan menggunakan voucher',
      order_number: 'Nomor Pesanan',
      status: 'Status',
      date: 'Tanggal',
      order_status: {
        waiting_payment: 'Menunggu Pembayaran',
        new: 'Baru',
        on_process: 'Sedang Diproses',
        sent: 'Dikirim',
        delivered: 'Terkirim',
        completed: 'Selesai',
        canceled: 'Dibatalkan',
        cancel_request: 'Permintaan Pembatalan',
      },
    },
    error: {
      voucher_unused: 'Voucher belum pernah digunakan!',
    },
  },
  returChannel: {
    list_retur: 'List Retur',
    list_pengajuan_retur: 'List Pengajuan Retur',
    pilih_warehouse: 'Pilih Gudang',
    semua: 'Semua',
    selesai: 'Selesai',
    ditolak: 'Ditolak',
    menunggu_konfirmasi: 'Menunggu Konfirmasi',
    dalam_proses: 'Dalam Proses',
    dibatalkan: 'Dibatalkan',
    draft: 'Draft',
    no_pengajuan_retur: 'No. Pengajuan Retur',
    distributor: 'Distributor',
    tanggal_pengajuan: 'Tanggal Pengajuan',
    pelanggan: 'Pelanggan',
    status: 'Status',
    aksi: 'Aksi',
    detail_pengajuan_retur: 'Detail Pengajuan Retur',
    nama_pelanggan: 'Nama Pelanggan',
    total_nilai_retur: 'Total Nilai Retur',
    total_koin_retur: 'Total Koin Retur',
    tolak_pengajuan: 'Tolak Pengajuan',
    terima: 'Terima',
    proses: 'Proses',
    ya_tolak: 'Ya, Tolak',
    batalkan: 'Batalkan',
    alasan_penolakan: 'Alasan Penolakan',
    masukan_alasan: 'Masukan Alasan Penolakan',
    min_char_reason: 'Minimal 5 karakter de maksimal 75 karakter',
    ubah_status: 'Ubah Status Retur',
    confirm_finish: 'Apakah Anda yakin ingin menyelesaikan pengajuan retur ini?',
    confirm_reject_needed: 'Anda perlu melakukan tolak pengajuan jika tidak ada retur pada produk?',
    ya_terima: 'Ya, Terima',
    ya_selesaikan: 'Ya, Selesaikan',
    nama_produk: 'Nama Produk',
    harga_retur: 'Harga Retur',
    nilai_koin: 'Nilai Koin',
    total: 'Total',
    total_pengembalian: 'Total Pengembalian Dana',
    reason: 'Alasan',
    req_qty_desc: 'jumlah item yang di request',
    app_qty_desc: 'jumlah item yang di approve',
    damaged_product: 'Produk cacat atau rusak',
    expired_product: 'Produk mendekati expired',
    other_reason: 'Lain-lain',
  },
  creditNotes: {
    page_title: 'Credit Notes',
    create_button: 'Buat Credit Notes',
    form_title: 'Formulir Permintaan Credit Notes',
    modal_detail_title: 'Formulir Permintaan Credit Notes',
    update_status_title: 'Ubah Status Credit Notes',
    placeholder_warehouse: 'Pilih Gudang',
    tab_all: 'Semua',
    tab_requested: 'Pengajuan',
    tab_approved: 'Disetujui',
    tab_rejected: 'Ditolak',
    tab_canceled: 'Dibatalkan',
    column_cn_number: 'No. Credit Notes',
    column_distributor: 'Distributor',
    column_request_date: 'Tanggal Request',
    column_withdrawal: 'Penarikan',
    column_status: 'Status',
    label_distributor_name: 'Nama Distributor',
    label_date: 'Tanggal',
    label_withdrawal_amount: 'Input Penarikan Point',
    helper_amount: 'Anda akan mendapatkan sejumlah IDR ..........',
    note_term_condition: 'Syarat & Ketentuan :',
    note_1: '* Anda dapat melakukan claim Minimum .........point & maksimum ..............point',
    note_2: '* Credit Note dapat direquest maksimum ................. kali dalam .....................',
    note_3: '* Proses akan dilakukan maksimal 2x24 Jam',
    submit_button: 'Kirim',
    cancel_button: 'Batalkan',
    reject_button: 'Tolak',
    accept_button: 'Terima',
    finish_button: 'Ya, Selesaikan',
    confirm_finish_desc: 'Apakah Anda yakin ingin menyelesaikan pengajuan Credit Notes ini?',
    reject_title: 'Tolak Pengajuan',
    cancel_title: 'Batalkan Pengajuan',
    reject_reason: 'Alasan Penolakan',
    cancel_reason: 'Alasan Pembatalan',
    placeholder_reason: 'Masukan Alasan',
    yes_reject: 'Ya, Tolak',
    yes_cancel: 'Ya, Batalkan',
    detail_name: 'Nama',
    detail_coin_kino: 'Koin Kino',
    detail_coin_withdrawal: 'Koin Penarikan',
    detail_rupiah: 'Rupiah',
    total: 'Total',
  },
  invoice: {
    list_invoice: 'List Invoice',
    invoice_number: 'No. Invoice',
    order_date: 'Tanggal Pemesanan',
    total_bill: 'Total Tagihan',
    payment_status: 'Status Pembayaran',
    order_number: 'No. Order',
    customer_name: 'Nama Customer',
    payment_due_date: 'Batas Waktu Pembayaran',
    send: 'Kirim',
    export_excel: 'Export Excel',
    start_date: 'Tanggal Mulai',
    end_date: 'Tanggal Akhir',
    today: 'Hari ini',
    this_month: 'Bulan ini',
    this_year: 'Tahun ini',
    last_7_days: '7 Hari Terakhir',
    last_30_days: '30 Hari Terakhir',
    last_1_year: '1 Tahun Terakhir',
    paid: 'Lunas',
    canceled: 'Dibatalkan',
    unpaid: 'Belum Lunas',
    declined: 'Ditolak',
    expired: 'Kadaluarsa',
    error_title: 'Terjadi kesalahan',
    error_select_warehouse: 'Harap pilih gudang terlebih dahulu sebelum export data invoice.',
    error_empty_data: 'Data Kosong',
    error_filter_date: 'Tidak ada data berdasarkan filter tanggal tersebut.',
    error_load_data: 'Gagal saat memuat data.',
  },
  paymentHistory: {
    page_title: 'Riwayat Pembayaran',
    placeholder_seller: 'Pilih seller',
    alert_select_seller: 'Pilih seller terlebih dahulu',
    create_payment: 'Buat Pembayaran',
    column_payment_number: 'No. Pembayaran',
    column_total_payment: 'Total Bayar',
    column_payment_date: 'Tanggal Bayar',
    column_payment_method: 'Metode Pembayaran',
    column_payment_name: 'Nama Pembayaran',
    column_order_number: 'No. Order',
    column_invoice_number: 'No. Invoice',
    column_due_date: 'Tgl. Jatuh Tempo',
    column_outstanding: 'Outstanding',
    column_payment: 'Pembayaran',
    column_remaining_outstanding: 'Sisa Outstanding',
    column_status: 'Status',
    sort_oldest: 'Tanggal Terlama',
    sort_newest: 'Tanggal Terbaru',
    label_total_bill: 'Total Tagihan',
    label_total_order_paid: 'Total Order Terbayar',
    link_view: 'Lihat',
    placeholder_search_order: 'Cari No. Order',
    error_total_payment_empty: 'Total Bayar tidak boleh kosong',
    error_total_payment_match: 'Total Bayar harus sama dengan Total Tagihan',
    success_payment_created: 'Pembayaran Berhasil dibuat',
    error_payment_created: 'Pembayaran Gagal dibuat',
    warning_already_paid: 'Tagihan untuk nomor order {orderNumber} tersebut sudah terbayar',
    error_order_canceled: 'untuk Order number {orderNumber} tidak dapat diproses karena sudah berstatus Batal',
    copied_success: 'Berhasil menyalin {type}: {value}',
    error_load_distributor: 'Gagal memuat data distributor seller',
    error_load_seller: 'Gagal mendapatkan seller data',
    error_seller_not_found: 'Seller data tidak ditemukan',
    error_export_data: 'Gagal Export Data',
    export_filename: 'Riwayat Pembayaran',
    export_payment_id: 'ID Pembayaran',
    export_total_paid: 'Total yang Sudah Dibayar',
    export_account_number: 'Nomor Akun',
    export_order_id: 'ID Order',
    export_order_date: 'Tanggal Order',
  },
}

export const localeAntd = antd
export default messages
